
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iaX98", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PrioritySchemesPage", () => $bd74ff8ef7d71476$export$512f88a1345d2313);
$parcel$export(module.exports, "default", () => $bd74ff8ef7d71476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0wITm = parcelRequire("0wITm");

var $fXhkz = parcelRequire("fXhkz");

var $bmukb = parcelRequire("bmukb");

var $hJhcf = parcelRequire("hJhcf");

var $kUDQx = parcelRequire("kUDQx");
const $bd74ff8ef7d71476$export$512f88a1345d2313 = ()=>{
    const { filters: filters, setSchemeName: setSchemeName, setPriorityIdsFilter: setPriorityIdsFilter } = (0, $fXhkz.useFilters)();
    const prioritySchemesServiceResults = (0, $hJhcf.usePrioritySchemesService)();
    const prioritySchemesPageViewProps = (0, $bmukb.usePrioritySchemesPageController)(prioritySchemesServiceResults);
    const { onDeleteSchemeSuccess: onDeleteSchemeSuccess } = prioritySchemesPageViewProps;
    const deletePrioritySchemeProps = (0, $0wITm.useDeletePrioritySchemeController)(onDeleteSchemeSuccess);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUDQx.PrioritySchemesPageView), {
        ...prioritySchemesPageViewProps,
        ...deletePrioritySchemeProps,
        filters: filters,
        setSelectedPriorityIds: setPriorityIdsFilter,
        setSchemeName: setSchemeName
    });
};
var $bd74ff8ef7d71476$export$2e2bcd8739ae039 = $bd74ff8ef7d71476$export$512f88a1345d2313;

});
parcelRegister("0wITm", function(module, exports) {

$parcel$export(module.exports, "useDeletePrioritySchemeController", () => $4fceba8f608128ac$export$280099cbf49aff2b);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5p8cx = parcelRequire("5p8cx");

var $7aEKW = parcelRequire("7aEKW");

var $5zxtT = parcelRequire("5zxtT");
const $4fceba8f608128ac$export$280099cbf49aff2b = (onDeleteSchemeSuccess)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [deleteModalProps, setDeleteModalProps] = (0, $eUqFw.useState)({
        isOpen: false
    });
    const showDeleteSchemeSuccessFlag = (schemeId, schemeName)=>{
        const flagConfig = {
            type: 'success',
            id: `priority-scheme-delete-success-flag-${schemeId}`,
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.delete-scheme-flag',
            title: [
                (0, $5zxtT.messages).deleteSchemeFlagTitle,
                {
                    schemeName: schemeName
                }
            ],
            isAutoDismiss: true
        };
        showFlag(flagConfig);
    };
    const showUnexpectedErrorFlag = ()=>{
        const flagConfig = {
            type: 'error',
            id: 'priority-scheme-unexpected-error-flag',
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.unexpected-error-flag',
            title: (0, $5zxtT.messages).deleteUnexpectedErrorFlagTitle,
            description: (0, $5zxtT.messages).deleteUnexpectedErrorFlagDescription,
            isAutoDismiss: true
        };
        showFlag(flagConfig);
    };
    const setDeleteModalOpen = (priorityScheme)=>{
        setDeleteModalProps({
            isOpen: true,
            isSubmitting: false,
            schemeId: priorityScheme.id,
            schemeName: priorityScheme.name,
            associatedProjectCount: priorityScheme.projects.total
        });
    };
    const onCompleteDeleteScheme = ()=>setDeleteModalProps({
            isOpen: false
        });
    const onSubmitDeleteScheme = async ()=>{
        try {
            if (!deleteModalProps.isOpen) {
                showUnexpectedErrorFlag();
                onCompleteDeleteScheme();
                return;
            }
            setDeleteModalProps({
                ...deleteModalProps,
                isSubmitting: true
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $5p8cx.deletePrioritySchemeTrackEvent).actionSubject} ${(0, $5p8cx.deletePrioritySchemeTrackEvent).action}`, (0, $5p8cx.deletePrioritySchemeTrackEvent).actionSubjectId, {
                prioritySchemeId: deleteModalProps.schemeId,
                prioritySchemeProjectsCount: deleteModalProps.associatedProjectCount
            });
            const response = await (0, $7aEKW.deletePrioritySchemeRequest)(deleteModalProps.schemeId);
            if (!response.isSuccess) showUnexpectedErrorFlag();
            else {
                onDeleteSchemeSuccess();
                showDeleteSchemeSuccessFlag(deleteModalProps.schemeId, deleteModalProps.schemeName);
            }
        } catch (e) {
            showUnexpectedErrorFlag();
        }
        onCompleteDeleteScheme();
    };
    return {
        deleteModalProps: deleteModalProps,
        setDeleteModalOpen: setDeleteModalOpen,
        onSubmitDeleteScheme: onSubmitDeleteScheme,
        onCompleteDeleteScheme: onCompleteDeleteScheme
    };
};

});
parcelRegister("5p8cx", function(module, exports) {

$parcel$export(module.exports, "ADD_PRIORITY_SCHEME_MODAL_SOURCE_NAME", () => $cfc7eda35f2eab18$export$bd6924f1a9b620c5);
$parcel$export(module.exports, "EDIT_PRIORITY_SCHEME_MODAL_SOURCE_NAME", () => $cfc7eda35f2eab18$export$fde82e444f6a8e94);
$parcel$export(module.exports, "PRIORITY_SCHEME_CONFIGURATION_SOURCE_NAME", () => $cfc7eda35f2eab18$export$e061d01af4b2bd09);
$parcel$export(module.exports, "addPrioritySchemeButtonUIEvent", () => $cfc7eda35f2eab18$export$d898c019f9d126c4);
$parcel$export(module.exports, "addPrioritySchemeTrackEvent", () => $cfc7eda35f2eab18$export$5fc56a71c7baa5a);
$parcel$export(module.exports, "actionsDropdownMenuUIEvent", () => $cfc7eda35f2eab18$export$65e9f1fcb8a8a699);
$parcel$export(module.exports, "editPrioritySchemeDropdownItemUIEvent", () => $cfc7eda35f2eab18$export$d05f99f476544fcd);
$parcel$export(module.exports, "editPrioritySchemeTrackEvent", () => $cfc7eda35f2eab18$export$84695b859a4df3b3);
$parcel$export(module.exports, "deletePrioritySchemeDropdownItemUIEvent", () => $cfc7eda35f2eab18$export$134478eee52d7e95);
$parcel$export(module.exports, "deletePrioritySchemeTrackEvent", () => $cfc7eda35f2eab18$export$e5d69b9605546eea);
$parcel$export(module.exports, "inProductHelpButtonForPrioritySchemesUIEvent", () => $cfc7eda35f2eab18$export$5a29f738a06f9b55);
$parcel$export(module.exports, "ADD_PRIORITY_SCHEME_BUTTON_SELECTOR", () => $cfc7eda35f2eab18$export$5da277692deadd50);
$parcel$export(module.exports, "ADD_PRIORITY_SCHEME_BUTTON_LIMIT_EXCEEDED_TOOLTIP_SELECTOR", () => $cfc7eda35f2eab18$export$45fd9d4b7245b785);
$parcel$export(module.exports, "DELETE_MODAL_SELECTOR", () => $cfc7eda35f2eab18$export$60e2d4078dd0f171);
$parcel$export(module.exports, "DELETE_MODAL_SPINNER_SELECTOR", () => $cfc7eda35f2eab18$export$61f1c7c3175aec5b);
$parcel$export(module.exports, "DELETE_MODAL_SUBMIT_BUTTON_SELECTOR", () => $cfc7eda35f2eab18$export$97ef94234daa555a);
$parcel$export(module.exports, "INVALID_DELETE_MODAL_SELECTOR", () => $cfc7eda35f2eab18$export$9382231064a329ef);
$parcel$export(module.exports, "INVALID_DELETE_MODAL_CONFIRM_BUTTON_SELECTOR", () => $cfc7eda35f2eab18$export$59a067b5ff924f19);
$parcel$export(module.exports, "LEARN_MORE_LINK_SELECTOR", () => $cfc7eda35f2eab18$export$982a69931e292118);
$parcel$export(module.exports, "PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR", () => $cfc7eda35f2eab18$export$36d907ecd661d2ee);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL", () => $cfc7eda35f2eab18$export$868ad48448218bfb);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_DESC_FIELD_VALIDATION_ERROR_SELECTOR", () => $cfc7eda35f2eab18$export$f7b9bd0d7df5e669);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_NAME_AND_DESCRIPTION_FIELDS_SELECTOR", () => $cfc7eda35f2eab18$export$585dad235bcf7cf8);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_NAME_FIELD_VALIDATION_ERROR_SELECTOR", () => $cfc7eda35f2eab18$export$cf6f3c06c1a4007d);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_PRIORITIES_FIELD_VALIDATION_ERROR_SELECTOR", () => $cfc7eda35f2eab18$export$6fd75b1d58625aa7);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR", () => $cfc7eda35f2eab18$export$9e0ef252217f1db1);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR", () => $cfc7eda35f2eab18$export$c2e1ccc1213512be);
$parcel$export(module.exports, "LOCKED_CELL_TOOLTIP_SELECTOR", () => $cfc7eda35f2eab18$export$5d771275749a41c);
const $cfc7eda35f2eab18$export$bd6924f1a9b620c5 = 'addPrioritySchemeModal';
const $cfc7eda35f2eab18$export$fde82e444f6a8e94 = 'editPrioritySchemeModal';
const $cfc7eda35f2eab18$export$e061d01af4b2bd09 = 'prioritySchemeConfiguration';
const $cfc7eda35f2eab18$export$d898c019f9d126c4 = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'addPrioritySchemeButtonClicked'
};
const $cfc7eda35f2eab18$export$5fc56a71c7baa5a = {
    action: 'created',
    actionSubject: 'priorityScheme',
    actionSubjectId: 'addPriorityScheme'
};
const $cfc7eda35f2eab18$export$65e9f1fcb8a8a699 = {
    action: 'toggled',
    actionSubject: 'dropdownMenu',
    actionSubjectId: 'actionsDropdownMenuToggled'
};
const $cfc7eda35f2eab18$export$d05f99f476544fcd = {
    action: 'clicked',
    actionSubject: 'dropdownItem',
    actionSubjectId: 'editPrioritySchemeDropdownItemClicked'
};
const $cfc7eda35f2eab18$export$84695b859a4df3b3 = {
    action: 'updated',
    actionSubject: 'priorityScheme',
    actionSubjectId: 'editPriorityScheme'
};
const $cfc7eda35f2eab18$export$134478eee52d7e95 = {
    action: 'clicked',
    actionSubject: 'dropdownItem',
    actionSubjectId: 'deletePrioritySchemeDropdownItemClicked'
};
const $cfc7eda35f2eab18$export$e5d69b9605546eea = {
    action: 'deleted',
    actionSubject: 'priorityScheme',
    actionSubjectId: 'deletePriorityScheme'
};
const $cfc7eda35f2eab18$export$5a29f738a06f9b55 = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'helpPrioritySchemeClicked'
};
const $cfc7eda35f2eab18$export$5da277692deadd50 = 'admin-pages-priority-schemes.ui.priority-schemes-header.add-priority-scheme';
const $cfc7eda35f2eab18$export$45fd9d4b7245b785 = 'admin-pages-priority-schemes.ui.priority-schemes-header.tooltip';
const $cfc7eda35f2eab18$export$60e2d4078dd0f171 = 'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.modal';
const $cfc7eda35f2eab18$export$61f1c7c3175aec5b = 'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.delete-modal';
const $cfc7eda35f2eab18$export$97ef94234daa555a = 'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.delete-modal-view.button';
const $cfc7eda35f2eab18$export$9382231064a329ef = 'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.invalid-delete-modal-view.modal';
const $cfc7eda35f2eab18$export$59a067b5ff924f19 = 'admin-pages-priority-schemes.ui.delete-priority-scheme-modal.invalid-delete-modal-view.button';
const $cfc7eda35f2eab18$export$982a69931e292118 = 'admin-pages-priority-schemes.ui.priority-schemes-header.header-description.p';
const $cfc7eda35f2eab18$export$dd53fc23e21e489f = 'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--pagination--right-navigator';
const $cfc7eda35f2eab18$export$ef60e78cbfcb317d = 'common-components-error-state.empty-state';
const $cfc7eda35f2eab18$export$e7549037f0f23cc8 = 'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu--trigger';
const $cfc7eda35f2eab18$export$36d907ecd661d2ee = 'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu';
const $cfc7eda35f2eab18$export$8794433d7c292977 = 'admin-pages-priority-schemes.common.ui.priority-picker.dropdown-menu--menu-wrapper--menu-group';
const $cfc7eda35f2eab18$export$868ad48448218bfb = 'admin-pages-priority-schemes.ui.priority-scheme-modal.modal-view.modal';
const $cfc7eda35f2eab18$export$f7b9bd0d7df5e669 = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.description-error-message';
const $cfc7eda35f2eab18$export$585dad235bcf7cf8 = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.text-field';
const $cfc7eda35f2eab18$export$cf6f3c06c1a4007d = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.name-and-description.name-error-message';
const $cfc7eda35f2eab18$export$6fd75b1d58625aa7 = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-error-message';
const $cfc7eda35f2eab18$export$5bf5ccb23c9608ee = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker--trigger';
const $cfc7eda35f2eab18$export$9e0ef252217f1db1 = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker';
const $cfc7eda35f2eab18$export$e05d4d812396b54c = 'admin-pages-priority-schemes.ui.priority-scheme-modal.priority-scheme-details.priorities.priorities-picker--menu-wrapper--menu-group';
const $cfc7eda35f2eab18$export$c2e1ccc1213512be = 'admin-pages-priority-schemes.ui.priority-scheme-modal.button';
const $cfc7eda35f2eab18$export$84c4b07776ad8835 = 'Filter by name';
const $cfc7eda35f2eab18$export$f63ee7799da8e56c = 'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--empty-view-container';
const $cfc7eda35f2eab18$export$b8266082053f82b6 = 'admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless--table';
const $cfc7eda35f2eab18$export$941e5230e9be3c06 = 'admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu--trigger';
const $cfc7eda35f2eab18$export$5d37c87cff0ce090 = 'admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu--menu-wrapper--menu-group';
const $cfc7eda35f2eab18$export$450083f357717ab1 = 'unlocked-cell-actions';
const $cfc7eda35f2eab18$export$4ac371d6253c53e9 = 'locked-cell-actions';
const $cfc7eda35f2eab18$export$d231d73922ae88a = 'unlocked-cell-name';
const $cfc7eda35f2eab18$export$66a7779a9faf6d2a = 'unlocked-cell-priorities';
const $cfc7eda35f2eab18$export$b270fc6f26dab0be = 'unlocked-cell-projects';
const $cfc7eda35f2eab18$export$5d771275749a41c = 'admin-pages-priority-schemes.common.ui.locked-cell.tooltip';

});

parcelRegister("7aEKW", function(module, exports) {

$parcel$export(module.exports, "deletePrioritySchemeRequest", () => $4bd7a0ae3839067c$export$f2b594f551b1809c);

var $9wVV1 = parcelRequire("9wVV1");
const $4bd7a0ae3839067c$export$473d3a5f757553cb = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('status' in obj) || typeof obj.status !== 'number') return undefined;
    if (!('body' in obj) || obj.body !== null) return undefined;
    return {
        status: obj.status,
        body: obj.body
    };
};
const $4bd7a0ae3839067c$export$f2b594f551b1809c = async (schemeId)=>{
    try {
        const URL = `/rest/api/2/priorityscheme/${schemeId}`;
        const response = await (0, $9wVV1.fetchWithStatus)(URL, {
            method: 'DELETE'
        });
        const responseData = $4bd7a0ae3839067c$export$473d3a5f757553cb(response);
        if (!responseData) return {
            isSuccess: false
        };
        return {
            isSuccess: true
        };
    } catch (error) {
        // for now all errors, including validation errors will be handled with a generic
        // failure flag.
        return {
            isSuccess: false
        };
    }
};

});
parcelRegister("9wVV1", function(module, exports) {

$parcel$export(module.exports, "fetchWithStatus", () => $69b7aa216e963ef8$export$c927bbada8f4a86f);
$parcel$export(module.exports, "refineValidationError", () => $69b7aa216e963ef8$export$af38b55ed945250c);
$parcel$export(module.exports, "refineFetchError", () => $69b7aa216e963ef8$export$4267fead92761695);
$parcel$export(module.exports, "refineEditPrioritySchemeResponse", () => $69b7aa216e963ef8$export$2cc3889534fea70f);
$parcel$export(module.exports, "refineCreatePrioritySchemeResponse", () => $69b7aa216e963ef8$export$e1944ef932ca18a0);
$parcel$export(module.exports, "refinePriorityOnServerPageResponse", () => $69b7aa216e963ef8$export$b139ea50edab690);

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");

var $jxATW = parcelRequire("jxATW");

var $162Uz = parcelRequire("162Uz");

var $bGfSx = parcelRequire("bGfSx");

var $iA6pe = parcelRequire("iA6pe");
const $69b7aa216e963ef8$export$c927bbada8f4a86f = async (url, options = {})=>{
    const response = await fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...(0, $fVqUX.default),
        ...options
    }));
    if (!response.ok) {
        const traceId = (0, $jxATW.getTraceId)(response);
        if (traceId !== undefined && traceId.length > 0) throw new (0, $7byHA.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
        else throw new (0, $7byHA.default)(response.status, undefined, undefined, response);
    }
    if (response.status === 204) return new Promise((resolve)=>{
        resolve({
            status: response.status,
            body: null
        });
    });
    const body = await response.json();
    return new Promise((resolve)=>{
        resolve({
            status: response.status,
            body: body
        });
    });
};
const $69b7aa216e963ef8$export$af38b55ed945250c = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('errors' in obj) || typeof obj.errors !== 'object' || !obj.errors) return undefined;
    const validationErrors = [];
    if ('name' in obj.errors && typeof obj.errors.name === 'string') validationErrors.push({
        field: (0, $162Uz.PRIORITY_SCHEME_NAME_FIELD),
        message: obj.errors.name
    });
    if ('description' in obj.errors && typeof obj.errors.description === 'string') validationErrors.push({
        field: (0, $162Uz.PRIORITY_SCHEME_DESCRIPTION_FIELD),
        message: obj.errors.description
    });
    return validationErrors;
};
const $69b7aa216e963ef8$export$4267fead92761695 = async (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('statusCode' in obj) || typeof obj.statusCode !== 'number') return undefined;
    if (!('originalResponse' in obj) || typeof obj.originalResponse !== 'object' || !obj.originalResponse || !('json' in obj.originalResponse) || typeof obj.originalResponse.json !== 'function') return undefined;
    const responseJson = await obj.originalResponse.json();
    return {
        statusCode: obj.statusCode,
        responseJson: responseJson
    };
};
const $69b7aa216e963ef8$export$2cc3889534fea70f = (schemeId, obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('status' in obj) || typeof obj.status !== 'number') return undefined;
    if (!('body' in obj) || typeof obj.body !== 'object') return undefined;
    // TODO: Update this to deal with updated edit scheme response
    if (obj.body === null) return {
        status: obj.status,
        body: {
            id: schemeId
        }
    };
    const asyncTask = (0, $bGfSx.refineAsyncTask)(obj.body);
    if (!asyncTask) return {
        status: obj.status,
        body: {
            id: schemeId
        }
    };
    return {
        status: obj.status,
        body: {
            id: schemeId,
            ...asyncTask
        }
    };
};
const $69b7aa216e963ef8$export$e1944ef932ca18a0 = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('status' in obj) || typeof obj.status !== 'number') return undefined;
    if (!('body' in obj) || typeof obj.body !== 'object') return undefined;
    if (!obj.body) return undefined;
    if (!('id' in obj.body) || typeof obj.body.id !== 'string') return undefined;
    const schemeId = obj.body.id;
    const asyncTask = (0, $bGfSx.refineAsyncTask)(obj.body);
    if (!asyncTask) return {
        status: obj.status,
        body: {
            id: schemeId
        }
    };
    return {
        status: obj.status,
        body: {
            id: schemeId,
            ...asyncTask
        }
    };
};
const $69b7aa216e963ef8$export$b139ea50edab690 = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('maxResults' in obj) || typeof obj.maxResults !== 'number') return undefined;
    if (!('startAt' in obj) || typeof obj.startAt !== 'number') return undefined;
    if (!('total' in obj) || typeof obj.total !== 'number') return undefined;
    if (!('isLast' in obj) || typeof obj.isLast !== 'boolean') return undefined;
    if (!('values' in obj) || !Array.isArray(obj.values)) return undefined;
    const refinedValues = obj.values.map((e)=>{
        const newMappingPriority = (0, $iA6pe.refinePriorityOnServer)(e);
        if (!newMappingPriority) throw new Error('Unexpected shape of Mapping Priority');
        return newMappingPriority;
    });
    return {
        maxResults: obj.maxResults,
        startAt: obj.startAt,
        total: obj.total,
        isLast: obj.isLast,
        values: refinedValues
    };
};

});
parcelRegister("162Uz", function(module, exports) {

$parcel$export(module.exports, "NAME_COLUMN_KEY", () => $196e8d7b18fa669d$export$98ec13b3fe8b7146);
$parcel$export(module.exports, "PRIORITIES_COLUMN_KEY", () => $196e8d7b18fa669d$export$ca32e0e4642442ee);
$parcel$export(module.exports, "PROJECTS_COLUMN_KEY", () => $196e8d7b18fa669d$export$2f9fadc754e2510a);
$parcel$export(module.exports, "ACTIONS_COLUMN_KEY", () => $196e8d7b18fa669d$export$bcfcce3a3992590c);
$parcel$export(module.exports, "TABLE_DEFAULT_PAGE", () => $196e8d7b18fa669d$export$153b530fed5b91a2);
$parcel$export(module.exports, "TABLE_ROWS_PER_PAGE_LIMIT", () => $196e8d7b18fa669d$export$3921c1a6bd2b85c7);
$parcel$export(module.exports, "PROJECT_PICKER_ROWS_PER_PAGE", () => $196e8d7b18fa669d$export$a30ab2b928510850);
$parcel$export(module.exports, "PROJECT_PICKER_PENDING_CHANGES_LIMIT", () => $196e8d7b18fa669d$export$e992bd3bea91f664);
$parcel$export(module.exports, "PRIORITY_SCHEME_NAME_FIELD", () => $196e8d7b18fa669d$export$104c594d0b3ffc7);
$parcel$export(module.exports, "PRIORITY_SCHEME_DESCRIPTION_FIELD", () => $196e8d7b18fa669d$export$e18bde4441497e58);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_DETAILS_TAB_INDEX", () => $196e8d7b18fa669d$export$1430ff16b2549b7d);
$parcel$export(module.exports, "PRIORITY_SCHEME_MODAL_PROJECTS_TAB_INDEX", () => $196e8d7b18fa669d$export$ebaac9faebcc71fc);
$parcel$export(module.exports, "SAVING", () => $196e8d7b18fa669d$export$7530d416f6cacb6d);
$parcel$export(module.exports, "FAILURE", () => $196e8d7b18fa669d$export$5b1e245d5eac107);
$parcel$export(module.exports, "DEFAULT", () => $196e8d7b18fa669d$export$e6952b12ade67489);
$parcel$export(module.exports, "MAX_DESCRIPTION_LENGTH", () => $196e8d7b18fa669d$export$614cf5493945cd86);
$parcel$export(module.exports, "MAX_NAME_LENGTH", () => $196e8d7b18fa669d$export$cd2b108cbcd37452);
$parcel$export(module.exports, "ORDER_PROJECTS_BY", () => $196e8d7b18fa669d$export$97f5fb43313aac8e);
$parcel$export(module.exports, "PRIORITY_SCHEMES_HARD_LIMIT", () => $196e8d7b18fa669d$export$481b3c99a7afdb70);
const $196e8d7b18fa669d$export$98ec13b3fe8b7146 = 'name';
const $196e8d7b18fa669d$export$ca32e0e4642442ee = 'priorities';
const $196e8d7b18fa669d$export$2f9fadc754e2510a = 'projects';
const $196e8d7b18fa669d$export$bcfcce3a3992590c = 'actions';
const $196e8d7b18fa669d$export$153b530fed5b91a2 = 1;
const $196e8d7b18fa669d$export$3921c1a6bd2b85c7 = 5;
const $196e8d7b18fa669d$export$a30ab2b928510850 = 10;
const $196e8d7b18fa669d$export$e992bd3bea91f664 = 100;
const $196e8d7b18fa669d$export$104c594d0b3ffc7 = 'name';
const $196e8d7b18fa669d$export$e18bde4441497e58 = 'description';
const $196e8d7b18fa669d$export$beea64b207c9e2d5 = 'prioritiesId';
const $196e8d7b18fa669d$export$d1f3a33348b09f5c = 'projectsId';
const $196e8d7b18fa669d$export$bdf4def0d144e3b0 = 'mappings';
const $196e8d7b18fa669d$export$1430ff16b2549b7d = 0;
const $196e8d7b18fa669d$export$ebaac9faebcc71fc = 1;
const $196e8d7b18fa669d$export$d788bc089976c004 = 'INIT';
const $196e8d7b18fa669d$export$7530d416f6cacb6d = 'SAVING';
const $196e8d7b18fa669d$export$5b1e245d5eac107 = 'FAILURE';
const $196e8d7b18fa669d$export$e6952b12ade67489 = 'DEFAULT';
const $196e8d7b18fa669d$export$614cf5493945cd86 = 4000;
const $196e8d7b18fa669d$export$cd2b108cbcd37452 = 255;
const $196e8d7b18fa669d$export$97f5fb43313aac8e = $196e8d7b18fa669d$export$98ec13b3fe8b7146;
const $196e8d7b18fa669d$export$481b3c99a7afdb70 = 300;

});

parcelRegister("bGfSx", function(module, exports) {

$parcel$export(module.exports, "refineAsyncTask", () => $e9536063e0f5b5c4$export$6f2647d519aaf717);
const $e9536063e0f5b5c4$export$6f2647d519aaf717 = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('task' in obj) || typeof obj.task !== 'object' || !obj.task) return undefined;
    if (!('id' in obj.task) || typeof obj.task.id !== 'string') return undefined;
    if (!('self' in obj.task) || typeof obj.task.self !== 'string') return undefined;
    return {
        task: {
            id: obj.task.id,
            self: obj.task.self
        }
    };
};

});

parcelRegister("iA6pe", function(module, exports) {

$parcel$export(module.exports, "calculateRowsOnPage", () => $c2920fd498048c23$export$aa43c464413ae93);
$parcel$export(module.exports, "refinePriorityOnServer", () => $c2920fd498048c23$export$1b6738e588ca96c0);
$parcel$export(module.exports, "parsePriorityOnServerToPriority", () => $c2920fd498048c23$export$27126a84e0a8b2f5);
const $c2920fd498048c23$export$aa43c464413ae93 = ({ rowsPerPage: rowsPerPage, selectedPage: selectedPage, totalRows: totalRows })=>{
    let startRow;
    let endRow;
    const isLastPage = totalRows < (selectedPage + 1) * rowsPerPage;
    if (selectedPage === 1) {
        startRow = selectedPage;
        endRow = totalRows <= rowsPerPage ? totalRows : rowsPerPage;
    } else {
        startRow = (selectedPage - 1) * rowsPerPage + 1;
        endRow = isLastPage ? totalRows : selectedPage * rowsPerPage;
    }
    return {
        startRow: startRow,
        endRow: endRow
    };
};
const $c2920fd498048c23$export$1b6738e588ca96c0 = (obj)=>{
    if (!obj || typeof obj !== 'object') return undefined;
    if (!('self' in obj) || typeof obj.self !== 'string') return undefined;
    if (!('statusColor' in obj) || typeof obj.statusColor !== 'string') return undefined;
    if (!('description' in obj) || typeof obj.description !== 'string') return undefined;
    if (!('iconUrl' in obj) || typeof obj.iconUrl !== 'string') return undefined;
    if (!('name' in obj) || typeof obj.name !== 'string') return undefined;
    if (!('id' in obj) || typeof obj.id !== 'string') return undefined;
    if (!('sequence' in obj) || typeof obj.sequence !== 'string') return undefined;
    let isDefault = false;
    if ('isDefault' in obj && typeof obj.isDefault === 'boolean') isDefault = obj.isDefault;
    return {
        self: obj.self,
        statusColor: obj.statusColor,
        description: obj.description,
        iconUrl: obj.iconUrl,
        name: obj.name,
        id: obj.id,
        sequence: obj.sequence,
        isDefault: isDefault
    };
};
const $c2920fd498048c23$export$27126a84e0a8b2f5 = (priorityOnServer)=>({
        ...priorityOnServer,
        sequence: Number(priorityOnServer.sequence)
    });

});



parcelRegister("5zxtT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $12664a8754e2918f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $12664a8754e2918f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteSchemeFlagTitle: {
        "id": "admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-scheme-flag-title",
        "defaultMessage": "The priority scheme \"{schemeName}\" is deleted"
    },
    deleteUnexpectedErrorFlagTitle: {
        "id": "admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-unexpected-error-flag-title",
        "defaultMessage": "We couldn\u2019t delete the priority scheme"
    },
    deleteUnexpectedErrorFlagDescription: {
        "id": "admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-unexpected-error-flag-description",
        "defaultMessage": "Refresh to try again."
    }
});

});


parcelRegister("fXhkz", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $8f8a21251fbf26d4$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $162Uz = parcelRequire("162Uz");
const $8f8a21251fbf26d4$var$parsePriorityIds = (rawPriorityIds)=>{
    try {
        return rawPriorityIds.split(',').map((id)=>id.trim()).filter((id)=>!!id);
    } catch (e) {
        return [];
    }
};
function $8f8a21251fbf26d4$var$buildFilters(rawPriorityIds, rawSchemeName) {
    return {
        priorityIds: $8f8a21251fbf26d4$var$parsePriorityIds(rawPriorityIds),
        schemeName: rawSchemeName || ''
    };
}
function $8f8a21251fbf26d4$export$bbe534f3c10e3d6e(keys) {
    const [{ location: location }, { replace: replace }] = (0, $lB25E.useRouter)();
    const [values, setValues] = (0, $eUqFw.useState)(()=>{
        const params = new URLSearchParams(location.search);
        const initialValues = {};
        keys.forEach((key)=>{
            const value = params.get(key);
            initialValues[key] = value ?? '';
        });
        return initialValues;
    });
    const setQueryParam = (0, $eUqFw.useCallback)((newValues)=>{
        setValues((prevValues)=>({
                ...prevValues,
                ...newValues
            }));
        const params = new URLSearchParams(location.search);
        Object.entries(newValues).forEach(([key, value])=>{
            if (value) params.set(key, value);
            else // If the value is an empty string or otherwise falsy,
            // remove the parameter from the URL.
            params.delete(key);
        });
        replace({
            ...location,
            search: params.toString()
        });
    }, [
        replace,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        const updatedValues = {};
        let shouldUpdateState = false;
        keys.forEach((key)=>{
            const value = params.get(key) ?? '';
            if (values[key] !== value) {
                updatedValues[key] = value;
                shouldUpdateState = true;
            }
        });
        if (shouldUpdateState) setValues((currentValues)=>({
                ...currentValues,
                ...updatedValues
            }));
    // ignoring values to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        keys
    ]);
    return [
        values,
        setQueryParam
    ];
}
const $8f8a21251fbf26d4$export$973ca22476b0e05f = ()=>{
    const [queryParams, setQueryParam] = $8f8a21251fbf26d4$export$bbe534f3c10e3d6e([
        'pageNumber',
        'priorityId',
        'schemeName'
    ]);
    const { priorityId: priorityId, schemeName: schemeName, pageNumber: pageNumber } = queryParams;
    const setSchemeNameWithReset = (0, $eUqFw.useCallback)((value)=>{
        setQueryParam({
            schemeName: value,
            pageNumber: (0, $162Uz.TABLE_DEFAULT_PAGE).toString()
        });
    }, [
        setQueryParam
    ]);
    const setPriorityIdsFilter = (0, $eUqFw.useCallback)((ids)=>{
        setQueryParam({
            priorityId: ids.join(',')
        });
    }, [
        setQueryParam
    ]);
    const filters = (0, $eUqFw.useMemo)(()=>$8f8a21251fbf26d4$var$buildFilters(priorityId || '', schemeName || ''), [
        priorityId,
        schemeName
    ]);
    const pageNumberInt = (0, $eUqFw.useMemo)(()=>{
        const result = parseInt(pageNumber, 10);
        return Number.isNaN(result) ? (0, $162Uz.TABLE_DEFAULT_PAGE) : result;
    }, [
        pageNumber
    ]);
    // we are using `useMemo` so that we don't provoke our consumers
    // to send unnecessary requests to the backend,
    const result = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setSchemeName: setSchemeNameWithReset,
            setPriorityIdsFilter: setPriorityIdsFilter,
            pageNumber: pageNumberInt,
            setPageNumber: (value)=>setQueryParam({
                    pageNumber: value.toString()
                })
        }), [
        filters,
        setSchemeNameWithReset,
        setPriorityIdsFilter,
        pageNumberInt,
        setQueryParam
    ]);
    return result;
};

});

parcelRegister("bmukb", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemesPageController", () => $c6f8e8448267166f$export$f2572f9ca6b70b94);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $lJQSK = parcelRequire("lJQSK");

var $fXhkz = parcelRequire("fXhkz");
const $c6f8e8448267166f$var$defaultPrioritySchemeModalPartialProps = {
    initialPriorityScheme: undefined,
    isOpen: false,
    startingTab: 0
};
const $c6f8e8448267166f$export$f2572f9ca6b70b94 = ({ data: data, onRefetch: onRefetch, state: state })=>{
    const { filters: filters, pageNumber: pageNumber, setPageNumber: setPageNumber } = (0, $fXhkz.useFilters)();
    const { prioritySchemes: prioritySchemes, prioritySchemesCount: prioritySchemesCount, taskInProgress: taskInProgress } = data;
    const currentPageNumber = pageNumber || (0, $162Uz.TABLE_DEFAULT_PAGE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [page, setPage] = (0, $eUqFw.useState)({
        currentPage: currentPageNumber,
        items: prioritySchemes,
        totalItems: prioritySchemesCount,
        pageSize: (0, $162Uz.TABLE_ROWS_PER_PAGE_LIMIT)
    });
    const [prioritySchemeModalPartialProps, setPrioritySchemeModalPartialProps] = (0, $eUqFw.useState)($c6f8e8448267166f$var$defaultPrioritySchemeModalPartialProps);
    (0, $eUqFw.useEffect)(()=>{
        onRefetch(currentPageNumber, filters);
    }, [
        onRefetch,
        filters,
        currentPageNumber
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setPage((prevState)=>({
                ...prevState,
                items: prioritySchemes,
                totalItems: prioritySchemesCount,
                ...prevState.currentPage !== currentPageNumber && {
                    currentPage: currentPageNumber
                }
            }));
    }, [
        currentPageNumber,
        prioritySchemes,
        prioritySchemesCount
    ]);
    const onPrioritySchemeModalComplete = (status)=>{
        if (status === (0, $lJQSK.ModalOnCompleteStatus).SUCCESS) {
            const { currentPage: currentPage } = page;
            onRefetch(currentPage, filters);
        }
        setPrioritySchemeModalPartialProps($c6f8e8448267166f$var$defaultPrioritySchemeModalPartialProps);
    };
    const onAddScheme = (_event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $5p8cx.addPrioritySchemeButtonUIEvent).actionSubjectId);
        setPrioritySchemeModalPartialProps((prevProps)=>({
                ...prevProps,
                isOpen: !prevProps.isOpen
            }));
    };
    const onEditScheme = ({ prioritySchemeId: prioritySchemeId, startingTab: startingTab })=>{
        const { items: items } = page;
        const initialPriorityScheme = items.find(({ id: id })=>id === prioritySchemeId);
        if (!initialPriorityScheme) return;
        const { description: description, priorities: priorities, projects: projects } = initialPriorityScheme;
        const editPrioritySchemeDropdownItemUIEventWithContext = {
            ...(0, $5p8cx.editPrioritySchemeDropdownItemUIEvent),
            containers: {
                priorityScheme: {
                    id: prioritySchemeId
                }
            }
        };
        const editPrioritySchemeDropdownItemUIEventAttributes = {
            prioritySchemeId: prioritySchemeId,
            priorities: priorities.map(({ id: id })=>id),
            prioritySchemePriorityCount: priorities.length,
            prioritySchemeHasDescription: Boolean(description),
            prioritySchemeProjects: projects.values.map(({ id: id })=>id),
            prioritySchemeProjectsCount: projects.total
        };
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent(editPrioritySchemeDropdownItemUIEventWithContext), (0, $5p8cx.editPrioritySchemeDropdownItemUIEvent).actionSubjectId, editPrioritySchemeDropdownItemUIEventAttributes);
        setPrioritySchemeModalPartialProps((prevProps)=>({
                initialPriorityScheme: initialPriorityScheme,
                isOpen: !prevProps.isOpen,
                startingTab: startingTab
            }));
    };
    const onFetch = (0, $eUqFw.useCallback)((currentPage)=>{
        onRefetch(currentPage, filters);
        setPage((prevState)=>({
                ...prevState,
                currentPage: currentPage
            }));
        setPageNumber(currentPage);
    }, [
        onRefetch,
        filters,
        setPageNumber
    ]);
    const onDeleteSchemeSuccess = ()=>{
        const { currentPage: currentPage } = page;
        onRefetch(currentPage, filters);
    };
    return {
        locked: taskInProgress,
        prioritySchemeModalPartialProps: prioritySchemeModalPartialProps,
        onComplete: onPrioritySchemeModalComplete,
        onAddScheme: onAddScheme,
        onDeleteSchemeSuccess: onDeleteSchemeSuccess,
        onEditScheme: onEditScheme,
        onFetch: onFetch,
        page: page,
        state: state
    };
};

});
parcelRegister("lJQSK", function(module, exports) {

$parcel$export(module.exports, "ModalOnCompleteStatus", () => $0c081af8b9bddd0d$export$bb22be6e6b21efbf);
$parcel$export(module.exports, "ProjectFilterChoice", () => $0c081af8b9bddd0d$export$1c6231c290883187);
$parcel$export(module.exports, "ProjectStyleForInput", () => $0c081af8b9bddd0d$export$2cde36063fea74d0);
$parcel$export(module.exports, "ProjectPickerState", () => $0c081af8b9bddd0d$export$3f76efc290d5e7d3);
$parcel$export(module.exports, "PrioritySchemesPageState", () => $0c081af8b9bddd0d$export$c569f1e5a98b39);
const $0c081af8b9bddd0d$export$bb22be6e6b21efbf = {
    DISMISSAL: 'DISMISSAL',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
};
const $0c081af8b9bddd0d$export$1c6231c290883187 = {
    /**
	 * Default filter choice for the Project Picker component
	 * Shows a list of projects available in the user's Jira instance
	 */ ALL_PROJECTS: 'All projects',
    /**
	 * Secondary filter choice for the Project Picker component
	 * Shows a list of projects which are already associated to the current priority scheme
	 */ ASSOCIATED_PROJECTS: 'Existing projects'
};
const $0c081af8b9bddd0d$export$2cde36063fea74d0 = {
    // "Company-Managed Projects"
    CMP: 'classic',
    // "Team-Managed Projects"
    TMP: 'next-gen'
};
const $0c081af8b9bddd0d$export$3f76efc290d5e7d3 = {
    /**
	 * On the first page load, before any requests begin, the state is "INITIAL"
	 */ INITITAL: 'INITIAL',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS'
};
const $0c081af8b9bddd0d$export$c569f1e5a98b39 = {
    /**
	 * On the first page load, before any requests begin, the state is "INITIAL"
	 */ INITITAL: 'INITIAL',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS'
};

});


parcelRegister("hJhcf", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemesService", () => $00f58632d3d60035$export$1ba1afa627441062);

var $eUqFw = parcelRequire("eUqFw");

var $2jdHI = parcelRequire("2jdHI");

var $lJQSK = parcelRequire("lJQSK");

var $fcCX7 = parcelRequire("fcCX7");
const $00f58632d3d60035$var$initPrioritySchemesServiceData = {
    prioritySchemes: [],
    prioritySchemesCount: 0,
    taskInProgress: false
};
const $00f58632d3d60035$export$1ba1afa627441062 = ()=>{
    const [data, setData] = (0, $eUqFw.useState)($00f58632d3d60035$var$initPrioritySchemesServiceData);
    const [state, setState] = (0, $eUqFw.useState)((0, $lJQSK.PrioritySchemesPageState).INITITAL);
    // we need a stateRef, so that we can avoid adding an extra dependency for onRefetch method
    const stateRef = (0, $eUqFw.useRef)(state);
    const originalRefetch = (0, $eUqFw.useCallback)(async (page, filters)=>{
        setState((0, $lJQSK.PrioritySchemesPageState).LOADING);
        stateRef.current = (0, $lJQSK.PrioritySchemesPageState).LOADING;
        try {
            const response = await (0, $fcCX7.fetchPrioritySchemes)(page, filters);
            setData(response);
            setState((0, $lJQSK.PrioritySchemesPageState).SUCCESS);
            stateRef.current = (0, $lJQSK.PrioritySchemesPageState).LOADING;
        } catch (error) {
            setData($00f58632d3d60035$var$initPrioritySchemesServiceData);
            setState((0, $lJQSK.PrioritySchemesPageState).ERROR);
            stateRef.current = (0, $lJQSK.PrioritySchemesPageState).LOADING;
        }
    }, []);
    const [debouncedRefetch] = (0, $2jdHI.default)(originalRefetch, 300);
    const onRefetch = (0, $eUqFw.useCallback)(async (page, filters)=>{
        if (stateRef.current === (0, $lJQSK.PrioritySchemesPageState).INITITAL) return originalRefetch(page, filters);
        return debouncedRefetch(page, filters);
    }, [
        debouncedRefetch,
        originalRefetch
    ]);
    return {
        data: data,
        onRefetch: onRefetch,
        state: state
    };
};

});
parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("fcCX7", function(module, exports) {

$parcel$export(module.exports, "emptyFilter", () => $dbf800b7019f1706$export$12a30f94aa5abbcb);
$parcel$export(module.exports, "fetchPrioritySchemes", () => $dbf800b7019f1706$export$baff1f4e6ebe2b75);

var $162Uz = parcelRequire("162Uz");

var $9wVV1 = parcelRequire("9wVV1");
const $dbf800b7019f1706$var$PRIORITY_SCHEMES_API = '/rest/api/2/priorityscheme';
const $dbf800b7019f1706$var$toPriority = (rawData)=>{
    if (!rawData || typeof rawData !== 'object' || !('id' in rawData) || typeof rawData.id !== 'string' || !('name' in rawData) || typeof rawData.name !== 'string' || !('isDefault' in rawData) || typeof rawData.isDefault !== 'boolean' || !('iconUrl' in rawData) || typeof rawData.iconUrl !== 'string' || !('sequence' in rawData) || !(typeof rawData.sequence === 'number' || typeof rawData.sequence === 'string')) throw new Error('Unexpected shape of Priority');
    const { id: id, name: name, isDefault: isDefault, iconUrl: iconUrl } = rawData;
    return {
        id: id,
        name: name,
        isDefault: isDefault,
        iconUrl: iconUrl,
        sequence: Number(rawData.sequence)
    };
};
const $dbf800b7019f1706$var$toProject = (rawData)=>{
    if (!rawData || typeof rawData !== 'object' || !('id' in rawData) || typeof rawData.id !== 'string' || !('name' in rawData) || typeof rawData.name !== 'string' || !('avatarUrls' in rawData) || typeof rawData.avatarUrls !== 'object' || !rawData.avatarUrls || !('48x48' in rawData.avatarUrls) || typeof rawData.avatarUrls['48x48'] !== 'string') throw new Error('Unexpected shape of Project');
    return {
        id: rawData.id,
        name: rawData.name,
        avatarUrl: rawData.avatarUrls['48x48']
    };
};
const $dbf800b7019f1706$var$toPriorityScheme = (rawData)=>{
    if (!rawData || typeof rawData !== 'object' || !('id' in rawData) || typeof rawData.id !== 'string' || !('name' in rawData) || typeof rawData.name !== 'string' || !('projects' in rawData) || typeof rawData.projects !== 'object' || !rawData.projects || !('total' in rawData.projects) || typeof rawData.projects.total !== 'number' || !('values' in rawData.projects) || !Array.isArray(rawData.projects.values) || !('priorities' in rawData) || typeof rawData.priorities !== 'object' || !rawData.priorities || !('values' in rawData.priorities) || !Array.isArray(rawData.priorities.values)) throw new Error('Unexpected shape of PriorityScheme');
    const { id: id, name: name, priorities: { values: rawPriorities }, projects: { total: total, values: rawProjects } } = rawData;
    // description is optional on the server, but we don't want to deal with undefined
    const description = 'description' in rawData && typeof rawData.description === 'string' ? rawData.description : '';
    return {
        id: id,
        name: name,
        description: description,
        isDefault: 'isDefault' in rawData ? !!rawData.isDefault : false,
        priorities: rawPriorities.map($dbf800b7019f1706$var$toPriority),
        projects: {
            total: total,
            values: rawProjects.map($dbf800b7019f1706$var$toProject)
        }
    };
};
const $dbf800b7019f1706$export$6e168ccc7b55e0a0 = (rawData)=>{
    if (!rawData || typeof rawData !== 'object' || !('total' in rawData) || typeof rawData.total !== 'number' || !('values' in rawData) || !Array.isArray(rawData.values)) throw new Error('Unexpected response from the server');
    const { total: total, values: values } = rawData;
    return {
        prioritySchemes: values.map($dbf800b7019f1706$var$toPriorityScheme),
        prioritySchemesCount: total,
        taskInProgress: 'task' in rawData
    };
};
const $dbf800b7019f1706$export$f462295156674085 = (filter)=>{
    const searchParams = new URLSearchParams();
    filter.priorityIds.forEach((priorityId)=>searchParams.append('priorityId', priorityId));
    if (filter.schemeName) searchParams.append('schemeName', filter.schemeName);
    return searchParams;
};
const $dbf800b7019f1706$export$12a30f94aa5abbcb = {
    priorityIds: [],
    schemeName: ''
};
function $dbf800b7019f1706$export$a2e4e2dcc7b1f22f(page, filters, onlyDefault = false) {
    const searchParams = $dbf800b7019f1706$export$f462295156674085(filters);
    searchParams.append('expand', 'priorities,projects,taskInProgress');
    searchParams.append('maxResults', String((0, $162Uz.TABLE_ROWS_PER_PAGE_LIMIT)));
    searchParams.append('onlyDefault', onlyDefault ? 'true' : 'false');
    const startAtParam = (page - 1) * (0, $162Uz.TABLE_ROWS_PER_PAGE_LIMIT);
    searchParams.append('startAt', String(startAtParam));
    return searchParams;
}
const $dbf800b7019f1706$export$baff1f4e6ebe2b75 = async (page, filters, onlyDefault = false)=>{
    const searchParams = $dbf800b7019f1706$export$a2e4e2dcc7b1f22f(page, filters, onlyDefault);
    const URL = `${$dbf800b7019f1706$var$PRIORITY_SCHEMES_API}?${searchParams}`;
    const { body: body, status: status } = await (0, $9wVV1.fetchWithStatus)(URL);
    if (status !== 200) throw new Error(`Unexpected response status: ${status} for ${$dbf800b7019f1706$var$PRIORITY_SCHEMES_API}`);
    return $dbf800b7019f1706$export$6e168ccc7b55e0a0(body);
};

});


parcelRegister("kUDQx", function(module, exports) {

$parcel$export(module.exports, "PrioritySchemesPageView", () => $eff8aefbdf90efce$export$d789742b816f331);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $3NCZx = parcelRequire("3NCZx");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $jfj6c = parcelRequire("jfj6c");

var $lJQSK = parcelRequire("lJQSK");

var $2JYIp = parcelRequire("2JYIp");

var $j9N85 = parcelRequire("j9N85");

var $h3n89 = parcelRequire("h3n89");

var $fAYMo = parcelRequire("fAYMo");

var $eVWKA = parcelRequire("eVWKA");

var $5xxMu = parcelRequire("5xxMu");
const $eff8aefbdf90efce$var$PrioritySchemesTableContent = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { locked: locked, state: state } = props;
    switch(state){
        case (0, $lJQSK.PrioritySchemesPageState).ERROR:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
                header: formatMessage((0, $h3n89.default).errorHeader),
                description: formatMessage((0, $h3n89.default).errorDescription)
            });
        case (0, $lJQSK.PrioritySchemesPageState).LOADING:
        case (0, $lJQSK.PrioritySchemesPageState).INITITAL:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5xxMu.PrioritySchemesTable), {
                isLoading: true,
                isLocked: false,
                ...props
            });
        case (0, $lJQSK.PrioritySchemesPageState).SUCCESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5xxMu.PrioritySchemesTable), {
                isLoading: false,
                isLocked: locked,
                ...props
            });
        default:
            return null;
    }
};
const $eff8aefbdf90efce$export$d789742b816f331 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { locked: locked, prioritySchemeModalPartialProps: prioritySchemeModalPartialProps, onComplete: onComplete, onAddScheme: onAddScheme, state: state, deleteModalProps: deleteModalProps, onSubmitDeleteScheme: onSubmitDeleteScheme, onCompleteDeleteScheme: onCompleteDeleteScheme, filters: filters, page: { totalItems: totalItems }, setSelectedPriorityIds: setSelectedPriorityIds, setSchemeName: setSchemeName } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $5p8cx.PRIORITY_SCHEME_CONFIGURATION_SOURCE_NAME),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $h3n89.default).title)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, prioritySchemeModalPartialProps.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAYMo.AddOrEditPrioritySchemeModal), {
        ...prioritySchemeModalPartialProps,
        onComplete: onComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, deleteModalProps.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2JYIp.DeletePrioritySchemeModalWrapper), {
        associatedProjectCount: deleteModalProps.associatedProjectCount,
        isSubmitting: deleteModalProps.isSubmitting,
        schemeName: deleteModalProps.schemeName,
        onComplete: onCompleteDeleteScheme,
        onSubmit: onSubmitDeleteScheme
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVWKA.PrioritySchemesHeader), {
        hasError: (0, $lJQSK.PrioritySchemesPageState).ERROR === state,
        isLoading: (0, $lJQSK.PrioritySchemesPageState).LOADING === state,
        isLocked: locked,
        limitSchemes: totalItems >= (0, $162Uz.PRIORITY_SCHEMES_HARD_LIMIT),
        onAddScheme: onAddScheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9N85.Filter), {
        filters: filters,
        setSelectedPriorityIds: setSelectedPriorityIds,
        setSchemeName: setSchemeName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eff8aefbdf90efce$var$PrioritySchemesTableContent, props)));
};

});
parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $4zP5Y = parcelRequire("4zP5Y");

var $80J5A = parcelRequire("80J5A");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($4zP5Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($80J5A)));
    const isAssetConsolidation = (0, $1ybV0.ff)('jfe-asset-consolidation-itsm-agni_po996');
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (isAssetConsolidation) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("4zP5Y", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("80J5A", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("jfj6c", function(module, exports) {

$parcel$export(module.exports, "Container", () => $cea4993373333554$export$42a852a2b6b56249);
$parcel$export(module.exports, "TableContainer", () => $cea4993373333554$export$f2c3aea42b2a048f);
$parcel$export(module.exports, "TableCell", () => $cea4993373333554$export$1e4baea7053fc0e3);
$parcel$export(module.exports, "CellItem", () => $cea4993373333554$export$6427c7c47459a7b6);
$parcel$export(module.exports, "PriorityIconContainer", () => $cea4993373333554$export$d82d4f026352a76e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cea4993373333554$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8vkk0",
            __cmplp.className
        ])
    });
});
const $cea4993373333554$export$f2c3aea42b2a048f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81mnf _1ht61txw _14zb1txw _8k75jp4b _1i7v1vlj _31ku1h6o _25gbu2gc",
            __cmplp.className
        ])
    });
});
const $cea4993373333554$export$1e4baea7053fc0e3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLocked: isLocked, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc _4t3i1osq _18s8zu5n _13bo1vlj _dpd31txw _xlob1h6o",
            __cmplp.isLocked ? "_4rtx13gf" : "_4rtxtlke",
            __cmplp.className
        ])
    });
});
const $cea4993373333554$export$6427c7c47459a7b6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp12x7 _11c81vlj",
            __cmplp.className
        ])
    });
});
const $cea4993373333554$export$d82d4f026352a76e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1ejb _c71l1ejb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2JYIp", function(module, exports) {

$parcel$export(module.exports, "DeletePrioritySchemeModalWrapper", () => $8f7d3e23be704b12$export$a21d0845583b9626);

var $eUqFw = parcelRequire("eUqFw");

var $7fjm2 = parcelRequire("7fjm2");

var $gi7Ef = parcelRequire("gi7Ef");
const $8f7d3e23be704b12$export$a21d0845583b9626 = ({ isSubmitting: isSubmitting, associatedProjectCount: associatedProjectCount, schemeName: schemeName, onComplete: onComplete, onSubmit: onSubmit })=>associatedProjectCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi7Ef.InvalidDeleteModalView), {
        schemeName: schemeName,
        onComplete: onComplete,
        associatedProjectCount: associatedProjectCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fjm2.DeleteModalView), {
        isSubmitting: isSubmitting,
        schemeName: schemeName,
        onComplete: onComplete,
        onSubmit: onSubmit
    });

});
parcelRegister("7fjm2", function(module, exports) {

$parcel$export(module.exports, "DeleteModalView", () => $f34e6f7d6fc86988$export$3b3ee271b7697324);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $6vf5m = parcelRequire("6vf5m");
const $f34e6f7d6fc86988$export$3b3ee271b7697324 = ({ isSubmitting: isSubmitting, schemeName: schemeName, onComplete: onComplete, onSubmit: onSubmit })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const modalTitle = formatMessage((0, $6vf5m.messages).deleteModalTitleWithNoAssociatedProject, {
        schemeName: schemeName
    });
    const modalDescription = formatMessage((0, $6vf5m.messages).deleteModalDescriptionWithNoAssociatedProject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: (0, $5p8cx.DELETE_MODAL_SELECTOR),
        onClose: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, modalDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onComplete,
        isDisabled: isSubmitting
    }, formatMessage((0, $6vf5m.messages).deleteModalCancelButtonTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: (0, $5p8cx.DELETE_MODAL_SUBMIT_BUTTON_SELECTOR),
        appearance: "warning",
        onClick: onSubmit,
        isDisabled: isSubmitting,
        autoFocus: true
    }, isSubmitting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: (0, $5p8cx.DELETE_MODAL_SPINNER_SELECTOR)
    }) : formatMessage((0, $6vf5m.messages).deleteModalDeleteButtonTitle))));
};

});
parcelRegister("6vf5m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eec7e56a12278845$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $eec7e56a12278845$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteModalTitle: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-title",
        "defaultMessage": "Delete priority scheme"
    },
    deleteModalTitleWithNoAssociatedProject: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-title-with-no-associated-project",
        "defaultMessage": "Delete scheme \"{schemeName}\""
    },
    deleteModalDescription: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-description",
        "defaultMessage": "There may be some projects associated with the scheme \u201C{schemeName}\u201D that have been moved to\n            trash or archived. These projects will be associated with the default priority scheme, and their issues will be assigned to the default priority."
    },
    deleteModalDescriptionWithNoAssociatedProject: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-description-with-no-associated-project",
        "defaultMessage": "This scheme has no associated projects and can be deleted."
    },
    deleteModalCancelButtonTitle: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-cancel-button-title",
        "defaultMessage": "Cancel"
    },
    deleteModalDeleteButtonTitle: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.delete-modal-view.delete-modal-delete-button-title",
        "defaultMessage": "Delete"
    }
});

});


parcelRegister("gi7Ef", function(module, exports) {

$parcel$export(module.exports, "InvalidDeleteModalView", () => $b1879ff4607b2177$export$52d057849c2bea9f);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $16sNA = parcelRequire("16sNA");
const $b1879ff4607b2177$export$52d057849c2bea9f = ({ schemeName: schemeName, onComplete: onComplete, associatedProjectCount: associatedProjectCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: (0, $5p8cx.INVALID_DELETE_MODAL_SELECTOR),
        onClose: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $16sNA.messages).invalidDeleteModalTitleNew))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $16sNA.messages).invalidDeleteModalNAssociatedProjectDescriptionNew, {
        schemeName: schemeName,
        associatedProjectCount: associatedProjectCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: (0, $5p8cx.INVALID_DELETE_MODAL_CONFIRM_BUTTON_SELECTOR),
        appearance: "primary",
        onClick: onComplete,
        autoFocus: true
    }, formatMessage((0, $16sNA.messages).invalidDeleteModalCompleteButtonNew))));
};

});
parcelRegister("16sNA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6b5dfedc8f55832e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6b5dfedc8f55832e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    invalidDeleteModalTitle: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-title",
        "defaultMessage": "The scheme is in use"
    },
    invalidDeleteModalTitleNew: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-title-new",
        "defaultMessage": "We couldn't delete the priority scheme"
    },
    invalidDeleteModalNAssociatedProjectDescriptionNew: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-n-associated-project-description-new",
        "defaultMessage": "{associatedProjectCount, plural, one {The scheme \"{schemeName}\" has {associatedProjectCount} associated project. Remove this project from the scheme to delete the scheme.} other {The scheme \"{schemeName}\" has {associatedProjectCount} associated projects. Remove these projects from the scheme to delete the scheme.}}"
    },
    invalidDeleteModalCompleteButtonNew: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-complete-button-new",
        "defaultMessage": "Ok"
    },
    invalidDeleteModalDescription: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-description.non-final",
        "defaultMessage": "To delete the priority scheme \"{schemeName}\", you need to first remove all projects from it first."
    },
    invalidDeleteModalCompleteButton: {
        "id": "admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-complete-button.non-final",
        "defaultMessage": "Ok got it"
    }
});

});



parcelRegister("j9N85", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $be8643b1f0ad317c$export$ec91da630f36d5ea);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2l1Ja = parcelRequire("2l1Ja");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dzCsg = parcelRequire("dzCsg");

var $cG32o = parcelRequire("cG32o");
const $be8643b1f0ad317c$export$ec91da630f36d5ea = ({ filters: filters, setSelectedPriorityIds: setSelectedPriorityIds, setSchemeName: setSchemeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be8643b1f0ad317c$var$filterWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be8643b1f0ad317c$var$inputWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2l1Ja.default), {
        value: filters.schemeName,
        onChange: setSchemeName,
        shouldFitContainerWidth: true,
        placeholder: formatMessage((0, $dzCsg.default).searchFieldPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cG32o.PriorityFilterPicker), {
        selectedPriorityIds: filters.priorityIds,
        setSelectedPriorityIds: setSelectedPriorityIds
    }));
};
const $be8643b1f0ad317c$var$filterWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.250',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $be8643b1f0ad317c$var$inputWrapperStyles = (0, $1ZAYh.xcss)({
    width: '220px',
    marginRight: 'space.100'
});

});
parcelRegister("2l1Ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdeca50a427435db$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $8Ui86 = parcelRequire("8Ui86");

var $8rQuz = parcelRequire("8rQuz");
const $bdeca50a427435db$export$4c4c11a6ab1f5b09 = 1000;
const $bdeca50a427435db$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((value, callback)=>callback(value), $bdeca50a427435db$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $bdeca50a427435db$var$Filter extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $8rQuz.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args);
        this.prevQueryValue = this.props.value;
        this.prevSearchValue = this.props.value;
        this.handleNewValue = (newValue)=>{
            $bdeca50a427435db$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        };
        this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $bdeca50a427435db$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $bdeca50a427435db$export$2e2bcd8739ae039 = $bdeca50a427435db$var$Filter;

});
parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $babBw = parcelRequire("babBw");

var $kq9HD = parcelRequire("kq9HD");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $babBw.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $8rQuz.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kq9HD.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $babBw.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("kq9HD", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $c70659cfee4e098d$export$84038b503874befa);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $c70659cfee4e098d$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c70659cfee4e098d$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7)))
    }));
const $c70659cfee4e098d$var$wrapperStylesCloseIcon = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $81537fc79b34b1c4$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8xkEh = parcelRequire("8xkEh");

var $aB51E = parcelRequire("aB51E");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aB51E))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStylesBefore,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $81537fc79b34b1c4$var$wrapperStylesBefore = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $81537fc79b34b1c4$var$spacingStylesBefore = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});



parcelRegister("dzCsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c918fd3f5bf52e01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c918fd3f5bf52e01$var$messages = (0, $90IgZ.defineMessages)({
    searchFieldPlaceholder: {
        "id": "admin-pages-priority-schemes.filter.search-field-placeholder",
        "defaultMessage": "Filter by name"
    }
});
var $c918fd3f5bf52e01$export$2e2bcd8739ae039 = $c918fd3f5bf52e01$var$messages;

});

parcelRegister("cG32o", function(module, exports) {

$parcel$export(module.exports, "PriorityFilterPicker", () => $de9fceb9215a8af0$export$199a37fd2e4bde6);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $irbrC = parcelRequire("irbrC");

var $5uT0G = parcelRequire("5uT0G");

var $h7n33 = parcelRequire("h7n33");
const $de9fceb9215a8af0$export$199a37fd2e4bde6 = ({ selectedPriorityIds: selectedPriorityIds, setSelectedPriorityIds: setSelectedPriorityIds })=>{
    const intl = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [pickerFilter, setPickerFilter] = (0, $eUqFw.useState)('');
    const [pageIndex, setPageIndex] = (0, $eUqFw.useState)(0);
    const { page: page, loading: loading } = (0, $5uT0G.usePriorities)(pickerFilter, pageIndex);
    const onFilterChange = (newFilter)=>{
        setPickerFilter(newFilter);
    };
    const onLoadMore = ()=>{
        const { currentPage: currentPage } = page;
        setPageIndex(currentPage + 1);
    };
    const onSelect = (priority)=>{
        const newPriorities = selectedPriorityIds.includes(priority.id) ? selectedPriorityIds.filter((id)=>id !== priority.id) : [
            ...selectedPriorityIds,
            priority.id
        ];
        setSelectedPriorityIds(newPriorities);
    };
    const onClearSelection = ()=>{
        setSelectedPriorityIds([]);
    };
    const onOpen = ()=>{
        setIsOpen(true);
        setPageIndex(0);
    };
    const onClose = ()=>{
        setIsOpen(false);
        setSelectedPriorityIds(selectedPriorityIds);
    };
    const trigger = selectedPriorityIds.length === 0 ? intl.formatMessage((0, $h7n33.messages).choosePriorities) : intl.formatMessage((0, $h7n33.messages).multipleSelectedPriorities, {
        count: selectedPriorityIds.length
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $irbrC.default), {
        showCheckboxes: true,
        selectedPriorityIds: selectedPriorityIds,
        filter: pickerFilter,
        renderTrigger: trigger,
        isLoading: loading,
        page: page,
        isOpen: isOpen,
        onSelect: onSelect,
        onClearSelection: onClearSelection,
        onFilterChange: onFilterChange,
        onClose: onClose,
        onLoadMore: onLoadMore,
        onOpen: onOpen,
        testId: (0, $5p8cx.PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR)
    });
};

});
parcelRegister("irbrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a57b94ae4a0c2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $9mc6u = parcelRequire("9mc6u");

var $dsroq = parcelRequire("dsroq");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iuEB4 = parcelRequire("iuEB4");
const $2a8a57b94ae4a0c2$var$Skeleton = ({ total: total, loaded: loaded, page: page })=>{
    // if we don't have a total number yet, we simply use the page size
    // once the total number is available, we use it to calculate the number of skeletons to show on the last page
    const count = total ? Math.min(total - loaded, page) : page;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Array.from({
        length: count
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$SkeletonRow, {
            key: index,
            height: 16,
            width: "100%",
            "data-ignore": "1"
        })));
};
const $2a8a57b94ae4a0c2$var$Filter = ({ onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$FilterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        onChange: (e)=>onChange(e.currentTarget.value),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: formatMessage((0, $iuEB4.default).searchFieldPlaceholder),
            size: "small"
        })),
        placeholder: formatMessage((0, $iuEB4.default).searchFieldPlaceholder),
        value: value
    }));
};
const $2a8a57b94ae4a0c2$var$Footer = ({ loaded: loaded, isLoading: isLoading, total: total, onLoadMore: onLoadMore, onClearSelection: onClearSelection })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isLoading && !total) // there is nothing useful to show in the footer while we are loading the first page
    return null;
    let leftButton = null;
    if (onLoadMore) leftButton = total > loaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "compact",
        onClick: onLoadMore,
        isDisabled: isLoading
    }, formatMessage((0, $iuEB4.default).loadMore)) : null;
    else if (onClearSelection) leftButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "compact",
        onClick: onClearSelection
    }, formatMessage((0, $iuEB4.default).clearSelection));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$FooterWrapper, null, leftButton || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $iuEB4.default).prioritiesCountInfo, {
        dispayedCount: loaded,
        totalCount: total
    })));
};
function $2a8a57b94ae4a0c2$export$2e2bcd8739ae039({ renderTrigger: renderTrigger, isOpen: isOpen, isLoading: isLoading, onClose: onClose, onOpen: onOpen, onSelect: onSelect, onClearSelection: onClearSelection, onFilterChange: onFilterChange, onLoadMore: onLoadMore, filter: filter, page: { items: items, pageSize: pageSize, totalItems: totalItems }, showCheckboxes: showCheckboxes, selectedPriorityIds: selectedPriorityIds, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); /*
                  * The DropdownItemCheckbox, as is today, does not allow both checkbox and elemBefore.
                  * That means we don't render priority icons next to the checkboxes unfortunately.
                  * We should explore if a custom component would do that.
                  */ 
    const Item = showCheckboxes ? (0, $9mc6u.default) : (0, $hD6GJ.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: testId,
        onOpenChange: isOpen ? onClose : onOpen,
        isOpen: isOpen,
        spacing: "compact",
        trigger: renderTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$DialogContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$Filter, {
        onChange: onFilterChange,
        value: filter
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$DropdownListWrapper, null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Item, {
            id: item.id,
            key: item.id,
            onClick: (e)=>{
                e.stopPropagation();
                onSelect(item);
            },
            isSelected: selectedPriorityIds?.includes(item.id),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "circle",
                label: item.name,
                size: "xsmall",
                src: item.iconUrl
            })
        }, item.name)), !isLoading && !items.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        isDisabled: true
    }, formatMessage(filter ? (0, $iuEB4.default).noMatchingPriorities : (0, $iuEB4.default).noPriorities)), showCheckboxes && !isLoading && totalItems > items.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onLoadMore
    }, formatMessage((0, $iuEB4.default).loadMore)) : null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$Skeleton, {
        total: totalItems,
        loaded: items.length,
        page: pageSize
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a8a57b94ae4a0c2$var$Footer, {
        isLoading: isLoading,
        total: totalItems,
        loaded: items.length,
        onLoadMore: showCheckboxes ? undefined : onLoadMore,
        onClearSelection: showCheckboxes ? onClearSelection : undefined
    })));
}
const $2a8a57b94ae4a0c2$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$DialogContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$DropdownListWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv _18m91wug _c71l1mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$FilterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41bs6",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3doh6cr _1e0c1txw _1bah1yb4 _4cvr1h6o _2lx2vrvc _1yt41bs6",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8a57b94ae4a0c2$var$SkeletonRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1f2r _1pglp3kn _18s81bs6 _bfhk1yrq _1itk1j98 _12vemgnk _4t3i2nrh _1bsb1hdq _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});



parcelRegister("iuEB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e2834012f828bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $46e2834012f828bd$var$messages = (0, $90IgZ.defineMessages)({
    addPrioritiesToggle: {
        "id": "admin-pages-priority-schemes.common.priority-picker.add-priorities-toggle",
        "defaultMessage": "Add priorities"
    },
    loadMore: {
        "id": "admin-pages-priority-schemes.common.priority-picker.load-more",
        "defaultMessage": "Load more"
    },
    clearSelection: {
        "id": "admin-pages-priority-schemes.common.priority-picker.clear-selection",
        "defaultMessage": "Clear selection"
    },
    noMatchingPriorities: {
        "id": "admin-pages-priority-schemes.common.priority-picker.no-matching-priorities",
        "defaultMessage": "No matching priorities"
    },
    noPriorities: {
        "id": "admin-pages-priority-schemes.common.priority-picker.no-priorities",
        "defaultMessage": "No available priorities"
    },
    prioritiesCountInfo: {
        "id": "admin-pages-priority-schemes.common.priority-picker.priorities-count-info",
        "defaultMessage": "{dispayedCount} of {totalCount, plural, one {# priority} other {# priorities}}"
    },
    searchFieldPlaceholder: {
        "id": "admin-pages-priority-schemes.common.priority-picker.search-field-placeholder",
        "defaultMessage": "Search priorities"
    }
});
var $46e2834012f828bd$export$2e2bcd8739ae039 = $46e2834012f828bd$var$messages;

});


parcelRegister("5uT0G", function(module, exports) {

$parcel$export(module.exports, "usePriorities", () => $972d784d2e2d1bf0$export$c71c4f77de6d3cd8);

var $eUqFw = parcelRequire("eUqFw");


var $df4RB = parcelRequire("df4RB");
const $972d784d2e2d1bf0$export$c71c4f77de6d3cd8 = (filter, pageIndex)=>{
    const [allPriorities, setAllPriorities] = (0, $eUqFw.useState)([]);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            try {
                const response = await fetch('/rest/api/3/priority');
                const data = await response.json();
                if (!Array.isArray(data)) throw new Error(`Expected array of priorities, instead got ${typeof data}`);
                setAllPriorities(data.map((0, $df4RB.toPriorityOption)));
            } catch (e) {
                setError(e);
            } finally{
                setLoading(false);
            }
        })();
    }, []);
    const currentPage = pageIndex + 1;
    const filteredPriorities = filter ? allPriorities.filter((p)=>p.name.toLowerCase().includes(filter.toLowerCase())) : allPriorities;
    const page = {
        items: filteredPriorities.slice(0, currentPage * (0, $e272fd5397becb39$export$950baf168f4d0418)),
        currentPage: currentPage,
        pageSize: (0, $e272fd5397becb39$export$950baf168f4d0418),
        totalItems: filteredPriorities.length
    };
    return {
        page: page,
        loading: loading,
        error: error
    };
};

});
// TODO: Confirm this with design
const $e272fd5397becb39$export$950baf168f4d0418 = 10;

parcelRegister("df4RB", function(module, exports) {

$parcel$export(module.exports, "toPriorityOption", () => $b653f00203296db3$export$248f627d17d24817);
$parcel$export(module.exports, "fetchAvailablePriorities", () => $b653f00203296db3$export$d8e06013d35b601c);
$parcel$export(module.exports, "fetchPrioritiesByScheme", () => $b653f00203296db3$export$b2ee525b42c4cf66);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $9wVV1 = parcelRequire("9wVV1");
const $b653f00203296db3$export$c393c1299f11dfd5 = '/rest/api/3/priority';
const $b653f00203296db3$export$248f627d17d24817 = (p, sequence)=>{
    if (!p || typeof p !== 'object' || !('id' in p) || typeof p.id !== 'string' || !('name' in p) || typeof p.name !== 'string' || !('iconUrl' in p) || typeof p.iconUrl !== 'string') throw new Error('Unexpected priority object');
    return {
        id: p.id,
        name: p.name,
        iconUrl: p.iconUrl,
        sequence: sequence
    };
};
const $b653f00203296db3$export$d8e06013d35b601c = async (query, page, pageSize, exclude, selectedPriorities = [])=>{
    const response = await (0, $2OdyW.default)($b653f00203296db3$export$c393c1299f11dfd5);
    if (!response || !Array.isArray(response)) throw new Error('Unexpected response from /rest/api/3/priority');
    const allPriorities = response.map($b653f00203296db3$export$248f627d17d24817);
    const excludedPriorityIds = {};
    exclude.forEach((id)=>{
        excludedPriorityIds[id] = true;
    });
    const matchingPriorities = allPriorities.filter((p)=>!excludedPriorityIds[p.id] && p.name.toLowerCase().includes(query.toLowerCase()));
    return {
        items: matchingPriorities.slice(page * pageSize - selectedPriorities.length, (page + 1) * pageSize),
        currentPage: page,
        pageSize: pageSize,
        totalItems: matchingPriorities.length
    };
};
const $b653f00203296db3$export$b2ee525b42c4cf66 = async (schemeId, startAt, maxResults)=>{
    try {
        const URL = `/rest/api/2/priorityscheme/${schemeId}/priorities?startAt=${startAt}&maxResults=${maxResults}`;
        const response = await (0, $2OdyW.default)(URL);
        const responseBody = (0, $9wVV1.refinePriorityOnServerPageResponse)(response);
        if (!responseBody) throw new Error('Invalid response');
        return responseBody;
    } catch (error) {
        // We don't care if the error is a 400 or 403 we will deal with them in
        // in the same way i imagine.
        const fetchError = await (0, $9wVV1.refineFetchError)(error);
        (0, $guiFP.default)({
            error: fetchError ? new Error(`get priority by scheme failed with status code ${fetchError.statusCode} and response body ${fetchError.responseJson}`) : new Error('get priority by scheme failed with unexpected error'),
            meta: {
                id: 'getPriorityByScheme',
                packageName: 'jiraAdminPagesPrioritySchemes',
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("h7n33", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a0200551bf607db$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1a0200551bf607db$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    choosePriorities: {
        "id": "admin-pages-priority-schemes.filter.priority-filter-picker.choose-priorities",
        "defaultMessage": "All priorities"
    },
    multipleSelectedPriorities: {
        "id": "admin-pages-priority-schemes.filter.priority-filter-picker.multiple-selected-priorities",
        "defaultMessage": "{count, plural, one {# priority selected} other {# priorities selected}}"
    }
});

});



parcelRegister("h3n89", function(module, exports) {

$parcel$export(module.exports, "default", () => $663aa7deae8d2218$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $663aa7deae8d2218$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "admin-pages-priority-schemes.title",
        "defaultMessage": "Priority schemes"
    },
    errorHeader: {
        "id": "admin-pages-priority-schemes.error-header",
        "defaultMessage": "There was a problem loading this page"
    },
    errorDescription: {
        "id": "admin-pages-priority-schemes.error-description",
        "defaultMessage": "Check your connection and try again"
    }
});
var $663aa7deae8d2218$export$2e2bcd8739ae039 = $663aa7deae8d2218$var$messages;

});

parcelRegister("fAYMo", function(module, exports) {

$parcel$export(module.exports, "AddOrEditPrioritySchemeModal", () => $f2b107bcbaf7007b$export$f61e1cf3b43d622c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $1zbEq = parcelRequire("1zbEq");

var $4Bees = parcelRequire("4Bees");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $lJQSK = parcelRequire("lJQSK");

var $4I6Xz = parcelRequire("4I6Xz");

var $ejYU1 = parcelRequire("ejYU1");

var $duNeP = parcelRequire("duNeP");

var $lI8Uj = parcelRequire("lI8Uj");

var $ht9t8 = parcelRequire("ht9t8");

var $gYn2Y = parcelRequire("gYn2Y");

var $1jagA = parcelRequire("1jagA");

var $akBi9 = parcelRequire("akBi9");

var $cS51P = parcelRequire("cS51P");

var $4FmMB = parcelRequire("4FmMB");
const $f2b107bcbaf7007b$var$emptyCreateSchemeData = {
    id: undefined,
    name: '',
    description: '',
    isDefault: false,
    priorities: [],
    projects: {
        total: 0,
        values: []
    }
};
const $f2b107bcbaf7007b$var$emptyMappingDiff = {
    prioritiesDiff: {
        add: [],
        remove: []
    },
    projectsDiff: {
        add: [],
        remove: []
    }
};
const $f2b107bcbaf7007b$var$learnMoreURL = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-priorities-for-projects';
const $f2b107bcbaf7007b$export$f61e1cf3b43d622c = (modalWrapperProps)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { initialPriorityScheme: initialPriorityScheme, onComplete: onComplete, startingTab: startingTab } = modalWrapperProps;
    const [formError, setFormError] = (0, $eUqFw.useState)({
        name: '',
        description: '',
        priorityIds: '',
        projectIds: ''
    });
    const [requiresRemovedProjectsMapping, setRequiresRemovedProjectsMapping] = (0, $eUqFw.useState)(false);
    const { defaultSchemeId: defaultSchemeId, defaultSchemePriorities: defaultSchemePriorities, isDefaultSchemeError: isDefaultSchemeError, isDefaultSchemeLoading: isDefaultSchemeLoading } = (0, $duNeP.usePrioritySchemeMappingsOut)({
        requiresRemovedProjectsMapping: requiresRemovedProjectsMapping
    });
    const [currentSchemeMappingDiffs, setCurrentSchemeMappingDiffs] = (0, $eUqFw.useState)($f2b107bcbaf7007b$var$emptyMappingDiff);
    const [defaultSchemeMappingDiffs, setDefaultSchemeMappingDiffs] = (0, $eUqFw.useState)($f2b107bcbaf7007b$var$emptyMappingDiff);
    const [prioritySchemeDetailsFormTab, setPrioritySchemeDetailsFormTab] = (0, $eUqFw.useState)(startingTab || (0, $162Uz.PRIORITY_SCHEME_MODAL_DETAILS_TAB_INDEX));
    const [prioritySchemeModalState, setPrioritySchemeModalState] = (0, $eUqFw.useState)((0, $162Uz.DEFAULT)); /**
                                                                                                               * Add project mappings refers to mapping to the default scheme, removed project mappings is the second case
                                                                                                               * where the projected removed from the 'AddedProjectsMapping' case are added the 'RemovedProjectsMapping'
                                                                                                               */ 
    const [modalStep, setModalStep] = (0, $eUqFw.useState)('FormView');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showSuccessFlag: showSuccessFlag, showAsyncSuccessFlag: showAsyncSuccessFlag, showUnexpectedErrorFlag: showUnexpectedErrorFlag } = (0, $cS51P.usePrioritySchemeShowFlags)();
    const initialScheme = initialPriorityScheme || $f2b107bcbaf7007b$var$emptyCreateSchemeData;
    const isCreatingNewScheme = !initialPriorityScheme;
    const schemeDetailsProps = (0, $4I6Xz.usePrioritySchemeDetailsController)(initialScheme, setFormError);
    const { priorityScheme: priorityScheme, triggerSchemeDetailsValidation: triggerSchemeDetailsValidation } = schemeDetailsProps;
    const projectPickerProps = (0, $lI8Uj.useProjectPickerController)((0, $ht9t8.useProjectPickerService)(initialScheme));
    const { pendingChanges: pendingChanges } = projectPickerProps;
    const projectsDiff = (0, $4FmMB.calculateProjectsDiff)(pendingChanges);
    const prioritiesDiff = (0, $4FmMB.calculatePrioritiesDiff)(initialScheme.priorities, priorityScheme.priorities);
    (0, $eUqFw.useEffect)(()=>{
        const newProjectDiffs = (0, $4FmMB.calculateProjectsDiff)(pendingChanges);
        setCurrentSchemeMappingDiffs((prevState)=>({
                ...prevState,
                projectsDiff: newProjectDiffs
            }));
        if (newProjectDiffs.remove.length > 0) setRequiresRemovedProjectsMapping(true);
        else setRequiresRemovedProjectsMapping(false);
        setDefaultSchemeMappingDiffs((prevState)=>({
                ...prevState,
                projectsDiff: {
                    ...prevState.projectsDiff,
                    add: newProjectDiffs.remove
                }
            }));
    }, [
        pendingChanges
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setCurrentSchemeMappingDiffs((prevState)=>({
                ...prevState,
                prioritiesDiff: (0, $4FmMB.calculatePrioritiesDiff)(initialScheme.priorities, priorityScheme.priorities)
            }));
    }, [
        initialScheme.priorities,
        priorityScheme.priorities
    ]);
    const currentSchemeMappingModalProps = (0, $ejYU1.usePriorityMappingsController)({
        schemeId: priorityScheme.id ? priorityScheme.id : null,
        ...currentSchemeMappingDiffs
    });
    const defaultSchemeMappingModalProps = (0, $ejYU1.usePriorityMappingsController)({
        schemeId: defaultSchemeId,
        ...defaultSchemeMappingDiffs
    });
    const onSave = async ()=>{
        if (!triggerSchemeDetailsValidation(priorityScheme)) {
            setModalStep('FormView');
            return;
        }
        setPrioritySchemeModalState((0, $162Uz.SAVING));
        try {
            const res = await (0, $4FmMB.savePrioritySchemeRequest)(priorityScheme, prioritiesDiff, projectsDiff, (0, $4FmMB.mapPriorityMappingsToRequestMappings)(currentSchemeMappingModalProps.mappings, defaultSchemeMappingModalProps.mappings));
            if (!res.isSuccess && 'errors' in res) {
                (0, $4FmMB.handleApiValidationErrors)(res, setFormError);
                setPrioritySchemeModalState((0, $162Uz.DEFAULT));
                return;
            }
            if (!res.isSuccess) {
                showUnexpectedErrorFlag(isCreatingNewScheme);
                setPrioritySchemeModalState((0, $162Uz.DEFAULT));
                return;
            }
            const { data: { id: createdPrioritySchemeId } } = res;
            (0, $4FmMB.fireSaveAnalyticsEvent)(createAnalyticsEvent, initialScheme, priorityScheme, createdPrioritySchemeId, projectsDiff);
            const { data: data, isMigrationPending: isMigrationPending } = res;
            const flagData = {
                schemeName: priorityScheme.name,
                schemeId: data.id
            };
            if (isMigrationPending) showAsyncSuccessFlag(flagData, isCreatingNewScheme);
            else showSuccessFlag(flagData, isCreatingNewScheme);
            onComplete((0, $lJQSK.ModalOnCompleteStatus).SUCCESS);
        } catch (error) {
            showUnexpectedErrorFlag(isCreatingNewScheme);
        }
        setPrioritySchemeModalState((0, $162Uz.DEFAULT));
    };
    const renderFormViewPrimaryButton = ()=>{
        let onSubmit = onSave;
        let isDisabled = false;
        let buttonContent = isCreatingNewScheme ? formatMessage((0, $akBi9.default).addPrioritySchemeButtonTitle) : formatMessage((0, $akBi9.default).editPrioritySchemeButtonTitle);
        if (currentSchemeMappingModalProps.isLoading || defaultSchemeMappingModalProps.isLoading || prioritySchemeModalState === 'SAVING') {
            buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            });
            isDisabled = true;
        } else if (currentSchemeMappingModalProps.page.totalItems > 0) {
            onSubmit = ()=>setModalStep('AddedProjectsMapping');
            buttonContent = formatMessage((0, $akBi9.default).mappingModalNextButtonTitle);
        } else if (defaultSchemeMappingModalProps.page.totalItems > 0) {
            onSubmit = ()=>setModalStep('RemovedProjectsMapping');
            buttonContent = formatMessage((0, $akBi9.default).mappingModalNextButtonTitle);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR),
            appearance: "primary",
            onClick: onSubmit,
            type: "submit",
            isDisabled: isDisabled
        }, buttonContent);
    };
    const renderMappingInViewPrimaryButton = ()=>{
        let onSubmit = onSave;
        let isDisabled = false;
        let buttonContent = isCreatingNewScheme ? formatMessage((0, $akBi9.default).addPrioritySchemeButtonTitle) : formatMessage((0, $akBi9.default).editPrioritySchemeButtonTitle);
        if (defaultSchemeMappingModalProps.isLoading || prioritySchemeModalState === 'SAVING') {
            buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            });
            isDisabled = true;
        } else if (defaultSchemeMappingModalProps.page.totalItems > 0) {
            onSubmit = ()=>setModalStep('RemovedProjectsMapping');
            buttonContent = formatMessage((0, $akBi9.default).mappingModalNextButtonTitle);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR),
            appearance: "primary",
            onClick: onSubmit,
            type: "submit",
            isDisabled: isDisabled
        }, buttonContent);
    };
    const renderMappingOutViewPrimaryButton = ()=>{
        const onSubmit = onSave;
        let isDisabled = false;
        let buttonContent = isCreatingNewScheme ? formatMessage((0, $akBi9.default).addPrioritySchemeButtonTitle) : formatMessage((0, $akBi9.default).editPrioritySchemeButtonTitle);
        if (prioritySchemeModalState === 'SAVING') {
            buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            });
            isDisabled = true;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR),
            appearance: "primary",
            onClick: onSubmit,
            type: "submit",
            isDisabled: isDisabled
        }, buttonContent);
    };
    const detailsFormProps = {
        formTab: prioritySchemeDetailsFormTab,
        formError: formError,
        isCreatingNewScheme: isCreatingNewScheme,
        onComplete: onComplete,
        onSave: onSave,
        prioritySchemeModalState: prioritySchemeModalState,
        projectPickerProps: projectPickerProps,
        ...schemeDetailsProps,
        setFormTab: setPrioritySchemeDetailsFormTab,
        startingTab: startingTab
    };
    const renderModalContent = ()=>{
        if (modalStep === 'FormView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYn2Y.PrioritySchemeDetailsForm), {
            ...detailsFormProps,
            renderPrimaryButton: renderFormViewPrimaryButton,
            onRemovePriorityMapping: currentSchemeMappingModalProps.onRemovePriorityMapping
        });
        if (modalStep === 'AddedProjectsMapping') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jagA.MappingModalView), {
            isDisabled: prioritySchemeModalState === 'SAVING',
            modalTitle: formatMessage((0, $akBi9.default).mappingModalTitle),
            modalDescription: isCreatingNewScheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $akBi9.default).mappingModalAddSchemeDescription, {
                schemeName: priorityScheme.name
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akBi9.default).mappingModalSelectNewPrioritiesDescription,
                values: {
                    learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: $f2b107bcbaf7007b$var$learnMoreURL,
                        target: "_blank"
                    }, formatMessage((0, $akBi9.default).mappingModalLearnMoreLink))
                }
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $akBi9.default).mappingModalEditSchemeDescription, {
                schemeName: priorityScheme.name
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2b107bcbaf7007b$var$MappingInSchemesDescriptionUl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $akBi9.default).mappingModalEditSchemeAddProjectsListItemOne))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akBi9.default).mappingModalSelectNewPrioritiesDescription,
                values: {
                    learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: $f2b107bcbaf7007b$var$learnMoreURL,
                        target: "_blank"
                    }, formatMessage((0, $akBi9.default).mappingModalLearnMoreLink))
                }
            }))),
            renderPrimaryButton: renderMappingInViewPrimaryButton,
            onPreviousStep: ()=>setModalStep('FormView'),
            mappablePriorities: priorityScheme.priorities,
            ...currentSchemeMappingModalProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jagA.MappingModalView), {
            isDisabled: prioritySchemeModalState === 'SAVING',
            modalTitle: formatMessage((0, $akBi9.default).mappingModalTitle),
            modalDescription: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $akBi9.default).mappingModalEditSchemeDescription, {
                schemeName: priorityScheme.name
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2b107bcbaf7007b$var$MappingInSchemesDescriptionUl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $akBi9.default).mappingModalEditSchemeDescriptionRemoveProjectsListItemOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $akBi9.default).mappingModalEditSchemeDescriptionRemoveProjectsListItemTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akBi9.default).mappingModalSelectNewPrioritiesDescription,
                values: {
                    learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: $f2b107bcbaf7007b$var$learnMoreURL,
                        target: "_blank"
                    }, formatMessage((0, $akBi9.default).mappingModalLearnMoreLink))
                }
            }))),
            renderPrimaryButton: renderMappingOutViewPrimaryButton,
            onPreviousStep: ()=>{
                if (currentSchemeMappingModalProps.page.totalItems > 0) setModalStep('AddedProjectsMapping');
                else setModalStep('FormView');
            },
            mappablePriorities: defaultSchemePriorities,
            ...defaultSchemeMappingModalProps,
            isError: defaultSchemeMappingModalProps.isError || isDefaultSchemeError,
            isLoading: isDefaultSchemeLoading
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYn2Y.PrioritySchemeModalWithAnalytics), {
        initialPriorityScheme: initialScheme
    }, renderModalContent());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2b107bcbaf7007b$var$MappingInSchemesDescriptionUl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvtotd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4I6Xz", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemeDetailsController", () => $edc5a5b266cd2832$export$137deca487c1dbc1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9RVHI = parcelRequire("9RVHI");
const $edc5a5b266cd2832$export$137deca487c1dbc1 = (initialPriorityScheme, setFormError)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [prioritySchemeDetails, setPrioritySchemeDetails] = (0, $eUqFw.useState)(initialPriorityScheme);
    (0, $eUqFw.useEffect)(()=>{
        setPrioritySchemeDetails(initialPriorityScheme);
    }, [
        initialPriorityScheme
    ]);
    const onValidationError = (field, messageDescriptor, optionalValues)=>{
        setFormError((fields)=>({
                ...fields,
                [field]: formatMessage(messageDescriptor, optionalValues)
            }));
    };
    const onPrioritySchemeDetailsChange = (incomingPriorityScheme)=>{
        if (incomingPriorityScheme.name !== prioritySchemeDetails.name) {
            const isClean = (0, $9RVHI.validateName)(incomingPriorityScheme.name, onValidationError);
            if (isClean) setFormError((fields)=>({
                    ...fields,
                    name: ''
                }));
        }
        if (incomingPriorityScheme.description !== prioritySchemeDetails.description) {
            const isClean = (0, $9RVHI.validateDescription)(incomingPriorityScheme.description);
            if (isClean) setFormError((fields)=>({
                    ...fields,
                    description: ''
                }));
        }
        if (incomingPriorityScheme.priorities.length !== prioritySchemeDetails.priorities.length) {
            const isClean = (0, $9RVHI.validatePriorities)(incomingPriorityScheme.priorities, onValidationError);
            if (isClean) setFormError((fields)=>({
                    ...fields,
                    priorityIds: ''
                }));
        }
        setPrioritySchemeDetails(incomingPriorityScheme);
    };
    const triggerSchemeDetailsValidation = (incomingPriorityScheme)=>{
        let isClean = true;
        isClean = (0, $9RVHI.validateName)(incomingPriorityScheme.name, onValidationError) && isClean;
        isClean = (0, $9RVHI.validatePriorities)(incomingPriorityScheme.priorities, onValidationError) && isClean;
        return isClean;
    };
    return {
        onPrioritySchemeDetailsChange: onPrioritySchemeDetailsChange,
        priorityScheme: prioritySchemeDetails,
        triggerSchemeDetailsValidation: triggerSchemeDetailsValidation
    };
};

});
parcelRegister("9RVHI", function(module, exports) {

$parcel$export(module.exports, "validateName", () => $5fefcb267233ebef$export$b135c3f9b9f02308);
$parcel$export(module.exports, "validateDescription", () => $5fefcb267233ebef$export$b5ccb7b3af83de7e);
$parcel$export(module.exports, "validatePriorities", () => $5fefcb267233ebef$export$73135a7da91458ec);

var $162Uz = parcelRequire("162Uz");

var $k8IeC = parcelRequire("k8IeC");
const $5fefcb267233ebef$var$nameField = 'name';
const $5fefcb267233ebef$var$prioritiesField = 'priorityIds';
const $5fefcb267233ebef$export$b135c3f9b9f02308 = (name, onError)=>{
    if (name.length === 0) {
        onError && onError($5fefcb267233ebef$var$nameField, (0, $k8IeC.default).prioritySchemeNameFieldEmptyValidationError);
        return false;
    }
    return true;
};
const $5fefcb267233ebef$export$b5ccb7b3af83de7e = (description)=>{
    if (description.length >= (0, $162Uz.MAX_DESCRIPTION_LENGTH)) return false;
    return true;
};
const $5fefcb267233ebef$export$73135a7da91458ec = (priorities, onError)=>{
    if (priorities.length === 0) {
        onError && onError($5fefcb267233ebef$var$prioritiesField, (0, $k8IeC.default).prioritySchemePrioritiesFieldEmptyValidationError);
        return false;
    }
    return true;
};

});
parcelRegister("k8IeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $72bb199b8852f640$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $72bb199b8852f640$var$messages = (0, $90IgZ.defineMessages)({
    prioritySchemeNameMaxLengthValidationError: {
        "id": "admin-pages-priority-schemes.controllers.priority-scheme-name-max-length-validation-error",
        "defaultMessage": "The name you entered is too long. You can use up to {maxLength} characters."
    },
    prioritySchemeNameFieldEmptyValidationError: {
        "id": "admin-pages-priority-schemes.controllers.priority-scheme-name-field-empty-validation-error",
        "defaultMessage": "You must specify a name for the priority scheme to be added."
    },
    prioritySchemeDescriptionMaxLengthValidationError: {
        "id": "admin-pages-priority-schemes.controllers.priority-scheme-description-max-length-validation-error",
        "defaultMessage": "The description you entered is too long. You can use up to {maxLength} characters."
    },
    prioritySchemePrioritiesFieldEmptyValidationError: {
        "id": "admin-pages-priority-schemes.controllers.priority-scheme-priorities-field-empty-validation-error",
        "defaultMessage": "You must select at least one priority."
    }
});
var $72bb199b8852f640$export$2e2bcd8739ae039 = $72bb199b8852f640$var$messages;

});



parcelRegister("ejYU1", function(module, exports) {

$parcel$export(module.exports, "usePriorityMappingsController", () => $2a2fc50826faebe2$export$6c332987c6dd5b89);

var $eUqFw = parcelRequire("eUqFw");

var $2jdHI = parcelRequire("2jdHI");

var $iA6pe = parcelRequire("iA6pe");

var $4Dlce = parcelRequire("4Dlce");
const $2a2fc50826faebe2$var$DEFAULT_MAPPING_MODAL_ROW_COUNT = 8;
const $2a2fc50826faebe2$export$6c332987c6dd5b89 = ({ schemeId: schemeId, prioritiesDiff: prioritiesDiff, projectsDiff: projectsDiff })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [page, setPage] = (0, $eUqFw.useState)({
        currentPage: 1,
        items: [],
        totalItems: 0,
        pageSize: 0
    });
    const [mappings, setMappings] = (0, $eUqFw.useState)({});
    const [isError, setIsError] = (0, $eUqFw.useState)(false);
    /**
	 * @param pageNumber one indexed
	 */ const getSuggestedMappings = async (pageNumber)=>{
        try {
            setIsLoading(true);
            if (!isError) setIsError(false);
            const response = await (0, $4Dlce.getPrioritySchemeMappingsRequest)({
                ...schemeId && {
                    schemeId: Number(schemeId)
                },
                startAt: (pageNumber - 1) * $2a2fc50826faebe2$var$DEFAULT_MAPPING_MODAL_ROW_COUNT,
                maxResults: $2a2fc50826faebe2$var$DEFAULT_MAPPING_MODAL_ROW_COUNT,
                priorities: {
                    add: prioritiesDiff.add.map(Number),
                    remove: prioritiesDiff.remove.map(Number)
                },
                projects: {
                    add: projectsDiff.add.map(Number)
                }
            });
            setPage({
                currentPage: pageNumber,
                items: response.values.map((0, $iA6pe.parsePriorityOnServerToPriority)),
                totalItems: response.total,
                pageSize: response.maxResults
            });
        } catch (error) {
            setIsError(true);
        } finally{
            setIsLoading(false);
        }
    };
    const checkSuggestedMappings = async ()=>{
        await getSuggestedMappings(1);
        // Clear all mappings whenever we are checking for mappings
        // i.e. whenever there are any changes to the schemeId, priorities or projects
        // within the scheme
        setMappings({});
    };
    const [debouncedFetchData, cancelDebouncedFetchData] = (0, $2jdHI.default)(checkSuggestedMappings, 300);
    /**
	 * NOTE: schemeId, projectsDiff, prioritiesDiff must be memorised in order to prevent infinite looping.
	 *
	 * Possible alternative solutions in the future given more time:
	 * 1. Imperatively call the fetch and update our page, whenever schemeId, projectsDiff, prioritiesDiff changes
	 *    in the other controllers. onFetch might become annoying to deal with, you
	 * 2. Use Redux or another imperative state management framework to deal with this state -> and have it only
	 *    re-render when the schemeId, projectDiff, prioritiesDiff changes
	 */ (0, $eUqFw.useEffect)(()=>{
        if (schemeId === undefined) return;
        debouncedFetchData();
        return ()=>{
            cancelDebouncedFetchData();
        };
    }, [
        schemeId,
        projectsDiff,
        prioritiesDiff,
        debouncedFetchData,
        cancelDebouncedFetchData
    ]);
    const onUpdateMapping = (currentPriorityId, newPriority)=>{
        setMappings({
            ...mappings,
            [currentPriorityId]: newPriority
        });
    };
    const onRemovePriorityMapping = (removedPriorityId)=>{
        const newMappings = {};
        Object.entries(mappings).forEach(([priorityId, priority])=>{
            if (priority.id !== removedPriorityId) newMappings[priorityId] = priority;
        });
        setMappings(newMappings);
    };
    const onFetch = async (_event, pageNumber)=>{
        await getSuggestedMappings(pageNumber);
    };
    return {
        isError: isError,
        setIsError: setIsError,
        isLoading: isLoading,
        mappings: mappings,
        onUpdateMapping: onUpdateMapping,
        onRemovePriorityMapping: onRemovePriorityMapping,
        page: page,
        onFetch: onFetch
    };
};

});
parcelRegister("4Dlce", function(module, exports) {

$parcel$export(module.exports, "getPrioritySchemeMappingsRequest", () => $38c56ad157f106d4$export$8ff58061757ceff2);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $9wVV1 = parcelRequire("9wVV1");
const $38c56ad157f106d4$export$8ff58061757ceff2 = async (requestParams)=>{
    try {
        const URL = '/rest/api/2/priorityscheme/mappings';
        const response = await (0, $2OdyW.default)(URL, {
            method: 'POST',
            body: JSON.stringify(requestParams)
        });
        const responseBody = (0, $9wVV1.refinePriorityOnServerPageResponse)(response);
        if (!responseBody) throw new Error('Invalid response');
        return responseBody;
    } catch (error) {
        // We don't care if the error is a 400 or 403 we will deal with them in
        // in the same way i imagine.
        const fetchError = await (0, $9wVV1.refineFetchError)(error);
        (0, $guiFP.default)({
            error: fetchError ? new Error(`get priority scheme mappings failed with status code ${fetchError.statusCode} and response body ${fetchError.responseJson}`) : new Error('get priority scheme mappings failed with unexpected error'),
            meta: {
                id: 'getPrioritySchemeMappings',
                packageName: 'jiraAdminPagesPrioritySchemes',
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("duNeP", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemeMappingsOut", () => $fa546a3d7607a181$export$91ebb5257d3b555d);

var $eUqFw = parcelRequire("eUqFw");

var $iA6pe = parcelRequire("iA6pe");

var $df4RB = parcelRequire("df4RB");

var $fcCX7 = parcelRequire("fcCX7");
const $fa546a3d7607a181$export$91ebb5257d3b555d = ({ requiresRemovedProjectsMapping: requiresRemovedProjectsMapping })=>{
    const [defaultSchemeId, setDefaultSchemeId] = (0, $eUqFw.useState)(undefined);
    const [defaultSchemePriorities, setDefaultSchemePriorities] = (0, $eUqFw.useState)([]);
    const [isDefaultSchemeLoading, setIsDefaultSchemeLoading] = (0, $eUqFw.useState)(false);
    const [isDefaultSchemeError, setIsDefaultSchemeError] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            // To ensure that we only fetch one time -> when we first need to do remove project
            // mapping and when we haven't set the default scheme before.
            if (!requiresRemovedProjectsMapping || defaultSchemeId) return;
            try {
                setIsDefaultSchemeLoading(true);
                setIsDefaultSchemeError(false);
                const response = await (0, $fcCX7.fetchPrioritySchemes)(1, (0, $fcCX7.emptyFilter), true);
                if (response.prioritySchemes.length === 0) throw Error('Empty priority scheme when fetching default scheme');
                const responseSchemeId = response.prioritySchemes[0].id;
                setDefaultSchemeId(responseSchemeId);
                let startAt = 0;
                let isLast = false;
                let defaultPriorities = [];
                /**
				 * In the interest of time we will preload default scheme priorities instead of paginating it properly
				 * it from the paginated API, we will cap the amount of priorities we can fetch at 2000, we have a
				 * soft limit of 300 priorities in an instance however customers in server may migrate over with
				 * a ridiculous amount of priorities (in server as of now the max is only 200, but that may change).
				 *
				 * The current expected behaviour is that only 2000 priorities will be avaliable when mapping to the
				 * default scheme - this is already more than the 300 priorities we have communicated that we are
				 * supporting.
				 *
				 * When this edge case occurs, we will update our code to handle this edge case, by updating the
				 * mapping picker component to handle both dealing with both in memory priorities and fetching from an
				 * API.
				 */ while(!isLast && startAt < 2000)try {
                    // eslint-disable-next-line no-await-in-loop
                    const defaultPriorityPaginated = await (0, $df4RB.fetchPrioritiesByScheme)(responseSchemeId, 0, 1000);
                    startAt += defaultPriorityPaginated.maxResults;
                    isLast = defaultPriorityPaginated.isLast;
                    defaultPriorities = [
                        ...defaultPriorities,
                        ...defaultPriorityPaginated.values.map((0, $iA6pe.parsePriorityOnServerToPriority))
                    ];
                } catch (error) {
                    throw Error('Error fetching default scheme priorities');
                }
                setDefaultSchemePriorities(defaultPriorities);
            } catch (error) {
                setIsDefaultSchemeError(true);
            } finally{
                setIsDefaultSchemeLoading(false);
            }
        })();
    }, [
        defaultSchemeId,
        requiresRemovedProjectsMapping,
        setIsDefaultSchemeLoading
    ]);
    return {
        defaultSchemeId: defaultSchemeId,
        defaultSchemePriorities: defaultSchemePriorities,
        isDefaultSchemeLoading: isDefaultSchemeLoading,
        isDefaultSchemeError: isDefaultSchemeError
    };
};

});

parcelRegister("lI8Uj", function(module, exports) {

$parcel$export(module.exports, "useProjectPickerController", () => $4e8da6820d9e22df$export$52d8f4f0c8f695d6);

var $eUqFw = parcelRequire("eUqFw");

var $162Uz = parcelRequire("162Uz");

var $lJQSK = parcelRequire("lJQSK");
const $4e8da6820d9e22df$var$getIsOptionDisabled = (pendingChanges, project, isDefaultPriorityScheme)=>{
    const { id: id, isAssociatedWithScheme: isAssociatedWithScheme } = project;
    if (isAssociatedWithScheme && isDefaultPriorityScheme) return {
        disabled: true
    };
    if (Object.values(pendingChanges).length < (0, $162Uz.PROJECT_PICKER_PENDING_CHANGES_LIMIT)) return {
        disabled: false
    };
    return {
        disabled: pendingChanges[id] === undefined
    };
};
const $4e8da6820d9e22df$export$52d8f4f0c8f695d6 = ({ data: data, onRefetch: onRefetch, state: state })=>{
    const { countForQueriedProjectsInJira: countForQueriedProjectsInJira, countForQueriedAssociatedProjects: countForQueriedAssociatedProjects, totalNumberOfAssociatedProjects: totalNumberOfAssociatedProjects, priorityScheme: priorityScheme, projects: projects } = data;
    const [currentCountForAssociatedProjects, setCurrentCountForAssociatedProjects] = (0, $eUqFw.useState)(totalNumberOfAssociatedProjects);
    /**
	 * Prop was originally used to display the count of "total projects"
	 * which was deemed confusing, this UI component has been disabled
	 * we should clean up this state and component when we are sure there
	 * is no need for it.
	 */ const [newCountForAssociatedProjects, setNewCountForAssociatedProjects] = (0, $eUqFw.useState)(totalNumberOfAssociatedProjects);
    const [filter, setFilter] = (0, $eUqFw.useState)({
        projectFilterChoice: (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS,
        query: ''
    });
    const [page, setPage] = (0, $eUqFw.useState)({
        currentPage: (0, $162Uz.TABLE_DEFAULT_PAGE),
        items: projects,
        totalItems: countForQueriedProjectsInJira,
        pageSize: (0, $162Uz.PROJECT_PICKER_ROWS_PER_PAGE)
    });
    const [pendingChanges, setPendingChanges] = (0, $eUqFw.useState)({});
    const [selectAllChecked, setSelectAllChecked] = (0, $eUqFw.useState)(false);
    const { query: query, projectFilterChoice: projectFilterChoice } = filter;
    const { items: items } = page;
    (0, $eUqFw.useEffect)(()=>{
        setCurrentCountForAssociatedProjects(totalNumberOfAssociatedProjects);
    }, [
        totalNumberOfAssociatedProjects
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const updatedItems = projects.map((project)=>{
            const { checked: checked, id: id } = project;
            return {
                ...project,
                ...$4e8da6820d9e22df$var$getIsOptionDisabled(pendingChanges, project, priorityScheme.isDefault),
                checked: id in pendingChanges ? pendingChanges[id] : checked
            };
        });
        const pendingChangesCount = Object.values(pendingChanges).length;
        const pendingChangesToAddCount = Object.values(pendingChanges).filter((toAdd)=>toAdd).length;
        const pendingChangesToRemoveCount = pendingChangesCount - pendingChangesToAddCount;
        setNewCountForAssociatedProjects(currentCountForAssociatedProjects - pendingChangesToRemoveCount + pendingChangesToAddCount);
        setPage((prevPage)=>({
                ...prevPage,
                items: updatedItems
            }));
    }, [
        currentCountForAssociatedProjects,
        pendingChanges,
        projects,
        priorityScheme.isDefault
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS) setPage((prevPage)=>({
                ...prevPage,
                totalItems: countForQueriedProjectsInJira
            }));
        else if (projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ASSOCIATED_PROJECTS) setPage((prevPage)=>({
                ...prevPage,
                totalItems: countForQueriedAssociatedProjects
            }));
    }, [
        countForQueriedProjectsInJira,
        countForQueriedAssociatedProjects,
        projectFilterChoice
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setSelectAllChecked(items.filter(({ disabled: disabled })=>!disabled).some(({ checked: checked })=>checked));
    }, [
        items
    ]);
    const onFetch = (0, $eUqFw.useCallback)((onFetchParam)=>{
        const { projectFilterChoice: newProjectFilter, query: newQuery, selectedPage: selectedPage } = onFetchParam;
        const updatedProjectFilter = newProjectFilter ?? projectFilterChoice;
        const updatedQuery = newQuery ?? query;
        const startAtIndex = (selectedPage ? selectedPage - 1 : 0) * (0, $162Uz.PROJECT_PICKER_ROWS_PER_PAGE);
        onRefetch({
            projectFilter: updatedProjectFilter,
            query: updatedQuery,
            startAt: startAtIndex
        });
        setFilter({
            projectFilterChoice: updatedProjectFilter,
            query: updatedQuery
        });
        setPage((prevPage)=>({
                ...prevPage,
                currentPage: selectedPage ?? (0, $162Uz.TABLE_DEFAULT_PAGE)
            }));
    }, [
        onRefetch,
        projectFilterChoice,
        query
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state === (0, $lJQSK.ProjectPickerState).INITITAL) onFetch({
            projectFilterChoice: filter.projectFilterChoice,
            query: filter.query,
            selectedPage: page.currentPage
        });
    }, [
        filter.projectFilterChoice,
        filter.query,
        onFetch,
        page.currentPage,
        state
    ]);
    const onToggleProject = (input)=>{
        const { checked: checked, id: id, isAssociatedWithScheme: isAssociatedWithScheme } = input;
        const pendingChangeToAdd = !isAssociatedWithScheme && checked;
        const pendingChangeToRemove = isAssociatedWithScheme && !checked;
        const revertChangeToAdd = !isAssociatedWithScheme && !checked;
        const revertChangeToRemove = isAssociatedWithScheme && checked;
        if (pendingChangeToAdd || pendingChangeToRemove) setPendingChanges((prevChanges)=>{
            const nextChanges = {
                ...prevChanges
            };
            nextChanges[id] = checked;
            return nextChanges;
        });
        else if (revertChangeToAdd || revertChangeToRemove) setPendingChanges((prevChanges)=>{
            const nextChanges = {
                ...prevChanges
            };
            delete nextChanges[id];
            return nextChanges;
        });
    };
    const onToggleAllProjects = (checked)=>{
        items.forEach((project)=>onToggleProject({
                ...project,
                checked: checked
            }));
        setSelectAllChecked(checked);
    };
    return {
        currentCountForAssociatedProjects: currentCountForAssociatedProjects,
        filter: filter,
        onFetch: onFetch,
        onToggleAllProjects: onToggleAllProjects,
        onToggleProject: onToggleProject,
        newCountForAssociatedProjects: newCountForAssociatedProjects,
        page: page,
        pendingChanges: pendingChanges,
        priorityScheme: priorityScheme,
        selectAllChecked: selectAllChecked,
        state: state
    };
};

});

parcelRegister("ht9t8", function(module, exports) {

$parcel$export(module.exports, "useProjectPickerService", () => $3c9764fa8ac38d81$export$620bdd54f166e03d);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $lJQSK = parcelRequire("lJQSK");

var $lSiuz = parcelRequire("lSiuz");
const $3c9764fa8ac38d81$export$43fe127fc3f91e2 = {
    countForQueriedProjectsInJira: 0,
    countForQueriedAssociatedProjects: 0,
    totalNumberOfAssociatedProjects: 0,
    priorityScheme: {
        name: '',
        isDefault: false
    },
    projects: []
};
const $3c9764fa8ac38d81$export$620bdd54f166e03d = (priorityScheme)=>{
    const [data, setData] = (0, $eUqFw.useState)({
        ...$3c9764fa8ac38d81$export$43fe127fc3f91e2,
        priorityScheme: {
            name: priorityScheme.name ?? '',
            isDefault: priorityScheme.isDefault
        }
    });
    const [state, setState] = (0, $eUqFw.useState)((0, $lJQSK.ProjectPickerState).INITITAL);
    const onRefetch = (0, $eUqFw.useCallback)(async ({ projectFilter: projectFilter, query: query, startAt: startAt })=>{
        const prevErrorState = (0, $lJQSK.ProjectPickerState).ERROR === state;
        const prevInitialState = (0, $lJQSK.ProjectPickerState).INITITAL === state;
        setState((0, $lJQSK.ProjectPickerState).LOADING);
        const { countForQueriedProjectsInJira: countForQueriedProjectsInJira, countForQueriedAssociatedProjects: countForQueriedAssociatedProjects, totalNumberOfAssociatedProjects: totalNumberOfAssociatedProjects, priorityScheme: { name: name, isDefault: isDefault } } = data;
        try {
            let projects = [];
            let countForProjectsInJira = countForQueriedProjectsInJira;
            let countForAssociatedProjects = countForQueriedAssociatedProjects;
            let totalNumOfAssociatedProjects = totalNumberOfAssociatedProjects;
            if (!priorityScheme.id) {
                const { items: items, totalItems: totalItems } = await (0, $lSiuz.fetchAllProjects)((0, $2OdyW.default), startAt, query);
                countForProjectsInJira = totalItems;
                projects = items;
            } else if (projectFilter === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS) {
                // Populate value for lozenge used in "Existing projects" filter dropdown
                if (prevErrorState || prevInitialState) {
                    const { totalItems: totalItems } = await (0, $lSiuz.fetchProjectsAssociatedToPriorityScheme)((0, $2OdyW.default), priorityScheme.id, 0, '');
                    totalNumOfAssociatedProjects = totalItems;
                }
                const { items: items, totalItems: totalItems } = await (0, $lSiuz.fetchPrioritySchemeProjectSuggestions)((0, $2OdyW.default), priorityScheme.id, startAt, query);
                countForProjectsInJira = totalItems;
                projects = items;
            } else {
                const { items: items, totalItems: totalItems } = await (0, $lSiuz.fetchProjectsAssociatedToPriorityScheme)((0, $2OdyW.default), priorityScheme.id, startAt, query);
                countForAssociatedProjects = totalItems;
                projects = items;
            }
            const nextData = {
                countForQueriedProjectsInJira: countForProjectsInJira,
                countForQueriedAssociatedProjects: countForAssociatedProjects,
                totalNumberOfAssociatedProjects: totalNumOfAssociatedProjects,
                priorityScheme: {
                    name: name,
                    isDefault: isDefault
                },
                projects: projects
            };
            setData(nextData);
            setState((0, $lJQSK.ProjectPickerState).SUCCESS);
        } catch (error) {
            setState((0, $lJQSK.ProjectPickerState).ERROR);
        }
    }, [
        data,
        priorityScheme.id,
        state
    ]);
    return {
        data: data,
        onRefetch: onRefetch,
        state: state
    };
};

});
parcelRegister("lSiuz", function(module, exports) {

$parcel$export(module.exports, "fetchAllProjects", () => $c2824f38549f5f85$export$5142cca733615f8);
$parcel$export(module.exports, "fetchProjectsAssociatedToPriorityScheme", () => $c2824f38549f5f85$export$7b947ce88fa7ec22);
$parcel$export(module.exports, "fetchPrioritySchemeProjectSuggestions", () => $c2824f38549f5f85$export$d7999ce652561e98);

var $162Uz = parcelRequire("162Uz");
function $c2824f38549f5f85$var$getSearchParams(startAt, query) {
    const projectsParams = new URLSearchParams();
    projectsParams.append('startAt', String(startAt));
    if (query !== '') projectsParams.append('query', query);
    projectsParams.append('maxResults', String((0, $162Uz.PROJECT_PICKER_ROWS_PER_PAGE)));
    projectsParams.append('orderBy', (0, $162Uz.ORDER_PROJECTS_BY));
    return projectsParams;
}
function $c2824f38549f5f85$var$toProjectInputFactory(isAssociatedToScheme) {
    return function toProjectInput(p) {
        return {
            id: p.id,
            name: p.name,
            projectStyle: p.style,
            checked: isAssociatedToScheme(p),
            disabled: false,
            avatarUrl: p.avatarUrls['48x48'],
            isAssociatedWithScheme: isAssociatedToScheme(p)
        };
    };
}
function $c2824f38549f5f85$var$mapToPage(response, mapper) {
    return {
        pageSize: response.maxResults,
        totalItems: response.total,
        currentPage: response.startAt / response.maxResults + 1,
        items: response.values.map(mapper)
    };
}
function $c2824f38549f5f85$var$fetchPublicProjectsApi(myFetchJson, projectsParams) {
    return myFetchJson(`/rest/api/3/project/search?${projectsParams}`);
}
const $c2824f38549f5f85$export$5142cca733615f8 = async (myFetchJson, startAt, query)=>{
    const projectsParams = $c2824f38549f5f85$var$getSearchParams(startAt, query);
    const response = await $c2824f38549f5f85$var$fetchPublicProjectsApi(myFetchJson, projectsParams);
    return $c2824f38549f5f85$var$mapToPage(response, $c2824f38549f5f85$var$toProjectInputFactory(()=>false));
};
function $c2824f38549f5f85$var$fetchAssociatedProjectsApi(myFetchJson, prioritySchemeId, projectsParams) {
    return myFetchJson(`/rest/api/2/priorityscheme/${prioritySchemeId}/projects?${projectsParams}`);
}
const $c2824f38549f5f85$export$7b947ce88fa7ec22 = async (myFetchJson, prioritySchemeId, startAt, query)=>{
    const projectsParams = $c2824f38549f5f85$var$getSearchParams(startAt, query);
    const response = await $c2824f38549f5f85$var$fetchAssociatedProjectsApi(myFetchJson, prioritySchemeId, projectsParams);
    return $c2824f38549f5f85$var$mapToPage(response, $c2824f38549f5f85$var$toProjectInputFactory(()=>true));
};
const $c2824f38549f5f85$export$d7999ce652561e98 = async (myFetchJson, prioritySchemeId, startAt, query)=>{
    const projectsParams = $c2824f38549f5f85$var$getSearchParams(startAt, query);
    const projectsResult = await $c2824f38549f5f85$var$fetchPublicProjectsApi(myFetchJson, projectsParams);
    const projectIds = projectsResult.values.map((p)=>p.id);
    const associationsParams = new URLSearchParams();
    // Here we always start from 0 because we also pass an array of exactly <PAGE_SIZE> project ids
    associationsParams.append('startAt', String(0));
    associationsParams.append('maxResults', String(projectIds.length));
    projectIds.forEach((id)=>associationsParams.append('projectId', id));
    const associationsResponse = await $c2824f38549f5f85$var$fetchAssociatedProjectsApi(myFetchJson, prioritySchemeId, associationsParams);
    const associatedIds = new Set();
    associationsResponse.values.forEach((p)=>associatedIds.add(p.id));
    return $c2824f38549f5f85$var$mapToPage(projectsResult, $c2824f38549f5f85$var$toProjectInputFactory((p)=>associatedIds.has(p.id)));
};

});


parcelRegister("gYn2Y", function(module, exports) {

$parcel$export(module.exports, "PrioritySchemeModalWithAnalytics", () => $1711882397c7f3c1$export$5f72320b98c6b757);
$parcel$export(module.exports, "PrioritySchemeDetailsForm", () => $1711882397c7f3c1$export$c0ccc02794021e83);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $162Uz = parcelRequire("162Uz");

var $6bIZA = parcelRequire("6bIZA");

var $j1oS4 = parcelRequire("j1oS4");

var $5H02x = parcelRequire("5H02x");

var $4FmMB = parcelRequire("4FmMB");
const $1711882397c7f3c1$export$5f72320b98c6b757 = (props)=>{
    const { initialPriorityScheme: initialPriorityScheme, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...(0, $4FmMB.generateScreenEventMeta)(initialPriorityScheme),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), children);
};
const $1711882397c7f3c1$export$c0ccc02794021e83 = ({ renderPrimaryButton: renderPrimaryButton, formTab: formTab, formError: formError, isCreatingNewScheme: isCreatingNewScheme, onComplete: onComplete, onPrioritySchemeDetailsChange: onPrioritySchemeDetailsChange, onSave: onSave, projectPickerProps: projectPickerProps, priorityScheme: priorityScheme, prioritySchemeModalState: prioritySchemeModalState, setFormTab: setFormTab, onRemovePriorityMapping: onRemovePriorityMapping })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (formError.name || formError.description || formError.priorityIds) setFormTab((0, $162Uz.PRIORITY_SCHEME_MODAL_DETAILS_TAB_INDEX));
        else if (formError.projectIds) setFormTab((0, $162Uz.PRIORITY_SCHEME_MODAL_PROJECTS_TAB_INDEX));
    }, [
        formError,
        setFormTab
    ]);
    const renderDetailsContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1oS4.PrioritySchemeDetails), {
            prioritySchemeFormState: prioritySchemeModalState,
            priorityScheme: priorityScheme,
            setPriorityScheme: onPrioritySchemeDetailsChange,
            nameError: formError.name,
            descriptionError: formError.description,
            prioritiesError: formError.priorityIds,
            onRemovePriorityMapping: onRemovePriorityMapping
        });
    const renderProjectsContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H02x.ProjectPicker), projectPickerProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bIZA.ModalView), {
        renderPrimaryButton: renderPrimaryButton,
        prioritySchemeFormStatus: prioritySchemeModalState,
        onSubmit: onSave,
        onClose: onComplete,
        isCreatingNewScheme: isCreatingNewScheme,
        tabIndex: formTab,
        setTabIndex: setFormTab,
        renderDetailsContent: renderDetailsContent,
        renderProjectsContent: renderProjectsContent
    });
};

});
parcelRegister("6bIZA", function(module, exports) {

$parcel$export(module.exports, "ModalView", () => $07f36d8dfd6f5351$export$9b51165ab6e1c0c1);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $jWuk1 = parcelRequire("jWuk1");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $4Bees = parcelRequire("4Bees");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $lJQSK = parcelRequire("lJQSK");

var $agSsO = parcelRequire("agSsO");
const $07f36d8dfd6f5351$export$9b51165ab6e1c0c1 = ({ renderPrimaryButton: renderPrimaryButton, prioritySchemeFormStatus: prioritySchemeFormStatus, onSubmit: onSubmit, onClose: onClose, isCreatingNewScheme: isCreatingNewScheme, renderDetailsContent: renderDetailsContent, renderProjectsContent: renderProjectsContent, tabIndex: tabIndex, setTabIndex: setTabIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderSubmitButtonTitle = isCreatingNewScheme ? formatMessage((0, $agSsO.default).addPrioritySchemeButtonTitle) : formatMessage((0, $agSsO.default).editPrioritySchemeButtonTitle);
    const isDisabled = prioritySchemeFormStatus !== (0, $162Uz.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL),
        onClose: ()=>onClose((0, $lJQSK.ModalOnCompleteStatus).DISMISSAL)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, isCreatingNewScheme ? formatMessage((0, $agSsO.default).addPrioritySchemeTitle) : formatMessage((0, $agSsO.default).editPrioritySchemeTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        onClick: ()=>onClose((0, $lJQSK.ModalOnCompleteStatus).DISMISSAL),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        label: formatMessage((0, $agSsO.default).closeModalButtonLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "priority-scheme-modal-tabs",
        selected: tabIndex,
        onChange: setTabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, formatMessage((0, $agSsO.default).detailsPrioritySchemeTab)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, formatMessage((0, $agSsO.default).projectsPrioritySchemeTab))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, renderDetailsContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, renderProjectsContent()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: ()=>onClose((0, $lJQSK.ModalOnCompleteStatus).DISMISSAL),
        isDisabled: isDisabled
    }, formatMessage((0, $agSsO.default).cancelPrioritySchemeButtonTitle)), renderPrimaryButton ? renderPrimaryButton() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_SUBMIT_BUTTON_SELECTOR),
        appearance: "primary",
        onClick: onSubmit,
        type: "submit",
        isDisabled: isDisabled
    }, prioritySchemeFormStatus === (0, $162Uz.SAVING) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }) : renderSubmitButtonTitle)));
};

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f50084288d7b85a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f50084288d7b85a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStylesOld,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$442d081208938078 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStylesOld = (0, $9qnib.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $b552637a2f5925a8$var$tabListStyles : $b552637a2f5925a8$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("emR29", function(module, exports) {

$parcel$export(module.exports, "default", () => $854be789e89981e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $kgCsd = parcelRequire("kgCsd");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $854be789e89981e2$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $854be789e89981e2$export$2e2bcd8739ae039 = $854be789e89981e2$var$TabPanel;

});

parcelRegister("agSsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb12f728fa9f6d1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $acb12f728fa9f6d1$var$messages = (0, $90IgZ.defineMessages)({
    addPrioritySchemeTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.add-priority-scheme-title",
        "defaultMessage": "Add priority scheme"
    },
    editPrioritySchemeTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.edit-priority-scheme-title",
        "defaultMessage": "Edit priority scheme"
    },
    detailsPrioritySchemeTab: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.details-priority-scheme-tab",
        "defaultMessage": "Details"
    },
    projectsPrioritySchemeTab: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.projects-priority-scheme-tab",
        "defaultMessage": "Projects"
    },
    cancelPrioritySchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.cancel-priority-scheme-button-title",
        "defaultMessage": "Cancel"
    },
    addPrioritySchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.add-priority-scheme-button-title",
        "defaultMessage": "Add scheme"
    },
    editPrioritySchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.edit-priority-scheme-button-title",
        "defaultMessage": "Save"
    },
    closeModalButtonLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-view.close-modal-button-label",
        "defaultMessage": "Close modal"
    }
});
var $acb12f728fa9f6d1$export$2e2bcd8739ae039 = $acb12f728fa9f6d1$var$messages;

});


parcelRegister("j1oS4", function(module, exports) {

$parcel$export(module.exports, "PrioritySchemeDetails", () => $ac89428afaad1387$export$84ac5744c6491149);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $162Uz = parcelRequire("162Uz");

var $7LeOt = parcelRequire("7LeOt");

var $iMk9T = parcelRequire("iMk9T");

var $4ISro = parcelRequire("4ISro");
const $ac89428afaad1387$export$84ac5744c6491149 = ({ prioritySchemeFormState: prioritySchemeFormState, priorityScheme: priorityScheme, setPriorityScheme: setPriorityScheme, nameError: nameError, descriptionError: descriptionError, prioritiesError: prioritiesError, onRemovePriorityMapping: onRemovePriorityMapping })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (prioritySchemeFormState === (0, $162Uz.FAILURE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    const onPrioritiesChange = (priorities)=>{
        setPriorityScheme({
            ...priorityScheme,
            priorities: priorities
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac89428afaad1387$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac89428afaad1387$var$TabPanelDescription, null, formatMessage((0, $7LeOt.default).prioritySchemeDetailsTabPanelDescription, {
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMk9T.NameAndDescriptionView), {
        priorityScheme: priorityScheme,
        nameError: nameError,
        descriptionError: descriptionError,
        setPriorityScheme: setPriorityScheme,
        isDisabled: prioritySchemeFormState !== (0, $162Uz.DEFAULT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ISro.default), {
        error: prioritiesError,
        onChange: onPrioritiesChange,
        priorities: priorityScheme.priorities,
        onRemovePriorityMapping: onRemovePriorityMapping
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac89428afaad1387$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac89428afaad1387$var$TabPanelDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7LeOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a7594ed5b80501$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $34a7594ed5b80501$var$messages = (0, $90IgZ.defineMessages)({
    prioritySchemeDetailsTabPanelDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priority-scheme-details-tab-panel-description",
        "defaultMessage": "Enter details of the new priority scheme and select <b>Projects</b> to associate it with projects. You can also change the default priority for this scheme here."
    }
});
var $34a7594ed5b80501$export$2e2bcd8739ae039 = $34a7594ed5b80501$var$messages;

});

parcelRegister("iMk9T", function(module, exports) {

$parcel$export(module.exports, "NameAndDescriptionView", () => $e68c99af48117184$export$875156032d036e5a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");

var $hI5oG = parcelRequire("hI5oG");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $7SIkE = parcelRequire("7SIkE");
const $e68c99af48117184$export$875156032d036e5a = ({ priorityScheme: priorityScheme, setPriorityScheme: setPriorityScheme, nameError: nameError, descriptionError: descriptionError, isDisabled: isDisabled = false })=>{
    const isDefaultScheme = priorityScheme.isDefault ?? false;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const nameFieldIsInvalid = nameError !== '';
    const descriptionFieldIsInvalid = descriptionError !== '';
    const onChangeNameField = (e)=>{
        const nameFieldValue = e.currentTarget.value;
        setPriorityScheme({
            ...priorityScheme,
            name: nameFieldValue
        });
    };
    const onChangeDescriptionField = (e)=>{
        const descriptionFieldValue = e.currentTarget.value;
        setPriorityScheme({
            ...priorityScheme,
            description: descriptionFieldValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$NameAndDescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$FieldTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $7SIkE.default).prioritySchemeNameFieldTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$AsteriskWrapper, null, "*"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_NAME_AND_DESCRIPTION_FIELDS_SELECTOR),
        name: (0, $162Uz.PRIORITY_SCHEME_NAME_FIELD),
        label: formatMessage((0, $7SIkE.default).prioritySchemeNameFieldTitle),
        isRequired: true,
        isDisabled: isDefaultScheme || isDisabled,
        defaultValue: priorityScheme.name ?? '',
        placeholder: formatMessage((0, $7SIkE.default).prioritySchemeNameFieldPlaceholder),
        maxLength: (0, $162Uz.MAX_NAME_LENGTH),
        isInvalid: nameFieldIsInvalid,
        onChange: onChangeNameField
    }), nameFieldIsInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_NAME_FIELD_VALIDATION_ERROR_SELECTOR)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-live": "polite"
    }, nameError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e68c99af48117184$var$FieldTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $7SIkE.default).prioritySchemeDescriptionFieldTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_NAME_AND_DESCRIPTION_FIELDS_SELECTOR),
        name: (0, $162Uz.PRIORITY_SCHEME_DESCRIPTION_FIELD),
        label: formatMessage((0, $7SIkE.default).prioritySchemeDescriptionFieldTitle),
        isDisabled: isDefaultScheme || isDisabled,
        defaultValue: priorityScheme.description ?? '',
        placeholder: formatMessage((0, $7SIkE.default).prioritySchemeDescriptionFieldPlaceholder),
        maxLength: (0, $162Uz.MAX_DESCRIPTION_LENGTH),
        isInvalid: descriptionFieldIsInvalid,
        onChange: onChangeDescriptionField
    }), descriptionFieldIsInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
        testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_DESC_FIELD_VALIDATION_ERROR_SELECTOR)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-live": "polite"
    }, descriptionError))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e68c99af48117184$var$FieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e68c99af48117184$var$FieldTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e68c99af48117184$var$AsteriskWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvv77o _syaz1ick",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e68c99af48117184$var$NameAndDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("7SIkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c05bdf38203490$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $79c05bdf38203490$var$messages = (0, $90IgZ.defineMessages)({
    prioritySchemeNameFieldPlaceholder: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-name-field-placeholder",
        "defaultMessage": "Give this priority scheme a unique name"
    },
    prioritySchemeDescriptionFieldPlaceholder: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-description-field-placeholder",
        "defaultMessage": "Add more details to identify this scheme"
    },
    prioritySchemeNameFieldTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-name-field-title",
        "defaultMessage": "Name"
    },
    prioritySchemeDescriptionFieldTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-description-field-title",
        "defaultMessage": "Description"
    }
});
var $79c05bdf38203490$export$2e2bcd8739ae039 = $79c05bdf38203490$var$messages;

});


parcelRegister("4ISro", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc654d645baa4b6e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $5p8cx = parcelRequire("5p8cx");

var $irbrC = parcelRequire("irbrC");

var $df4RB = parcelRequire("df4RB");

var $9JFvO = parcelRequire("9JFvO");

var $ajNqe = parcelRequire("ajNqe");
const $dc654d645baa4b6e$var$PICKER_PAGE_SIZE = 8;
const $dc654d645baa4b6e$var$emptyInitialPage = {
    items: [],
    currentPage: 0,
    pageSize: $dc654d645baa4b6e$var$PICKER_PAGE_SIZE,
    totalItems: 0
};
function $dc654d645baa4b6e$export$2e2bcd8739ae039({ onChange: onChange, priorities: priorities, error: error, onRemovePriorityMapping: onRemovePriorityMapping }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isPickerOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isPickerLoading, setIsPickerLoading] = (0, $eUqFw.useState)(false);
    const [pickerFilter, setPickerFilter] = (0, $eUqFw.useState)(''); // okay, this is a bit of a hack, but we need to keep track of the picker items in a ref
    // so that we can use the latest version of the items in the loadMore method
    // with useEffect loadMore will allways use captured version of pickerItems and not the latest one
    const [, setPickerItemsVersion] = (0, $eUqFw.useState)(0);
    const pickerItems = (0, $eUqFw.useRef)($dc654d645baa4b6e$var$emptyInitialPage);
    const setPickerItems = (items)=>{
        pickerItems.current = items; // we need to update the version to force a re-render
        setPickerItemsVersion((v)=>v + 1);
    };
    const selectedIds = (0, $eUqFw.useMemo)(()=>{
        const ids = {};
        priorities.forEach((p)=>{
            ids[p.id] = true;
        });
        return ids;
    }, [
        priorities
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // here we remove the selected priorities from the picker items
        // so that they don't appear in the picker
        const currentItems = pickerItems.current.items;
        const filteredItems = currentItems.filter((p)=>!selectedIds[p.id]);
        if (filteredItems.length === currentItems.length) // no changes, so we don't need to update the picker items
        // otherwise we can end up with an infinite loop of useEffects
        return;
        setPickerItems({
            ...pickerItems.current,
            pageSize: $dc654d645baa4b6e$var$PICKER_PAGE_SIZE,
            // we should reduce the totalItems by the number of selected priorities that were removed from the picker items
            // we are also using Math.max here to avoid some weird edge cases and UI with negative numbers
            totalItems: Math.max(pickerItems.current.totalItems - (currentItems.length - filteredItems.length), 0),
            items: filteredItems
        });
    }, [
        selectedIds,
        pickerItems
    ]);
    const onRemove = (priority)=>{
        if (onRemovePriorityMapping) onRemovePriorityMapping(priority.id);
        const newPriorities = priorities.filter((p)=>p.id !== priority.id);
        if (priority.isDefault && newPriorities.length) // there should always be a default priority, so if the previous default was removed we make the first one default
        newPriorities[0] = {
            ...newPriorities[0],
            isDefault: true
        };
        onChange(newPriorities);
    };
    const onSetDefault = (priority)=>{
        onChange(priorities.map((p)=>({
                ...p,
                isDefault: p.id === priority.id
            })));
    };
    const fetch = async (filter)=>{
        try {
            const page = await (0, $df4RB.fetchAvailablePriorities)(filter, 0, $dc654d645baa4b6e$var$PICKER_PAGE_SIZE, Object.keys(selectedIds));
            if (filter !== pickerFilter) // if the filter has changed since we started fetching, we don't want to update the items
            return;
            setPickerItems(page);
        } catch (e) {
        // in the future we might want to show an error message
        }
        setIsPickerLoading(false);
    };
    const [debouncedFetch] = (0, $2jdHI.default)(fetch, 300);
    const onLoadMore = async (filter, exclude)=>{
        setIsPickerLoading(true);
        try {
            const page = await (0, $df4RB.fetchAvailablePriorities)(filter, pickerItems.current.currentPage + 1, $dc654d645baa4b6e$var$PICKER_PAGE_SIZE, exclude, Object.keys(selectedIds));
            if (filter !== pickerFilter) // if the filter has changed since we started fetching, we don't want to update the items
            return;
             // for different reasons, the API can return priorities that are already in the picker items
            // so we need to filter them out, otherwise we will have duplicates in the picker
            const alreadyLoadedItems = {};
            pickerItems.current.items.forEach((p)=>{
                alreadyLoadedItems[p.id] = true;
            });
            setPickerItems({
                ...page,
                items: [
                    ...pickerItems.current.items,
                    ...page.items.filter((p)=>!alreadyLoadedItems[p.id])
                ]
            });
        } catch (e) {
        // in the future we might want to show an error message
        }
        setIsPickerLoading(false);
    };
    const onSelect = ({ id: id, iconUrl: iconUrl, name: name, sequence: sequence })=>{
        if (selectedIds[id]) return;
        const newPriorities = [
            ...priorities,
            // if it's the first priority in the list, make it the default
            {
                id: id,
                iconUrl: iconUrl,
                name: name,
                isDefault: priorities.length === 0,
                sequence: sequence
            }
        ];
        newPriorities.sort((a, b)=>a.sequence - b.sequence);
        if (pickerItems.current.items.length <= 2 && !isPickerLoading && pickerItems.current.totalItems > $dc654d645baa4b6e$var$PICKER_PAGE_SIZE) // user is running out of available priorities,
        // and there are more available priorities to load
        // so lets load the next page in advance
        onLoadMore(pickerFilter, newPriorities.map((p)=>p.id));
        onChange(newPriorities);
    };
    const onPickerOpen = ()=>{
        setIsOpen(true); // we should always reset the available priorities when the picker is opened
        // otherwise we can miss some priorites that have been removed
        setPickerItems($dc654d645baa4b6e$var$emptyInitialPage);
        setPickerFilter('');
        setIsPickerLoading(true); // we are using fetch here instead of debouncedFetch because we want to fetch the first page immediately
        fetch('');
    };
    const onPickerClose = ()=>{
        setIsOpen(false);
        setPickerItems($dc654d645baa4b6e$var$emptyInitialPage);
        setPickerFilter('');
    };
    const onFilterChange = (value)=>{
        setPickerFilter(value);
        setIsPickerLoading(true); // we should always reset the available priorities when the filter changes
        setPickerItems($dc654d645baa4b6e$var$emptyInitialPage); // any filter change should be debounced to avoid unnecessary API calls
        debouncedFetch(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $ajNqe.default).prioritiesLabel),
        name: "priorities",
        isRequired: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_PRIORITIES_FIELD_VALIDATION_ERROR_SELECTOR)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "aria-live": "polite"
        }, error)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JFvO.default), {
            onRemove: onRemove,
            onSetDefault: onSetDefault,
            priorities: priorities
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc654d645baa4b6e$var$PickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $irbrC.default), {
            showCheckboxes: false,
            selectedPriorityIds: null,
            renderTrigger: formatMessage((0, $ajNqe.default).addPrioritiesToggle),
            isLoading: isPickerLoading,
            filter: pickerFilter,
            onSelect: onSelect,
            onLoadMore: ()=>onLoadMore(pickerFilter, Object.keys(selectedIds)),
            onFilterChange: onFilterChange,
            page: pickerItems.current,
            onOpen: onPickerOpen,
            onClose: onPickerClose,
            isOpen: isPickerOpen,
            testId: (0, $5p8cx.PRIORITY_SCHEME_MODAL_PRIORITY_PICKER_DROPDOWN_MENU_SELECTOR)
        }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc654d645baa4b6e$var$PickerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("9JFvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f056be91f0a31a$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $je5kZ = parcelRequire("je5kZ");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $adX3f = parcelRequire("adX3f");

var $5Amvv = parcelRequire("5Amvv");
const $e2f056be91f0a31a$var$Row = ({ priority: priority, onRemove: onRemove, onSetDefault: onSetDefault })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const defaultControl = priority.isDefault ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e2f056be91f0a31a$var$lozengeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $adX3f.default).defaultPriorityLozenge))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f056be91f0a31a$var$SetDefaultWrapper, {
        "data-control": "set-default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "compact",
        onClick: ()=>onSetDefault(priority)
    }, formatMessage((0, $5Amvv.default).setAsDefaultButton)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f056be91f0a31a$var$RowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        label: priority.name,
        size: "xsmall",
        src: priority.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, priority.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f056be91f0a31a$var$ActionsWrapper, null, defaultControl, onRemove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "compact",
        title: formatMessage((0, $5Amvv.default).removePriorityButton),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: ""
        }),
        onClick: ()=>onRemove(priority)
    })));
};
function $e2f056be91f0a31a$export$2e2bcd8739ae039({ priorities: priorities, onRemove: onRemove, onSetDefault: onSetDefault }) {
    const onRemovePriority = priorities.length > 1 ? onRemove : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, priorities.map((priority)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f056be91f0a31a$var$Row, {
            key: priority.id,
            priority: priority,
            onSetDefault: onSetDefault,
            onRemove: onRemovePriority
        })));
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2f056be91f0a31a$var$RowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahv2br _4cvr1h6o _2lx2vrvc _19ith6cr _1yt41bs6 _otyru2gc _2rko1y44 _13bpkb7n _dxh9idpf _1mspu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2f056be91f0a31a$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _2lx2vrvc _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2f056be91f0a31a$var$SetDefaultWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_gc16idpf _1o7akb7n",
            __cmplp.className
        ])
    });
});
const $e2f056be91f0a31a$var$lozengeWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.150'
});

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});

parcelRegister("adX3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $95edaff544d3f9ad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $95edaff544d3f9ad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultPriorityLozenge: {
        "id": "admin-pages-priority-schemes.common.default-priority-lozenge",
        "defaultMessage": "Default"
    }
});

});

parcelRegister("5Amvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8876614a7a0d5540$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $8876614a7a0d5540$var$messages = (0, $90IgZ.defineMessages)({
    setAsDefaultButton: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.list.set-as-default-button",
        "defaultMessage": "Set as default"
    },
    removePriorityButton: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.list.remove-priority-button",
        "defaultMessage": "Remove priority"
    }
});
var $8876614a7a0d5540$export$2e2bcd8739ae039 = $8876614a7a0d5540$var$messages;

});


parcelRegister("ajNqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5755f4466a7ec89f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5755f4466a7ec89f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    prioritiesLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.priorities-label",
        "defaultMessage": "Priorities"
    },
    addPrioritiesToggle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.priorities.add-priorities-toggle",
        "defaultMessage": "Select priorities"
    }
});

});



parcelRegister("5H02x", function(module, exports) {

$parcel$export(module.exports, "ProjectPicker", () => $89ac257dd39720fc$export$a4519235a2ef9605);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hEmKQ = parcelRequire("hEmKQ");

var $dRJbS = parcelRequire("dRJbS");

var $8o4vK = parcelRequire("8o4vK");
const $89ac257dd39720fc$export$a4519235a2ef9605 = ({ currentCountForAssociatedProjects: currentCountForAssociatedProjects, filter: filter, onFetch: onFetch, onToggleAllProjects: onToggleAllProjects, onToggleProject: onToggleProject, newCountForAssociatedProjects: newCountForAssociatedProjects, page: page, pendingChanges: pendingChanges, priorityScheme: priorityScheme, selectAllChecked: selectAllChecked, state: state })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89ac257dd39720fc$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89ac257dd39720fc$var$TabPanelDescription, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $hEmKQ.default).projectsTabPanelInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $hEmKQ.default).projectsTabPanelDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8o4vK.SearchWithFilter), {
        currentCountForAssociatedProjects: currentCountForAssociatedProjects,
        newCountForAssociatedProjects: newCountForAssociatedProjects,
        filter: filter,
        onFetch: onFetch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRJbS.ProjectPickerContent), {
        filter: filter,
        onFetch: onFetch,
        onInputChange: onToggleProject,
        onSelectAllInputChange: onToggleAllProjects,
        page: page,
        pendingChanges: pendingChanges,
        priorityScheme: priorityScheme,
        selectAllChecked: selectAllChecked,
        state: state
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89ac257dd39720fc$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1fez",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89ac257dd39720fc$var$TabPanelDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hEmKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eaca8f1c6ddbcd4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $2eaca8f1c6ddbcd4$var$messages = (0, $90IgZ.defineMessages)({
    projectsTabPanelInstruction: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.projects-tab-panel-instruction",
        "defaultMessage": "Select the projects to associate with this priority scheme."
    },
    projectsTabPanelDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.projects-tab-panel-description",
        "defaultMessage": "Associating projects with this new scheme will remove projects from their existing schemes. You may have to select new priorities for issues in these projects."
    }
});
var $2eaca8f1c6ddbcd4$export$2e2bcd8739ae039 = $2eaca8f1c6ddbcd4$var$messages;

});

parcelRegister("dRJbS", function(module, exports) {

$parcel$export(module.exports, "ProjectPickerContent", () => $c54b8dcad7829d99$export$dfcca05acbafd86e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iJlfe = parcelRequire("iJlfe");

var $bT7k5 = parcelRequire("bT7k5");

var $3KPTt = parcelRequire("3KPTt");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $2eG9N = parcelRequire("2eG9N");

var $9VPEO = parcelRequire("9VPEO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $162Uz = parcelRequire("162Uz");

var $lJQSK = parcelRequire("lJQSK");

var $iA6pe = parcelRequire("iA6pe");

var $8HOj5 = parcelRequire("8HOj5");
const $c54b8dcad7829d99$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: "retry-button",
                onClick: ()=>onRetry({})
            }, formatMessage((0, $8HOj5.messages).retry))
        ],
        title: formatMessage((0, $8HOj5.messages).errorTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8HOj5.messages).errorMessage)));
};
const $c54b8dcad7829d99$export$3b0d6d7590275603 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "28px",
        width: "532px"
    }));
const $c54b8dcad7829d99$export$d10c05fcf2d72bfe = (props)=>{
    const { avatarUrl: avatarUrl, checked: checked, disabled: disabled, id: id, isDefaultPriorityScheme: isDefaultPriorityScheme, name: name, onChange: onChange, projectStyle: projectStyle, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$ProjectCheckbox, {
        checked: checked,
        disabled: disabled,
        isAssociatedWithDefaultScheme: isDefaultPriorityScheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$SelectedBorder, {
        checked: checked,
        disabled: disabled,
        isAssociatedWithDefaultScheme: isDefaultPriorityScheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        checked: checked,
        disabled: disabled,
        id: id,
        name: name,
        onChange: (event)=>onChange({
                ...props,
                checked: event.target.checked
            }),
        type: "checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: name,
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$PrimaryDescription, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$SecondaryDescription, null, projectStyle === (0, $lJQSK.ProjectStyleForInput).CMP ? formatMessage((0, $8HOj5.messages).companyManagedProject) : formatMessage((0, $8HOj5.messages).teamManagedProject)))));
};
const $c54b8dcad7829d99$export$c4e70261e22d6dfe = ({ checked: checked, disabled: disabled, indeterminate: indeterminate, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleChange = (event)=>{
        const { target: { checked: isChecked } } = event;
        onChange(isChecked);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$SelectAllCheckbox, {
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$SelectedBorder, {
        checked: checked,
        disabled: disabled,
        isAssociatedWithDefaultScheme: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: checked,
        isDisabled: disabled,
        isIndeterminate: indeterminate,
        onChange: handleChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$SelectAllCheckboxLabel, null, formatMessage((0, $8HOj5.messages).selectAll))
    }));
};
const $c54b8dcad7829d99$export$29352359ffded387 = ({ filter: filter, onFetch: onFetch, onInputChange: onInputChange, onSelectAllInputChange: onSelectAllInputChange, page: page, pendingChanges: pendingChanges, priorityScheme: priorityScheme, selectAllChecked: selectAllChecked, tooltipDelay: tooltipDelay, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createSchemeAllProjectsFilterInfo: createSchemeAllProjectsFilterInfo, editSchemeAllProjectsFilterInfo: editSchemeAllProjectsFilterInfo, existingProjectsFilterInfo: existingProjectsFilterInfo, maxSelectionLimit: maxSelectionLimit, paginationNextLabel: paginationNextLabel, paginationPageLabel: paginationPageLabel, paginationPreviousLabel: paginationPreviousLabel, paginationSummary: paginationSummary, projectIsAssociatedWithDefaultScheme: projectIsAssociatedWithDefaultScheme, projectIsAssociatedWithScheme: projectIsAssociatedWithScheme } = (0, $8HOj5.messages);
    const { projectFilterChoice: projectFilterChoice } = filter;
    const { currentPage: currentPage, items: items, totalItems: totalItems, pageSize: pageSize } = page;
    const { name: name, isDefault: isDefault } = priorityScheme; // Pagination
    const { startRow: startRow, endRow: endRow } = (0, $iA6pe.calculateRowsOnPage)({
        rowsPerPage: pageSize,
        selectedPage: currentPage,
        totalRows: totalItems
    });
    const pageCount = Math.ceil(totalItems / pageSize);
    const pages = Array.from({
        length: pageCount
    }, (_, index)=>index + 1);
    const handleChange = (_event, selectedPage)=>{
        onFetch({
            selectedPage: selectedPage
        });
    }; // Select All Option
    const availableOptions = items.filter((project)=>!project.disabled);
    const availableOptionCount = availableOptions.length;
    const isEveryOptionDisabled = items.every((project)=>project.disabled);
    const selectedOptionCount = availableOptions.filter(({ checked: checked })=>checked).length;
    const validOptionRemainingCount = availableOptions.filter(({ id: id })=>!(id in pendingChanges)).length;
    const isSelectAllDisabled = isEveryOptionDisabled || Object.values(pendingChanges).length + validOptionRemainingCount > (0, $162Uz.PROJECT_PICKER_PENDING_CHANGES_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS ? `${name ? formatMessage(editSchemeAllProjectsFilterInfo, {
        schemeName: name
    }) : formatMessage(createSchemeAllProjectsFilterInfo)}` : formatMessage(existingProjectsFilterInfo, {
        schemeName: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$Options, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$c4e70261e22d6dfe, {
        checked: selectAllChecked,
        disabled: isSelectAllDisabled,
        indeterminate: selectedOptionCount > 0 && selectedOptionCount < availableOptionCount,
        onChange: onSelectAllInputChange
    }), items.map((item)=>item.disabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: isDefault ? formatMessage(projectIsAssociatedWithDefaultScheme) : formatMessage(maxSelectionLimit),
            key: item.id,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$d10c05fcf2d72bfe, {
            isDefaultPriorityScheme: isDefault,
            onChange: onInputChange,
            testId: testId,
            ...item
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS && item.isAssociatedWithScheme && formatMessage(projectIsAssociatedWithScheme),
            key: item.id,
            delay: tooltipDelay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$d10c05fcf2d72bfe, {
            isDefaultPriorityScheme: isDefault,
            onChange: onInputChange,
            testId: testId,
            ...item
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
        max: pageSize,
        nextLabel: formatMessage(paginationNextLabel),
        label: formatMessage(paginationPageLabel),
        onChange: handleChange,
        pageLabel: formatMessage(paginationPageLabel),
        pages: pages,
        previousLabel: formatMessage(paginationPreviousLabel),
        selectedIndex: currentPage - 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$var$Summary, null, formatMessage(paginationSummary, {
        startRow: startRow,
        endRow: endRow,
        totalRows: totalItems
    })));
};
const $c54b8dcad7829d99$export$dfcca05acbafd86e = ({ filter: filter, onFetch: onFetch, onInputChange: onInputChange, onSelectAllInputChange: onSelectAllInputChange, page: page, pendingChanges: pendingChanges, priorityScheme: priorityScheme, selectAllChecked: selectAllChecked, state: state })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { projectFilterChoice: projectFilterChoice, query: query } = filter;
    const { items: items } = page;
    if (state === (0, $lJQSK.ProjectPickerState).LOADING) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$3b0d6d7590275603, null);
    if (state === (0, $lJQSK.ProjectPickerState).ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$edf27be85e5f6da0, {
        onRetry: onFetch
    });
    const noProjectsInJira = !items.length && !query && projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS;
    if (noProjectsInJira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8HOj5.messages).noProjectsInJira));
    const noSearchResultsFound = !items.length && query;
    if (noSearchResultsFound) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8HOj5.messages).noSearchResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c54b8dcad7829d99$export$29352359ffded387, {
        filter: filter,
        onFetch: onFetch,
        onInputChange: onInputChange,
        onSelectAllInputChange: onSelectAllInputChange,
        page: page,
        pendingChanges: pendingChanges,
        priorityScheme: priorityScheme,
        selectAllChecked: selectAllChecked
    });
};
const $c54b8dcad7829d99$var$layoutStyles = {
    alignItems: 'center',
    display: 'flex',
    gap: `${"var(--ds-space-100, 8px)"}`
};
const $c54b8dcad7829d99$var$checkboxStyles = {
    ...$c54b8dcad7829d99$var$layoutStyles,
    borderBottom: `${"var(--ds-space-025, 2px)"} solid ${"var(--ds-border, #091E4224)"}`,
    height: `${"var(--ds-space-500, 40px)"}`,
    width: '100%'
};
const $c54b8dcad7829d99$var$columnLayoutStyles = {
    ...$c54b8dcad7829d99$var$layoutStyles,
    flexDirection: 'column'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c54b8dcad7829d99$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _zulpu2gc _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$Options = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _otyru2gc _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$PrimaryDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1gjq _k48pni7l",
            __cmplp.className
        ])
    });
});
const $c54b8dcad7829d99$var$getProjectCheckboxBackgroundColor = (checked, disabled, isAssociatedWithDefaultScheme)=>{
    let backgroundColor;
    if (disabled || isAssociatedWithDefaultScheme && checked) backgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    else if (checked) backgroundColor = "var(--ds-background-accent-blue-subtlest, #E9F2FF)";
    else backgroundColor = 'transparent';
    return backgroundColor;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$ProjectCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAssociatedWithDefaultScheme: isAssociatedWithDefaultScheme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1inmo1d": (0, $9t7rW.default)($c54b8dcad7829d99$var$getProjectCheckboxBackgroundColor(__cmplp.checked, __cmplp.disabled, __cmplp.isAssociatedWithDefaultScheme))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _zulpu2gc _n7zl176a _4t3i1jfw _1bsb1osq _bfhks346 _l6pq1n0e _1eq11h6o _15pj1txw _dlecu2gc _xw2dze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$SecondaryDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
const $c54b8dcad7829d99$var$getSelectAllCheckboxBackgroundColor = (checked, disabled)=>{
    let backgroundColor;
    if (disabled) backgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    else if (checked) backgroundColor = "var(--ds-background-accent-blue-subtlest, #E9F2FF)";
    else backgroundColor = 'transparent';
    return backgroundColor;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$SelectAllCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_mq3c6g": (0, $9t7rW.default)($c54b8dcad7829d99$var$getSelectAllCheckboxBackgroundColor(__cmplp.checked, __cmplp.disabled))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _zulpu2gc _n7zl176a _4t3i1jfw _1bsb1osq _bfhk1nrw _gk8j1h6o _dlecu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$SelectAllCheckboxLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _k48pni7l",
            __cmplp.className
        ])
    });
});
const $c54b8dcad7829d99$var$getSelectedBorderBackgroundColor = (checked, disabled, isAssociatedWithDefaultScheme)=>{
    let backgroundColor;
    if (disabled || isAssociatedWithDefaultScheme && checked) backgroundColor = "var(--ds-border-disabled, #091E420F)";
    else if (checked) backgroundColor = "var(--ds-border-selected, #0C66E4)";
    else backgroundColor = 'transparent';
    return backgroundColor;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$SelectedBorder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAssociatedWithDefaultScheme: isAssociatedWithDefaultScheme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1llz33t": (0, $9t7rW.default)($c54b8dcad7829d99$var$getSelectedBorderBackgroundColor(__cmplp.checked, __cmplp.disabled, __cmplp.isAssociatedWithDefaultScheme))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3mk9 _4t3i1jfw _1bsbv77o",
            __cmplp.checked || __cmplp.disabled || __cmplp.isAssociatedWithDefaultScheme ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c54b8dcad7829d99$var$Summary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1gjq _11c81vlj _18s8ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $5Mzgj = parcelRequire("5Mzgj");

var $2C9cn = parcelRequire("2C9cn");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
const $52d6d0a6ee26c024$var$navigatorIconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.075'
});
function $52d6d0a6ee26c024$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($5Mzgj))) : (0, (/*@__PURE__*/$parcel$interopDefault($2C9cn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $52d6d0a6ee26c024$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("5Mzgj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435cc9c581f97870$var$_react = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $435cc9c581f97870$var$_chevronLeft = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("a4cVy")));

var $435cc9c581f97870$var$_chevronLeftLarge = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("dXKde")));
function $435cc9c581f97870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435cc9c581f97870$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $435cc9c581f97870$var$_react.default.createElement($435cc9c581f97870$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $435cc9c581f97870$var$_chevronLeftLarge.default
    }, props));
$435cc9c581f97870$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $435cc9c581f97870$var$_default = module.exports.default = $435cc9c581f97870$var$ChevronLeftIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});


parcelRegister("2C9cn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e764405146a3983$var$_react = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1e764405146a3983$var$_chevronRight = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("fCmfi")));

var $1e764405146a3983$var$_chevronRightLarge = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("dwj4T")));
function $1e764405146a3983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e764405146a3983$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $1e764405146a3983$var$_react.default.createElement($1e764405146a3983$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $1e764405146a3983$var$_chevronRightLarge.default
    }, props));
$1e764405146a3983$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $1e764405146a3983$var$_default = module.exports.default = $1e764405146a3983$var$ChevronRightIcon;

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});


parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $73a5c9d720aa66e1$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8HOj5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ae18d8d7e224da2f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ae18d8d7e224da2f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectIsAssociatedWithDefaultScheme: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.project-is-associated-with-default-scheme",
        "defaultMessage": "Projects can\u2019t be removed from the default scheme but they can be added to other schemes."
    },
    projectIsAssociatedWithScheme: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.project-is-associated-with-scheme",
        "defaultMessage": "This project is already associated with the scheme."
    },
    maxSelectionLimit: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.max-selection-limit",
        "defaultMessage": "You\u2019ve selected 100 projects. Save your changes or remove projects to select more."
    },
    noSearchResults: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.no-search-results",
        "defaultMessage": "We couldn\u2019t find what you\u2019re looking for. Try searching for another project."
    },
    noProjectsInJira: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.no-projects-in-jira",
        "defaultMessage": "You don\u2019t have any projects in this Jira instance. "
    },
    errorTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.error-title",
        "defaultMessage": "We couldn\u2019t load your projects"
    },
    errorMessage: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.error-message",
        "defaultMessage": "Check your connection and try again."
    },
    retry: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.retry",
        "defaultMessage": "Try again"
    },
    selectAll: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.select-all",
        "defaultMessage": "Select all"
    },
    paginationNextLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-next-label",
        "defaultMessage": "Next"
    },
    paginationPageLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-page-label",
        "defaultMessage": "Page"
    },
    paginationPreviousLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-previous-label",
        "defaultMessage": "Previous"
    },
    paginationSummary: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-summary",
        "defaultMessage": "Showing {startRow} - {endRow} of {totalRows, plural, one {# project} other {# projects}}"
    },
    createSchemeAllProjectsFilterInfo: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.create-scheme-all-projects-filter-info",
        "defaultMessage": "View all projects in your Jira instance and select those you want to associate with the scheme"
    },
    editSchemeAllProjectsFilterInfo: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.edit-scheme-all-projects-filter-info",
        "defaultMessage": "View all projects in your Jira instance and select those you want to associate with the scheme \"{schemeName}\"."
    },
    existingProjectsFilterInfo: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.existing-projects-filter-info",
        "defaultMessage": "View projects that are already associated with the scheme \u201C{schemeName}\u201D."
    },
    companyManagedProject: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.company-managed-project",
        "defaultMessage": "Company-managed project"
    },
    teamManagedProject: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.team-managed-project",
        "defaultMessage": "Team-managed project"
    }
});

});


parcelRegister("8o4vK", function(module, exports) {

$parcel$export(module.exports, "SearchWithFilter", () => $c3ac20a2196dbb17$export$96e6f70fd9f522af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $5k4ch = parcelRequire("5k4ch");

var $dsroq = parcelRequire("dsroq");

var $ffiyv = parcelRequire("ffiyv");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lJQSK = parcelRequire("lJQSK");

var $h1HkS = parcelRequire("h1HkS");
const $c3ac20a2196dbb17$export$96e6f70fd9f522af = ({ currentCountForAssociatedProjects: // Lozenge value for "Existing projects" dropdown item
currentCountForAssociatedProjects, filter: filter, onFetch: onFetch })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { query: query, projectFilterChoice: projectFilterChoice } = filter;
    const handleChange = (event)=>{
        const updatedQuery = event.target.value;
        onFetch({
            query: updatedQuery
        });
    };
    const handleClick = (event)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const updatedProjectFilterChoice = event.currentTarget.title;
        if (projectFilterChoice !== updatedProjectFilterChoice) onFetch({
            projectFilterChoice: updatedProjectFilterChoice
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        onChange: handleChange,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: formatMessage((0, $h1HkS.messages).searchFieldSearchIconLabel),
            size: "small"
        }),
        elemAfterInput: query && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            onClick: ()=>onFetch({
                    query: ''
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
            label: formatMessage((0, $h1HkS.messages).searchFieldClearSearchIconLabel),
            size: "small"
        })),
        placeholder: formatMessage((0, $h1HkS.messages).searchFieldPlaceholder),
        value: query
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: projectFilterChoice
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$Highlight, {
        selected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$SelectedBorder, {
        selected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        description: formatMessage((0, $h1HkS.messages).allProjectsFilterDescription),
        isSelected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS,
        onClick: handleClick,
        shouldDescriptionWrap: true,
        title: (0, $lJQSK.ProjectFilterChoice).ALL_PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$Content, null, formatMessage((0, $h1HkS.messages).allProjectsFilter)))), currentCountForAssociatedProjects > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$Highlight, {
        selected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ASSOCIATED_PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$SelectedBorder, {
        selected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ASSOCIATED_PROJECTS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        description: formatMessage((0, $h1HkS.messages).existingProjectsFilterDescription),
        isSelected: projectFilterChoice === (0, $lJQSK.ProjectFilterChoice).ASSOCIATED_PROJECTS,
        onClick: handleClick,
        shouldDescriptionWrap: true,
        title: (0, $lJQSK.ProjectFilterChoice).ASSOCIATED_PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ac20a2196dbb17$var$Content, null, formatMessage((0, $h1HkS.messages).existingProjectsFilter), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "admin-pages-priority-schemes.ui.priority-scheme-modal.project-picker.search-with-filter.existing-projects-count"
    }, currentCountForAssociatedProjects)))))));
};
const $c3ac20a2196dbb17$var$layoutStyles = {
    display: 'flex',
    gap: `${"var(--ds-space-100, 8px)"}`,
    justifyContent: 'space-between'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3ac20a2196dbb17$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _1bah1yb4 _4t3ixy5q _otyru2gc _k49uglyw _1lg6glyw _1bb6u2gc _1sdc1qr7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3ac20a2196dbb17$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3ac20a2196dbb17$var$Highlight = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_lcsh06": (0, $9t7rW.default)(__cmplp.selected && `${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"}`),
            "--_zyy9g6": (0, $9t7rW.default)(__cmplp.selected && `${"var(--ds-text-selected, #0C66E4)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _8piv1q20 _1095g5is",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3ac20a2196dbb17$var$SelectedBorder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1yqz _1e0c1ule _1bsbv77o",
            __cmplp.selected ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});


parcelRegister("h1HkS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $da966801ac7dd68f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $da966801ac7dd68f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchFieldPlaceholder: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-placeholder",
        "defaultMessage": "Search projects"
    },
    searchFieldSearchIconLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-search-icon-label",
        "defaultMessage": "Search projects"
    },
    searchFieldClearSearchIconLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-clear-search-icon-label",
        "defaultMessage": "Clear search"
    },
    allProjectsFilter: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.all-projects-filter",
        "defaultMessage": "All projects"
    },
    allProjectsFilterDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.all-projects-filter-description",
        "defaultMessage": "All projects in the Jira instance"
    },
    existingProjectsFilter: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.existing-projects-filter",
        "defaultMessage": "Existing projects"
    },
    existingProjectsFilterDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.existing-projects-filter-description",
        "defaultMessage": "Existing projects in the scheme"
    }
});

});



parcelRegister("4FmMB", function(module, exports) {

$parcel$export(module.exports, "calculatePrioritiesDiff", () => $f43e8d52414360ac$export$ad1df5b789a21b99);
$parcel$export(module.exports, "calculateProjectsDiff", () => $f43e8d52414360ac$export$78304b5c72117d0a);
$parcel$export(module.exports, "savePrioritySchemeRequest", () => $f43e8d52414360ac$export$2280bf3b9d5dc8fb);
$parcel$export(module.exports, "handleApiValidationErrors", () => $f43e8d52414360ac$export$f85ded83335ac2c0);
$parcel$export(module.exports, "generateScreenEventMeta", () => $f43e8d52414360ac$export$26fa969a77662872);
$parcel$export(module.exports, "fireSaveAnalyticsEvent", () => $f43e8d52414360ac$export$6daf9f3eff738058);
$parcel$export(module.exports, "mapPriorityMappingsToRequestMappings", () => $f43e8d52414360ac$export$ea60c4e57afd4b33);

var $jMP2a = parcelRequire("jMP2a");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $75OeO = parcelRequire("75OeO");

var $7ml9d = parcelRequire("7ml9d");
const $f43e8d52414360ac$var$getDefaultPriorityId = (priorities)=>priorities.find(({ isDefault: isDefault })=>isDefault)?.id || '';
const $f43e8d52414360ac$export$ad1df5b789a21b99 = (existingPriorities, newPriorities)=>{
    const add = [];
    const remove = [];
    const existingPriorityIds = {};
    const newPriorityIds = {};
    newPriorities.forEach(({ id: id })=>{
        newPriorityIds[id] = true;
    });
    existingPriorities.forEach(({ id: id })=>{
        existingPriorityIds[id] = true;
    });
    newPriorities.forEach(({ id: id })=>{
        if (!existingPriorityIds[id]) add.push(id);
    });
    existingPriorities.forEach(({ id: id })=>{
        if (!newPriorityIds[id]) remove.push(id);
    });
    return {
        add: add,
        remove: remove
    };
};
const $f43e8d52414360ac$export$78304b5c72117d0a = (changes)=>{
    const pendingProjectIds = Object.keys(changes);
    const add = pendingProjectIds.filter((projectId)=>changes[projectId]);
    const remove = pendingProjectIds.filter((projectId)=>!changes[projectId]);
    return {
        add: add,
        remove: remove
    };
};
const $f43e8d52414360ac$export$3a31db41062647d0 = (priorityScheme, projectsDiff)=>({
        name: priorityScheme.name,
        description: priorityScheme.description,
        priorityIds: priorityScheme.priorities.map(({ id: id })=>id),
        defaultPriorityId: $f43e8d52414360ac$var$getDefaultPriorityId(priorityScheme.priorities),
        projectIds: projectsDiff.add
    });
const $f43e8d52414360ac$export$a3b674382336b0fd = (priorityScheme, prioritiesDiff, projectsDiff)=>({
        name: priorityScheme.name,
        description: priorityScheme.description,
        priorities: {
            add: {
                ids: prioritiesDiff.add
            },
            remove: {
                ids: prioritiesDiff.remove
            }
        },
        defaultPriorityId: $f43e8d52414360ac$var$getDefaultPriorityId(priorityScheme.priorities),
        projects: {
            add: {
                ids: projectsDiff.add
            },
            remove: {
                ids: projectsDiff.remove
            }
        }
    });
const $f43e8d52414360ac$export$2280bf3b9d5dc8fb = (priorityScheme, prioritiesDiff, projectsDiff, mappings)=>{
    let createParams = $f43e8d52414360ac$export$3a31db41062647d0(priorityScheme, projectsDiff);
    let editParams = $f43e8d52414360ac$export$a3b674382336b0fd(priorityScheme, prioritiesDiff, projectsDiff);
    if (mappings) {
        createParams = {
            ...createParams,
            mappings: mappings
        };
        editParams = {
            ...editParams,
            mappings: mappings
        };
    }
    return priorityScheme.id ? (0, $7ml9d.editPrioritySchemeRequest)(priorityScheme.id, editParams) : (0, $75OeO.createPrioritySchemeRequest)(createParams);
};
const $f43e8d52414360ac$export$f85ded83335ac2c0 = (response, setAPIValidationError)=>{
    let hasKnownErrors = false;
    response.errors.forEach(({ field: field, message: message })=>{
        if (field === (0, $162Uz.PRIORITY_SCHEME_NAME_FIELD)) {
            setAPIValidationError((fields)=>({
                    ...fields,
                    name: message
                }));
            hasKnownErrors = true;
        } else if (field === (0, $162Uz.PRIORITY_SCHEME_DESCRIPTION_FIELD)) {
            setAPIValidationError((fields)=>({
                    ...fields,
                    description: message
                }));
            hasKnownErrors = true;
        }
    });
    if (!hasKnownErrors) // there are only unknown validation errors that we can't properly show in the UI
    // so we are falling back to our "unknown error" flow
    throw new Error('unexpected error');
};
const $f43e8d52414360ac$export$26fa969a77662872 = (priorityScheme)=>{
    const isCreateScheme = !priorityScheme.id;
    const SCREEN_ANALYTICS_EVENT_SOURCE_NAME = isCreateScheme ? (0, $5p8cx.ADD_PRIORITY_SCHEME_MODAL_SOURCE_NAME) : (0, $5p8cx.EDIT_PRIORITY_SCHEME_MODAL_SOURCE_NAME);
    const attributes = isCreateScheme ? {} : {
        prioritySchemeId: priorityScheme.id,
        priorities: priorityScheme.priorities.map(({ id: id })=>id),
        prioritySchemePriorityCount: priorityScheme.priorities.length,
        prioritySchemeHasDescription: Boolean(priorityScheme.description),
        prioritySchemeProjects: priorityScheme.projects.values.map(({ id: id })=>id),
        prioritySchemeProjectsCount: priorityScheme.projects.total
    };
    return {
        attributes: attributes,
        sourceName: SCREEN_ANALYTICS_EVENT_SOURCE_NAME
    };
};
const $f43e8d52414360ac$var$generateProjectsMetaForTrackEvent = (existingProjects, existingProjectsCount, projectsDiff)=>{
    const existingProjectIds = existingProjects.map(({ id: id })=>id);
    let prioritySchemeProjects = existingProjectIds;
    let prioritySchemeProjectsCount = existingProjectsCount;
    const { add: add, remove: remove } = projectsDiff;
    if (remove.length > 0) {
        prioritySchemeProjects = prioritySchemeProjects.filter((id)=>!remove.includes(id));
        prioritySchemeProjectsCount -= remove.length;
    }
    if (add.length > 0) {
        prioritySchemeProjects = [
            ...prioritySchemeProjects,
            ...add
        ];
        prioritySchemeProjectsCount += add.length;
    }
    return {
        prioritySchemeProjects: prioritySchemeProjects,
        prioritySchemeProjectsCount: prioritySchemeProjectsCount
    };
};
const $f43e8d52414360ac$var$generateTrackEventMeta = (initialPriorityScheme, priorityScheme, createdPrioritySchemeId, projectsDiff)=>{
    const actionSubjectAndAction = !priorityScheme.id ? `${(0, $5p8cx.addPrioritySchemeTrackEvent).actionSubject} ${(0, $5p8cx.addPrioritySchemeTrackEvent).action}` : `${(0, $5p8cx.editPrioritySchemeTrackEvent).actionSubject} ${(0, $5p8cx.editPrioritySchemeTrackEvent).action}`;
    const actionSubjectId = !priorityScheme.id ? (0, $5p8cx.addPrioritySchemeTrackEvent).actionSubjectId : (0, $5p8cx.editPrioritySchemeTrackEvent).actionSubjectId;
    const attributes = {
        prioritySchemeId: priorityScheme.id ?? createdPrioritySchemeId,
        priorities: priorityScheme.priorities.map(({ id: id })=>id),
        prioritySchemePriorityCount: priorityScheme.priorities.length,
        prioritySchemeHasDescription: Boolean(priorityScheme.description),
        ...!priorityScheme.id ? {
            prioritySchemeProjects: projectsDiff.add,
            prioritySchemeProjectsCount: projectsDiff.add.length
        } : $f43e8d52414360ac$var$generateProjectsMetaForTrackEvent(initialPriorityScheme.projects.values, initialPriorityScheme.projects.total, projectsDiff)
    };
    return {
        actionSubjectAndAction: actionSubjectAndAction,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
const $f43e8d52414360ac$export$6daf9f3eff738058 = (createAnalyticsEvent, initialScheme, priorityScheme, createdPrioritySchemeId, projectsDiff)=>{
    const { actionSubjectAndAction: actionSubjectAndAction, actionSubjectId: actionSubjectId, attributes: attributes } = $f43e8d52414360ac$var$generateTrackEventMeta(initialScheme, priorityScheme, createdPrioritySchemeId, projectsDiff);
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, actionSubjectId, attributes);
};
const $f43e8d52414360ac$export$ea60c4e57afd4b33 = (inMappings, outMappings)=>{
    const mapToRequestMappingArray = (mappings)=>{
        const results = {};
        Object.entries(mappings).forEach(([fromPriorityId, toPriority])=>{
            results[Number(fromPriorityId)] = Number(toPriority.id);
        });
        return results;
    };
    return {
        in: mapToRequestMappingArray(inMappings),
        out: mapToRequestMappingArray(outMappings)
    };
};

});
parcelRegister("75OeO", function(module, exports) {

$parcel$export(module.exports, "createPrioritySchemeRequest", () => $1fa6302aa95839d3$export$740a7d2316d3096c);

var $9wVV1 = parcelRequire("9wVV1");
const $1fa6302aa95839d3$export$740a7d2316d3096c = async (requestParams)=>{
    try {
        const URL = '/rest/api/2/priorityscheme';
        const response = await (0, $9wVV1.fetchWithStatus)(URL, {
            method: 'POST',
            body: JSON.stringify(requestParams)
        });
        const responseData = (0, $9wVV1.refineCreatePrioritySchemeResponse)(response);
        if (!responseData) return {
            isSuccess: false
        };
        if (responseData.status === 202) return {
            isSuccess: true,
            isMigrationPending: true,
            data: responseData.body
        };
        return {
            isSuccess: true,
            isMigrationPending: false,
            data: responseData.body
        };
    } catch (error) {
        const fetchError = await (0, $9wVV1.refineFetchError)(error);
        if (fetchError) {
            const { statusCode: statusCode, responseJson: responseJson } = fetchError;
            const body = responseJson;
            if (statusCode === 400) {
                const validationErrors = (0, $9wVV1.refineValidationError)(body);
                if (validationErrors) return {
                    isSuccess: false,
                    errors: validationErrors
                };
            }
        }
        throw error;
    }
};

});

parcelRegister("7ml9d", function(module, exports) {

$parcel$export(module.exports, "editPrioritySchemeRequest", () => $a872cb9d8a938129$export$4ef926e558bd8172);

var $9wVV1 = parcelRequire("9wVV1");
const $a872cb9d8a938129$export$4ef926e558bd8172 = async (schemeId, requestParams)=>{
    try {
        const URL = `/rest/api/2/priorityscheme/${schemeId}`;
        const response = await (0, $9wVV1.fetchWithStatus)(URL, {
            method: 'PUT',
            body: JSON.stringify(requestParams)
        });
        const responseData = (0, $9wVV1.refineEditPrioritySchemeResponse)(schemeId, response);
        if (!responseData) return {
            isSuccess: false
        };
        if ('task' in responseData.body) return {
            isSuccess: true,
            isMigrationPending: true,
            data: responseData.body
        };
        return {
            isSuccess: true,
            isMigrationPending: false,
            data: responseData.body
        };
    } catch (error) {
        const fetchError = await (0, $9wVV1.refineFetchError)(error);
        if (fetchError) {
            const { statusCode: statusCode, responseJson: responseJson } = fetchError;
            const body = responseJson;
            if (statusCode === 400) {
                const validationErrors = (0, $9wVV1.refineValidationError)(body);
                if (validationErrors) return {
                    isSuccess: false,
                    errors: validationErrors
                };
            }
        }
        throw error;
    }
};

});



parcelRegister("1jagA", function(module, exports) {

$parcel$export(module.exports, "MappingModalView", () => $9ff383b88c6c7d0a$export$1df09452360de90f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $dXKde = parcelRequire("dXKde");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $3KPTt = parcelRequire("3KPTt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iA6pe = parcelRequire("iA6pe");

var $haHzQ = parcelRequire("haHzQ");

var $3HPQe = parcelRequire("3HPQe");
const $9ff383b88c6c7d0a$export$1df09452360de90f = ({ isError: isError, isDisabled: isDisabled, isLoading: isLoading, modalTitle: modalTitle, modalDescription: modalDescription, mappings: mappings, mappablePriorities: mappablePriorities, onUpdateMapping: onUpdateMapping, page: page, onFetch: onFetch, onPreviousStep: onPreviousStep, renderPrimaryButton: renderPrimaryButton })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { currentPage: currentPage, items: items, totalItems: totalItems, pageSize: pageSize } = page;
    const { startRow: startRow, endRow: endRow } = (0, $iA6pe.calculateRowsOnPage)({
        rowsPerPage: pageSize,
        selectedPage: currentPage,
        totalRows: totalItems
    });
    const renderMappingListContent = ()=>{
        if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "error"
        }, formatMessage((0, $3HPQe.default).mappingModalUnexpectedErrorTitle));
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $9ff383b88c6c7d0a$var$loadingMappingListContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "xlarge"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haHzQ.MappingList), {
            priorities: items,
            mappablePriorities: mappablePriorities,
            onUpdateMapping: onUpdateMapping,
            mappings: mappings
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ff383b88c6c7d0a$var$MappingTitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: isDisabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: formatMessage((0, $3HPQe.default).mappingModalReturnModalButtonLabel)
        }),
        onClick: onPreviousStep
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, modalDescription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.200",
        backgroundColor: "elevation.surface.sunken",
        xcss: $9ff383b88c6c7d0a$var$mappingTableBoxContainerStyles
    }, renderMappingListContent()), !isError && totalItems && totalItems > pageSize && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ff383b88c6c7d0a$var$MappingTablePaginationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
        nextLabel: formatMessage((0, $3HPQe.default).mappingModalPaginationNextButtonLabel),
        label: formatMessage((0, $3HPQe.default).mappingModalPaginationWrapperLabel),
        pageLabel: formatMessage((0, $3HPQe.default).mappingModalPaginationPageLabel),
        pages: Array.from({
            length: Math.ceil(totalItems / pageSize)
        }, (_, i)=>i + 1),
        previousLabel: formatMessage((0, $3HPQe.default).mappingModalPaginationPreviousButtonLabel),
        onChange: onFetch,
        selectedIndex: page.currentPage - 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ff383b88c6c7d0a$var$MappingTablePaginationSummary, null, formatMessage((0, $3HPQe.default).mappingModalPaginatorSummary, {
        startRow: startRow,
        endRow: endRow,
        totalRows: totalItems
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onPreviousStep,
        isDisabled: isDisabled
    }, formatMessage((0, $3HPQe.default).mappingModalFooterBack)), renderPrimaryButton()));
};
const $9ff383b88c6c7d0a$var$mappingTableBoxContainerStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    marginTop: 'space.150',
    /**
   * This height is the height of the mapping list box with the max amount of rows which is 8,
   * 586 = 554 (div height) + 16 (padding top) + 16 (padding top)
   */ minHeight: '586px'
});
const $9ff383b88c6c7d0a$var$loadingMappingListContainerStyles = (0, $1ZAYh.xcss)({
    display: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    /**
   * This height is the height of the mapping list box with the max amount of rows which is 8,
   * this div does not include the padding so = 554.
   */ minHeight: '554px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ff383b88c6c7d0a$var$MappingTitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpd7fw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ff383b88c6c7d0a$var$MappingTablePaginationSummary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ff383b88c6c7d0a$var$MappingTablePaginationContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("haHzQ", function(module, exports) {

$parcel$export(module.exports, "MappingList", () => $2ef7c7165af2e11a$export$e82e0908843dd951);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jfj6c = parcelRequire("jfj6c");

var $36ANT = parcelRequire("36ANT");

var $2JbCG = parcelRequire("2JbCG");
const $2ef7c7165af2e11a$var$MappingRow = ({ priority: priority, mappablePriorities: mappablePriorities, mappings: mappings, onUpdateMapping: onUpdateMapping })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingCurrentPriorityRowCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.PriorityIconContainer), {
        src: priority.iconUrl,
        alt: priority.name
    }), priority.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingTableArrowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: formatMessage((0, $2JbCG.default).mappingTableArrowIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36ANT.MappingPicker), {
        selectedPriority: mappings[priority.id] ? mappings[priority.id] : null,
        mappablePriorities: mappablePriorities,
        setSelectedPriority: (newPriority)=>onUpdateMapping(priority.id, newPriority)
    }));
};
const $2ef7c7165af2e11a$export$e82e0908843dd951 = ({ priorities: priorities, mappablePriorities: mappablePriorities, mappings: mappings, onUpdateMapping: onUpdateMapping })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingListContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingListHeaders, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingCurrentPriorityRowHeaderCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JbCG.default).mappingModalCurrentPriorityHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingNewPriorityRowHeaderCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JbCG.default).mappingModalNewPriorityHeading)))), priorities.map((priority, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ef7c7165af2e11a$var$MappingRow, {
            key: index,
            priority: priority,
            mappablePriorities: mappablePriorities,
            mappings: mappings,
            onUpdateMapping: onUpdateMapping
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ef7c7165af2e11a$var$MappingListContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ef7c7165af2e11a$var$MappingListHeaders = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _2lx2vrvc _4t3i1jfw _n7zl1on0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ef7c7165af2e11a$var$MappingRowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _2lx2vrvc _4t3ixncg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ef7c7165af2e11a$var$MappingCurrentPriorityRowCellContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1w81 _19bv1ejb _zulp1b66",
            __cmplp.className
        ])
    });
});
const $2ef7c7165af2e11a$var$MappingCurrentPriorityRowHeaderCellContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1w81 _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $2ef7c7165af2e11a$var$MappingNewPriorityRowHeaderCellContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbbn52 _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $2ef7c7165af2e11a$var$MappingTableArrowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("36ANT", function(module, exports) {

$parcel$export(module.exports, "MappingPicker", () => $91f3d79319c03e70$export$8b1ea4e645434634);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $irbrC = parcelRequire("irbrC");

var $jfj6c = parcelRequire("jfj6c");


var $3VIKl = parcelRequire("3VIKl");
const $91f3d79319c03e70$export$8b1ea4e645434634 = ({ selectedPriority: selectedPriority, mappablePriorities: mappablePriorities, setSelectedPriority: setSelectedPriority, pickerPageSize: pickerPageSize = (0, $e272fd5397becb39$export$950baf168f4d0418), defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const mappablePriorityWithSelectedPriorityFiltered = mappablePriorities.filter((priority)=>priority.id !== selectedPriority?.id);
    const intialPage = {
        items: mappablePriorityWithSelectedPriorityFiltered.slice(0, pickerPageSize),
        currentPage: 1,
        pageSize: pickerPageSize,
        totalItems: mappablePriorityWithSelectedPriorityFiltered.length
    };
    const [page, setPage] = (0, $eUqFw.useState)(intialPage);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultOpen);
    const [pickerFilter, setPickerFilter] = (0, $eUqFw.useState)('');
    const onOpen = ()=>{
        setIsOpen(true);
        setPage(intialPage);
        setPickerFilter('');
    };
    const onClose = ()=>{
        setIsOpen(false);
        setPage(intialPage);
        setPickerFilter('');
    };
    const onLoadMore = ()=>{
        const { currentPage: currentPage } = page;
        setPage({
            ...page,
            items: mappablePriorityWithSelectedPriorityFiltered.slice(0, (currentPage + 1) * pickerPageSize),
            currentPage: currentPage + 1,
            pageSize: pickerPageSize,
            totalItems: mappablePriorityWithSelectedPriorityFiltered.length
        });
    };
    const onFilterChange = (value)=>{
        setPickerFilter(value);
        const filteredList = mappablePriorityWithSelectedPriorityFiltered.filter((priority)=>priority.name.toLowerCase().includes(value.toLowerCase()));
        setPage({
            items: filteredList.slice(0, pickerPageSize),
            currentPage: 1,
            pageSize: pickerPageSize,
            totalItems: filteredList.length
        });
    };
    const onSelect = (priorityOption)=>{
        /**
     * Reconstructing priority here to deal with priorityOption type which is
     * used by the picker -> consider make it just priority
     *
     * If not, things to consider, if we care about the default priority being
     * selected in the future we can reconstruct it from mappablePriorities list.
     */ setSelectedPriority({
            ...priorityOption,
            isDefault: false
        });
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91f3d79319c03e70$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $irbrC.default), {
        showCheckboxes: false,
        selectedPriorityIds: null,
        isOpen: isOpen,
        renderTrigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                onClick: ()=>isOpen ? onClose() : onOpen(),
                ref: triggerRef,
                shouldFitContainer: true
            }, selectedPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91f3d79319c03e70$var$MappingDropdownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.PriorityIconContainer), {
                src: selectedPriority.iconUrl,
                alt: selectedPriority.name
            }), selectedPriority.name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: formatMessage((0, $3VIKl.default).mappingModalDropdownChevronDownIconLabel)
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91f3d79319c03e70$var$MappingDropdownContainer, null, formatMessage((0, $3VIKl.default).mappingModalDropdownMenuTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: formatMessage((0, $3VIKl.default).mappingModalDropdownChevronDownIconLabel)
            }))),
        isLoading: false,
        filter: pickerFilter,
        onSelect: onSelect,
        onLoadMore: onLoadMore,
        onFilterChange: onFilterChange,
        page: page,
        onOpen: onOpen,
        onClose: onClose
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f3d79319c03e70$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbbn52 _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f3d79319c03e70$var$MappingDropdownContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3VIKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5fc6d5b1848b409$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c5fc6d5b1848b409$var$messages = (0, $90IgZ.defineMessages)({
    mappingModalDropdownMenuTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-picker.mapping-modal-dropdown-menu-title",
        "defaultMessage": "Select priority"
    },
    mappingModalDropdownChevronDownIconLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-picker.mapping-modal-dropdown-chevron-down-icon-label",
        "defaultMessage": "priority scheme mapping chevron down"
    }
});
var $c5fc6d5b1848b409$export$2e2bcd8739ae039 = $c5fc6d5b1848b409$var$messages;

});


parcelRegister("2JbCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5adc9c72af872c7e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5adc9c72af872c7e$var$messages = (0, $90IgZ.defineMessages)({
    mappingModalCurrentPriorityHeading: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-current-priority-heading",
        "defaultMessage": "Current priority"
    },
    mappingModalNewPriorityHeading: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-new-priority-heading",
        "defaultMessage": "New priority"
    },
    mappingTableArrowIcon: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-table-arrow-icon",
        "defaultMessage": "chevron left to right icon"
    },
    mappingModalDropdownMenuTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-dropdown-menu-title",
        "defaultMessage": "Select priority"
    }
});
var $5adc9c72af872c7e$export$2e2bcd8739ae039 = $5adc9c72af872c7e$var$messages;

});


parcelRegister("3HPQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a0a489953303f8b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $7a0a489953303f8b$var$messages = (0, $90IgZ.defineMessages)({
    mappingModalFooterBack: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-footer-back",
        "defaultMessage": "Back"
    },
    mappingModalPaginatorSummary: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-paginator-summary",
        "defaultMessage": "Showing {startRow} - {endRow} of {totalRows, plural, one {# priority scheme} other {# priority schemes}}"
    },
    mappingModalReturnModalButtonLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-return-modal-button-label",
        "defaultMessage": "go back icon"
    },
    mappingModalPaginationNextButtonLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-next-button-label",
        "defaultMessage": "Next"
    },
    mappingModalPaginationWrapperLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-wrapper-label",
        "defaultMessage": "Pagination"
    },
    mappingModalPaginationPageLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-page-label",
        "defaultMessage": "Page"
    },
    mappingModalPaginationPreviousButtonLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-pagination-previous-button-label",
        "defaultMessage": "Page"
    },
    mappingModalUnexpectedErrorTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-modal-unexpected-error-title",
        "defaultMessage": "Unexpected Error"
    }
});
var $7a0a489953303f8b$export$2e2bcd8739ae039 = $7a0a489953303f8b$var$messages;

});


parcelRegister("akBi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3909758193956bba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $3909758193956bba$var$messages = (0, $90IgZ.defineMessages)({
    mappingModalTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-title",
        "defaultMessage": "Select new priorities"
    },
    mappingModalAddSchemeDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-add-scheme-description",
        "defaultMessage": "Some issues in the projects you\u2019ve selected use priorities that aren\u2019t available in the \u201C{schemeName}\u201D scheme."
    },
    mappingModalSelectNewPrioritiesDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-select-new-priorities-description",
        "defaultMessage": "Select new priorities to replace the current ones. {learnMoreLink}"
    },
    mappingModalLearnMoreLink: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-learn-more-link",
        "defaultMessage": "Learn more"
    },
    mappingModalEditSchemeDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description",
        "defaultMessage": "You\u2019re updating the \u201C{schemeName}\u201D scheme with projects and priorities, and some issues use priorities that aren\u2019t available in the projects. This may be due to the following reasons:"
    },
    mappingModalEditSchemeAddProjectsListItemOne: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-add-projects-list-item-one",
        "defaultMessage": "You\u2019re adding projects that have previously associated priorities to this scheme"
    },
    mappingModalEditSchemeDescriptionRemoveProjectsListItemOne: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description-remove-projects-list-item-one",
        "defaultMessage": "You\u2019re removing some priorities that were previously associated with this scheme"
    },
    mappingModalEditSchemeDescriptionRemoveProjectsListItemTwo: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description-remove-projects-list-item-two",
        "defaultMessage": "You\u2019re removing projects from this scheme and they\u2019ll be associated with the \u201Cdefault priority scheme\u201D"
    },
    mappingModalNextButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-next-button-title",
        "defaultMessage": "Next"
    },
    mappingModalSaveButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-save-button-title",
        "defaultMessage": "Save"
    },
    mappingModalAddSchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-add-scheme-button-title",
        "defaultMessage": "Add scheme"
    },
    mappingModalBackButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-back-button-title",
        "defaultMessage": "Back"
    },
    addPrioritySchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.add-priority-scheme-button-title",
        "defaultMessage": "Add scheme"
    },
    editPrioritySchemeButtonTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.edit-priority-scheme-button-title",
        "defaultMessage": "Save"
    }
});
var $3909758193956bba$export$2e2bcd8739ae039 = $3909758193956bba$var$messages;

});

parcelRegister("cS51P", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemeShowFlags", () => $e41e3698d7bd2ecd$export$1692d35514f12614);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $iQNnu = parcelRequire("iQNnu");
const $e41e3698d7bd2ecd$export$1692d35514f12614 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const getActions = (0, $eUqFw.useCallback)((schemeName)=>({
            actions: [
                {
                    content: (0, $iQNnu.default).viewPrioritySchemesAction,
                    href: `/jira/settings/issues/priority-schemes?schemeName=${schemeName}`
                }
            ]
        }), []);
    const createSchemeSuccessFlag = (0, $eUqFw.useMemo)(()=>({ schemeName: schemeName, schemeId: schemeId })=>({
                type: 'success',
                id: `priority-scheme-create-success-flag-${schemeId}`,
                testId: 'admin-pages-priority-schemes-priority-scheme-modal.create-scheme-flag',
                title: [
                    (0, $iQNnu.default).createdSchemeTitle,
                    {
                        name: schemeName
                    }
                ],
                isAutoDismiss: true,
                ...getActions(schemeName)
            }), [
        getActions
    ]);
    const editSchemeSuccessFlag = ({ schemeName: schemeName, schemeId: schemeId })=>({
            type: 'success',
            id: `priority-scheme-edit-success-flag-${schemeId}`,
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.edit-scheme-flag',
            title: (0, $iQNnu.default).editedSchemeTitle,
            description: [
                (0, $iQNnu.default).editedSchemeDescription,
                {
                    name: schemeName
                }
            ],
            isAutoDismiss: true,
            ...getActions(schemeName)
        });
    const createSchemeAsyncSuccessFlag = ({ schemeId: schemeId })=>({
            type: 'success',
            id: `priority-scheme-async-create-flag-${schemeId}`,
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.create-scheme-async-flag',
            title: (0, $iQNnu.default).longRequestCreateTitle,
            description: (0, $iQNnu.default).longRequestDescription,
            isAutoDismiss: true
        });
    const editSchemeAsyncSuccessFlag = ({ schemeId: schemeId })=>({
            type: 'success',
            id: `priority-scheme-async-edit-flag-${schemeId}`,
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.edit-scheme-async-flag',
            title: (0, $iQNnu.default).longRequestEditTitle,
            description: (0, $iQNnu.default).longRequestDescription,
            isAutoDismiss: true
        });
    const showSuccessFlag = (flagData, isCreatingNewScheme)=>{
        const flagConfig = isCreatingNewScheme ? createSchemeSuccessFlag(flagData) : editSchemeSuccessFlag(flagData);
        showFlag(flagConfig);
    };
    const showAsyncSuccessFlag = (flagData, isCreatingNewScheme)=>{
        const flagConfig = isCreatingNewScheme ? createSchemeAsyncSuccessFlag(flagData) : editSchemeAsyncSuccessFlag(flagData);
        showFlag(flagConfig);
    };
    const showUnexpectedErrorFlag = (isCreatingNewScheme)=>{
        const flagConfig = {
            type: 'error',
            id: 'priority-scheme-unexpected-error-flag',
            testId: 'admin-pages-priority-schemes-priority-scheme-modal.unexpected-error-flag',
            title: isCreatingNewScheme ? (0, $iQNnu.default).unexpectedCreateErrorTitle : (0, $iQNnu.default).unexpectedEditErrorTitle,
            description: (0, $iQNnu.default).unexpectedErrorBodyMessage,
            isAutoDismiss: true
        };
        showFlag(flagConfig);
    };
    return {
        showSuccessFlag: showSuccessFlag,
        showAsyncSuccessFlag: showAsyncSuccessFlag,
        showUnexpectedErrorFlag: showUnexpectedErrorFlag
    };
};

});
parcelRegister("iQNnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $29ebe37a09f24163$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $29ebe37a09f24163$var$messages = (0, $90IgZ.defineMessages)({
    longRequestCreateTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-create-title",
        "defaultMessage": "We're adding your priority scheme"
    },
    longRequestEditTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-edit-title",
        "defaultMessage": "We're updating your priority scheme"
    },
    longRequestDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.long-request-description",
        "defaultMessage": "This may take a while. You can edit schemes when this is completed."
    },
    createdSchemeTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.created-scheme-title",
        "defaultMessage": "Priority scheme {name} added"
    },
    editedSchemeTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.edited-scheme-title",
        "defaultMessage": "Priority scheme updated"
    },
    editedSchemeDescription: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.edited-scheme-description",
        "defaultMessage": "We\u2019ve updated the priority scheme \"{name}\""
    },
    successIconLabel: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.success-icon-label",
        "defaultMessage": "Success"
    },
    unexpectedCreateErrorTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-create-error-title",
        "defaultMessage": "We couldn't add the scheme"
    },
    unexpectedEditErrorTitle: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-edit-error-title",
        "defaultMessage": "We couldn't update the scheme"
    },
    unexpectedErrorBodyMessage: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.unexpected-error-body-message",
        "defaultMessage": "Refresh the page and try again."
    },
    viewPrioritySchemesAction: {
        "id": "admin-pages-priority-schemes.priority-scheme-modal.modal-flags.view-priority-schemes-action",
        "defaultMessage": "View priority scheme"
    }
});
var $29ebe37a09f24163$export$2e2bcd8739ae039 = $29ebe37a09f24163$var$messages;

});



parcelRegister("eVWKA", function(module, exports) {

$parcel$export(module.exports, "PrioritySchemesHeader", () => $66eef0f2f6004efe$export$250268bcdcedc517);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2eG9N = parcelRequire("2eG9N");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $f9dS3 = parcelRequire("f9dS3");

var $1wrt1 = parcelRequire("1wrt1");
const $66eef0f2f6004efe$export$7e27efbf7f6693b = ({ isDisabled: isDisabled, onAddScheme: onAddScheme })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: isDisabled,
        onClick: onAddScheme,
        testId: (0, $5p8cx.ADD_PRIORITY_SCHEME_BUTTON_SELECTOR)
    }, formatMessage((0, $1wrt1.messages).addPriorityScheme));
};
const $66eef0f2f6004efe$export$d8abb7a1cfbd4b6b = ({ children: children, isLocked: isLocked, limitSchemes: limitSchemes, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isLocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $1wrt1.messages).isLockedTooltip),
        delay: tooltipDelay
    }, children);
    if (limitSchemes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        testId: (0, $5p8cx.ADD_PRIORITY_SCHEME_BUTTON_LIMIT_EXCEEDED_TOOLTIP_SELECTOR),
        content: formatMessage((0, $1wrt1.messages).isHardLimitTooltip, {
            count: (0, $162Uz.PRIORITY_SCHEMES_HARD_LIMIT)
        }),
        delay: tooltipDelay
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $66eef0f2f6004efe$export$250268bcdcedc517 = ({ hasError: hasError, isLoading: isLoading, isLocked: isLocked, limitSchemes: limitSchemes, onAddScheme: onAddScheme })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isButtonDisabled = isLoading || isLocked || limitSchemes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66eef0f2f6004efe$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        actions: !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66eef0f2f6004efe$export$d8abb7a1cfbd4b6b, {
            isLocked: isLocked,
            limitSchemes: limitSchemes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66eef0f2f6004efe$export$7e27efbf7f6693b, {
            isDisabled: isButtonDisabled,
            onAddScheme: onAddScheme
        }))
    }, formatMessage((0, $1wrt1.messages).title)), !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9dS3.HeaderDescription), null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66eef0f2f6004efe$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1i7v1oud",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("f9dS3", function(module, exports) {

$parcel$export(module.exports, "HeaderDescription", () => $4e34eda24bf7ee3d$export$9cbca4161ff10154);

var $eUqFw = parcelRequire("eUqFw");

var $3x4sL = parcelRequire("3x4sL");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $5p8cx = parcelRequire("5p8cx");

var $iz4Ol = parcelRequire("iz4Ol");
const $4e34eda24bf7ee3d$var$ARTICLE_ID = 'YzlOU0xe92Dnzhz8yXfz6';
const $4e34eda24bf7ee3d$export$1861ee29fc9bca35 = 'https://support.atlassian.com/jira-cloud-administration/docs/manage-priority-schemes/';
const $4e34eda24bf7ee3d$var$FallbackHelpLink = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $4e34eda24bf7ee3d$export$1861ee29fc9bca35,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $iz4Ol.messages).learnMoreLink));
};
const $4e34eda24bf7ee3d$export$9cbca4161ff10154 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": (0, $5p8cx.LEARN_MORE_LINK_SELECTOR)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                    appearance: "link",
                    spacing: "none",
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e34eda24bf7ee3d$var$FallbackHelpLink, null),
                    articleId: $4e34eda24bf7ee3d$var$ARTICLE_ID,
                    onClick: (_event, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $5p8cx.inProductHelpButtonForPrioritySchemesUIEvent).actionSubjectId);
                    }
                }, children)
        },
        message: formatMessage((0, $iz4Ol.messages).prioritySchemesDescription, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $iz4Ol.messages).defaultPrioritySchemeDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $iz4Ol.messages).findPrioritiesDescription)));
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("iz4Ol", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8953e2cedd62be8e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8953e2cedd62be8e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    prioritySchemesDescription: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.header-description.priority-schemes-description",
        "defaultMessage": "Associate a priority or a group of priorities with your projects. You can choose a different set of priorities for your projects by using priority schemes. {linkStart}Learn more about priority schemes{linkEnd}."
    },
    learnMoreLink: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.header-description.learn-more-link",
        "defaultMessage": "Learn more about priority schemes"
    },
    defaultPrioritySchemeDescription: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.header-description.default-priority-scheme-description",
        "defaultMessage": "If you haven\u2019t associated any project with a priority scheme, a default priority scheme will be associated to the project."
    },
    findPrioritiesDescription: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.header-description.find-priorities-description",
        "defaultMessage": "You can find your priorities faster by their name or associated projects."
    }
});

});


parcelRegister("1wrt1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a719896a895885be$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a719896a895885be$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.title",
        "defaultMessage": "Priority schemes"
    },
    addPriorityScheme: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.add-priority-scheme",
        "defaultMessage": "Add priority scheme"
    },
    isLockedTooltip: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.is-locked-tooltip",
        "defaultMessage": "We\u2019re updating a priority scheme and you can edit priority schemes after we\u2019re done."
    },
    isHardLimitTooltip: {
        "id": "admin-pages-priority-schemes.priority-schemes-header.is-hard-limit-tooltip",
        "defaultMessage": "You cannot add more than {count, plural, one {# priority scheme} other {# priority schemes}}."
    }
});

});


parcelRegister("5xxMu", function(module, exports) {

$parcel$export(module.exports, "PrioritySchemesTable", () => $0c3a59fab996c789$export$13bf0f4f10b472c4);

var $eUqFw = parcelRequire("eUqFw");

var $clqWl = parcelRequire("clqWl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $162Uz = parcelRequire("162Uz");

var $jfj6c = parcelRequire("jfj6c");

var $iA6pe = parcelRequire("iA6pe");

var $3JWkt = parcelRequire("3JWkt");

var $c5Zyx = parcelRequire("c5Zyx");
const $0c3a59fab996c789$export$13bf0f4f10b472c4 = ({ isLoading: isLoading, isLocked: isLocked, onEditScheme: onEditScheme, setDeleteModalOpen: setDeleteModalOpen, onFetch: onFetch, page: page })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { currentPage: currentPage, items: items, totalItems: totalItems } = page;
    const { startRow: startRow, endRow: endRow } = (0, $iA6pe.calculateRowsOnPage)({
        rowsPerPage: (0, $162Uz.TABLE_ROWS_PER_PAGE_LIMIT),
        selectedPage: currentPage,
        totalRows: totalItems
    });
    const { head: head, rows: rows } = (0, $c5Zyx.usePrioritySchemesTable)({
        isLocked: isLocked,
        onEditScheme: onEditScheme,
        setDeleteModalOpen: setDeleteModalOpen,
        prioritySchemes: items
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.TableContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
        testId: "admin-pages-priority-schemes.ui.priority-schemes-table.dynamic-table-stateless",
        head: head,
        emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", null, formatMessage((0, $3JWkt.messages).noSearchResults)),
        rows: rows,
        rowsPerPage: (0, $162Uz.TABLE_ROWS_PER_PAGE_LIMIT),
        totalRows: totalItems,
        isFixedSize: true,
        isLoading: isLoading,
        page: currentPage,
        onSetPage: onFetch
    }), !isLoading && totalItems > 0 && startRow <= totalItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $3JWkt.messages).paginatorSummary, {
        startRow: startRow,
        endRow: endRow,
        totalRows: totalItems
    })));
};

});
parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $7cd2847e492d5dd4$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5Q9wj.default), onSort: providedOnSort = (0, $5Q9wj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5Q9wj.default), onRankEnd: providedOnRankEnd = (0, $5Q9wj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    const onSort = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $fVXMO.validateSortKey)(sortKey, head);
        (0, $fVXMO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
        isLoading: isLoading,
        spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7BSAY")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTable;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: $1430aaf59e7cbeab$var$captionStyles
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");



var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellBaseStylesModernized = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            (0, $XHGTv.fg)('design_system_team_dynamic_table_typography') ? $e23e257a0c447ed4$var$headCellBaseStylesModernized : $e23e257a0c447ed4$var$headCellBaseStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("7BSAY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aVYwg")
]).then(()=>parcelRequire('jlg4D'));

});


parcelRegister("3JWkt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $630984db610f4482$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $630984db610f4482$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.name",
        "defaultMessage": "Name"
    },
    priorities: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.priorities",
        "defaultMessage": "Priorities"
    },
    projects: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.projects",
        "defaultMessage": "Projects"
    },
    actions: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.actions",
        "defaultMessage": "Actions"
    },
    edit: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.edit",
        "defaultMessage": "Edit"
    },
    delete: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.delete",
        "defaultMessage": "Delete"
    },
    noSearchResults: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.no-search-results",
        "defaultMessage": "We couldn\u2019t find what you\u2019re looking for. Try searching for another scheme."
    },
    paginatorSummary: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.paginator-summary",
        "defaultMessage": "Showing {startRow} - {endRow} of {totalRows, plural, one {# priority scheme} other {# priority schemes}}"
    }
});

});

parcelRegister("c5Zyx", function(module, exports) {

$parcel$export(module.exports, "usePrioritySchemesTable", () => $83a1a3e2891b3ee3$export$bae64260d77f52fe);

var $eUqFw = parcelRequire("eUqFw");

var $7C66o = parcelRequire("7C66o");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5p8cx = parcelRequire("5p8cx");

var $162Uz = parcelRequire("162Uz");

var $6e37d = parcelRequire("6e37d");

var $fACH8 = parcelRequire("fACH8");

var $3JWkt = parcelRequire("3JWkt");

var $9rj5t = parcelRequire("9rj5t");

var $42Cwh = parcelRequire("42Cwh");
const $83a1a3e2891b3ee3$export$bae64260d77f52fe = ({ isLocked: isLocked, onEditScheme: onEditScheme, setDeleteModalOpen: setDeleteModalOpen, prioritySchemes: prioritySchemes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const head = {
        cells: [
            {
                key: (0, $162Uz.NAME_COLUMN_KEY),
                content: formatMessage((0, $3JWkt.messages).name),
                isSortable: false,
                width: 35
            },
            {
                key: (0, $162Uz.PRIORITIES_COLUMN_KEY),
                content: formatMessage((0, $3JWkt.messages).priorities),
                isSortable: false,
                width: 30
            },
            {
                key: (0, $162Uz.PROJECTS_COLUMN_KEY),
                content: formatMessage((0, $3JWkt.messages).projects),
                isSortable: false,
                width: 30
            },
            {
                key: (0, $162Uz.ACTIONS_COLUMN_KEY),
                content: formatMessage((0, $3JWkt.messages).actions),
                isSortable: false,
                width: 5
            }
        ]
    };
    const rows = prioritySchemes.map((priorityScheme, i)=>{
        const { id: id, name: name, description: description, priorities: priorities, projects: projects, isDefault: isDefault } = priorityScheme;
        const deleteMenuItem = {
            title: formatMessage((0, $3JWkt.messages).delete),
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent((0, $5p8cx.deletePrioritySchemeDropdownItemUIEvent)), (0, $5p8cx.deletePrioritySchemeDropdownItemUIEvent).actionSubjectId);
                setDeleteModalOpen(priorityScheme);
            }
        };
        const dropdownCellItems = [
            {
                title: formatMessage((0, $3JWkt.messages).edit),
                onClick: ()=>onEditScheme({
                        prioritySchemeId: id,
                        startingTab: (0, $162Uz.PRIORITY_SCHEME_MODAL_DETAILS_TAB_INDEX)
                    })
            }
        ];
        if (!isDefault) dropdownCellItems.push(deleteMenuItem);
        const onDropdownMenuToggle = ()=>{
            const actionsDropdownMenuUIEventWithContext = {
                ...(0, $5p8cx.actionsDropdownMenuUIEvent),
                containers: {
                    priorityScheme: {
                        id: id
                    }
                }
            };
            const actionsDropdownMenuUIEventWithAttributes = {
                prioritySchemeId: id,
                priorities: priorities.map(({ id: priorityId })=>priorityId),
                prioritySchemePriorityCount: priorities.length,
                prioritySchemeHasDescription: Boolean(description),
                prioritySchemeProjects: projects.values.map(({ id: projectId })=>projectId),
                prioritySchemeProjectsCount: projects.total
            };
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent(actionsDropdownMenuUIEventWithContext), (0, $5p8cx.actionsDropdownMenuUIEvent).actionSubjectId, actionsDropdownMenuUIEventWithAttributes);
        };
        return {
            key: `row-${i}-priority-scheme-${id}`,
            cells: [
                {
                    key: (0, $162Uz.NAME_COLUMN_KEY),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e37d.LockedCell), {
                        columnKey: (0, $162Uz.NAME_COLUMN_KEY),
                        isLocked: isLocked
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7C66o.default), {
                        scheme: {
                            id: id,
                            name: name,
                            description: description
                        }
                    }))
                },
                {
                    key: (0, $162Uz.PRIORITIES_COLUMN_KEY),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e37d.LockedCell), {
                        columnKey: (0, $162Uz.PRIORITIES_COLUMN_KEY),
                        isLocked: isLocked
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9rj5t.PriorityCell), {
                        priorities: priorities
                    }))
                },
                {
                    key: (0, $162Uz.PROJECTS_COLUMN_KEY),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e37d.LockedCell), {
                        columnKey: (0, $162Uz.PROJECTS_COLUMN_KEY),
                        isLocked: isLocked
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $42Cwh.ProjectCell), {
                        isLocked: isLocked,
                        onClick: ()=>onEditScheme({
                                prioritySchemeId: id,
                                startingTab: (0, $162Uz.PRIORITY_SCHEME_MODAL_PROJECTS_TAB_INDEX)
                            }),
                        totalCount: projects.total,
                        projects: projects.values
                    }))
                },
                {
                    key: (0, $162Uz.ACTIONS_COLUMN_KEY),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e37d.LockedCell), {
                        columnKey: (0, $162Uz.ACTIONS_COLUMN_KEY),
                        isLocked: isLocked
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fACH8.DropdownCell), {
                        isLocked: isLocked,
                        dropdownCellItems: dropdownCellItems,
                        onDropdownMenuToggle: onDropdownMenuToggle
                    }))
                }
            ]
        };
    });
    return {
        head: head,
        rows: rows
    };
};

});
parcelRegister("7C66o", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d6811e4a1ac072$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dnbhd = parcelRequire("dnbhd");
const $46d6811e4a1ac072$var$NameAndDescriptionCell = ({ scheme: scheme, getUrl: getUrl, onLinkClickHandleAnalytics: onLinkClickHandleAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46d6811e4a1ac072$var$CellWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46d6811e4a1ac072$var$NameText, null, getUrl != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: getUrl(scheme),
        // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onClick: (_, analyticsEvent)=>{
            if (onLinkClickHandleAnalytics != null) onLinkClickHandleAnalytics(analyticsEvent);
        }
    }, scheme.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, scheme.name)), scheme.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46d6811e4a1ac072$var$Description, null, scheme.description) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
var $46d6811e4a1ac072$export$2e2bcd8739ae039 = $46d6811e4a1ac072$var$NameAndDescriptionCell;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46d6811e4a1ac072$var$NameText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1q9y _y3gn1e5h _k48p8n31",
            __cmplp.className
        ])
    });
});
const $46d6811e4a1ac072$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1thw _18s8ze3t",
            __cmplp.className
        ])
    });
});
const $46d6811e4a1ac072$var$CellWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ca0qutpp _vchhusvi _4t3ioahv _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});


parcelRegister("6e37d", function(module, exports) {

$parcel$export(module.exports, "LockedCell", () => $5b1a2268f37c245c$export$794bed22233bf85a);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5p8cx = parcelRequire("5p8cx");

var $jfj6c = parcelRequire("jfj6c");

var $12pqM = parcelRequire("12pqM");
const $5b1a2268f37c245c$export$794bed22233bf85a = ({ columnKey: columnKey, isLocked: isLocked = false, children: children, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClickCapture = (event)=>event.stopPropagation();
    if (isLocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        testId: (0, $5p8cx.LOCKED_CELL_TOOLTIP_SELECTOR),
        content: formatMessage((0, $12pqM.default).migrationInfo),
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.TableCell), {
        "data-testid": `locked-cell-${columnKey}`,
        isLocked: isLocked,
        onClickCapture: handleClickCapture
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.TableCell), {
        "data-testid": `unlocked-cell-${columnKey}`
    }, children);
};

});
parcelRegister("12pqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $091c1132876c8bd7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $091c1132876c8bd7$var$messages = (0, $90IgZ.defineMessages)({
    migrationInfo: {
        "id": "admin-pages-priority-schemes.common.locked-cell.migration-info",
        "defaultMessage": "We\u2019re updating a priority scheme and you can edit priority schemes after we\u2019re done."
    }
});
var $091c1132876c8bd7$export$2e2bcd8739ae039 = $091c1132876c8bd7$var$messages;

});


parcelRegister("fACH8", function(module, exports) {

$parcel$export(module.exports, "DropdownCell", () => $ef90a7e116675479$export$765530eebef077c4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5d3HE = parcelRequire("5d3HE");
const $ef90a7e116675479$export$765530eebef077c4 = ({ isLocked: isLocked, dropdownCellItems: dropdownCellItems, onDropdownMenuToggle: onDropdownMenuToggle, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: isLocked ? formatMessage((0, $5d3HE.messages).isLockedTooltip) : formatMessage((0, $5d3HE.messages).actionsTooltip),
        position: "left",
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu",
        onOpenChange: onDropdownMenuToggle,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $5d3HE.messages).moreButtonIconLabel)
                }),
                ref: triggerRef
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, dropdownCellItems.map((e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: e.title,
            onClick: e.onClick
        }, e.title)))));
};

});
parcelRegister("5d3HE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0870bdcf7dbeafe9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0870bdcf7dbeafe9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    moreButtonIconLabel: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.more-button-icon-label",
        "defaultMessage": "more options"
    },
    actionsTooltip: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.actions-tooltip",
        "defaultMessage": "More actions for selected priority scheme"
    },
    isLockedTooltip: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.dropdown-cell.is-locked-tooltip",
        "defaultMessage": "We\u2019re updating a priority scheme and you can edit priority schemes after we\u2019re done."
    }
});

});


parcelRegister("9rj5t", function(module, exports) {

$parcel$export(module.exports, "PriorityCell", () => $9cf73b507e6f062f$export$b526cf238a0a0ab3);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jfj6c = parcelRequire("jfj6c");

var $299x2 = parcelRequire("299x2");
const $9cf73b507e6f062f$export$b526cf238a0a0ab3 = ({ priorities: priorities })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, priorities.map(({ id: id, name: name, isDefault: isDefault, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.CellItem), {
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "circle",
            label: name,
            size: "xsmall",
            src: iconUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, name), isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $299x2.default).defaultPriority)))));
};

});
parcelRegister("299x2", function(module, exports) {

$parcel$export(module.exports, "default", () => $547fb58ab94ae510$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $547fb58ab94ae510$var$messages = (0, $90IgZ.defineMessages)({
    defaultPriority: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.priority-cell.default-priority",
        "defaultMessage": "Default"
    }
});
var $547fb58ab94ae510$export$2e2bcd8739ae039 = $547fb58ab94ae510$var$messages;

});


parcelRegister("42Cwh", function(module, exports) {

$parcel$export(module.exports, "ProjectCell", () => $9a8a0a945e34348d$export$a0acc7707bde1d3);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $1AWkH = parcelRequire("1AWkH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jfj6c = parcelRequire("jfj6c");

var $d2u1V = parcelRequire("d2u1V");
const $9a8a0a945e34348d$var$DISPLAY_LIMIT = 5;
const $9a8a0a945e34348d$var$AddProjectsButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "",
            size: "small"
        }),
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $d2u1V.messages).addProjects));
};
const $9a8a0a945e34348d$var$ProjectCountButton = ({ count: count, isDisabled: isDisabled, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1AWkH))), {
            label: "",
            size: "small"
        }),
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $d2u1V.messages).totalProjectCount, {
        projectCount: count
    }));
};
const $9a8a0a945e34348d$export$a0acc7707bde1d3 = ({ isLocked: isLocked, onClick: onClick, projects: projects, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, totalCount === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a8a0a945e34348d$var$AddProjectsButton, {
        isDisabled: isLocked,
        onClick: onClick
    }), totalCount <= $9a8a0a945e34348d$var$DISPLAY_LIMIT ? projects.map(({ id: id, name: name, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfj6c.CellItem), {
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "square",
            label: name,
            size: "xsmall",
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a8a0a945e34348d$var$ProjectCountButton, {
        count: totalCount,
        isDisabled: isLocked,
        onClick: onClick
    }));

});
parcelRegister("1AWkH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $129666f3a5292f25$var$_react = $129666f3a5292f25$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $129666f3a5292f25$var$_pages = $129666f3a5292f25$var$_interopRequireDefault((parcelRequire("gaxd9")));
function $129666f3a5292f25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $129666f3a5292f25$var$DocumentsIcon = (props)=>/*#__PURE__*/ $129666f3a5292f25$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1zm13-6.99V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.52c0-.3-.13-.58-.36-.77l-5.07-4.24c-.36-.3-.81-.46-1.28-.46H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.99z"/></svg>`
    }, props, {
        newIcon: $129666f3a5292f25$var$_pages.default
    }));
$129666f3a5292f25$var$DocumentsIcon.displayName = 'DocumentsIcon';
var $129666f3a5292f25$var$_default = module.exports.default = $129666f3a5292f25$var$DocumentsIcon;

});
parcelRegister("gaxd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::507ba0a7522eee51c688b0df4f02c52b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc57578ad3be8c9a$var$_react = $bc57578ad3be8c9a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bc57578ad3be8c9a$var$_UNSAFE_baseNew = $bc57578ad3be8c9a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $bc57578ad3be8c9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc57578ad3be8c9a$var$PagesIcon = (props)=>/*#__PURE__*/ $bc57578ad3be8c9a$var$_react.default.createElement($bc57578ad3be8c9a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10 4.75H4m4.5 3H4m-1 4.5h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$bc57578ad3be8c9a$var$PagesIcon.displayName = 'PagesIcon';
var $bc57578ad3be8c9a$var$_default = module.exports.default = $bc57578ad3be8c9a$var$PagesIcon;

});


parcelRegister("d2u1V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fe7e0c7825980bb2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $fe7e0c7825980bb2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    addProjects: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.project-cell.add-projects",
        "defaultMessage": "Add projects"
    },
    totalProjectCount: {
        "id": "admin-pages-priority-schemes.priority-schemes-table.project-cell.total-project-count",
        "defaultMessage": "{projectCount, plural, one {# project} other {# projects}}"
    }
});

});







//# sourceMappingURL=async-admin-pages-priority-schemes.b13edf4d.js.map
